import { c as n, b as e, o as r, a as t } from "./vue.runtime.esm-bundler-CT4BZx-H.js";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c(a, l) {
  return r(), n("svg", o, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.136 10.148a.75.75 0 0 1-.014 1.06l-5.021 4.89a.75.75 0 0 1-1.047-1.074l5.02-4.89a.75.75 0 0 1 1.062.014",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.04 10.148a.75.75 0 0 1 1.06-.014l5.022 4.89a.75.75 0 1 1-1.047 1.075l-5.02-4.89a.75.75 0 0 1-.015-1.061",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.604 4.982a.75.75 0 0 1 .75-.75h7.734c1.792 0 3.546.518 5.039 1.489a8.92 8.92 0 0 1 3.352 3.977 8.68 8.68 0 0 1 .523 5.133 8.8 8.8 0 0 1-2.488 4.546 9.16 9.16 0 0 1-4.644 2.426 9.3 9.3 0 0 1-5.239-.495 9.05 9.05 0 0 1-4.084-3.253A8.72 8.72 0 0 1 3 13.125a.75.75 0 1 1 1.5-.004 7.22 7.22 0 0 0 1.282 4.083 7.55 7.55 0 0 0 3.408 2.712 7.8 7.8 0 0 0 4.393.415 7.66 7.66 0 0 0 3.883-2.028 7.3 7.3 0 0 0 2.066-3.771 7.18 7.18 0 0 0-.433-4.247 7.42 7.42 0 0 0-2.79-3.307 7.75 7.75 0 0 0-4.221-1.246H4.354a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.817 2.227a.75.75 0 0 1-.014 1.06l-1.75 1.705L6.803 6.7a.75.75 0 0 1-1.047 1.073L3.455 5.53a.75.75 0 0 1 0-1.075l2.301-2.241a.75.75 0 0 1 1.06.014",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const L8 = { render: c }, i = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d(a, l) {
  return r(), n("svg", i, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.156 5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5m0-1.5a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5m9.14 4.416a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25v-2.25a.75.75 0 0 1 .75-.75m-5.434 6.01a5.1 5.1 0 0 0-1.623-.26H7.066c-1.112 0-2.202.357-3.027 1.026-.828.672-1.335 1.622-1.335 2.655v2.237a.75.75 0 0 0 1.5 0v-2.237c0-.522.255-1.063.78-1.49.531-.43 1.278-.691 2.082-.691h4.175c.395 0 .785.062 1.145.182.36.121.678.295.94.507s.458.455.589.71.193.52.193.782v2.237a.75.75 0 0 0 1.5 0v-2.237a3.2 3.2 0 0 0-.358-1.464 3.7 3.7 0 0 0-.98-1.193c-.41-.333-.89-.59-1.408-.764",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A8 = { render: d }, h = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s(a, l) {
  return r(), n("svg", h, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.901 17.631a.75.75 0 0 0-.964-1.15L9.01 18.1a2.75 2.75 0 1 1-3.535-4.213l1.927-1.617 1.603-1.346a2.75 2.75 0 0 1 3.875.339.75.75 0 1 0 1.149-.964 4.25 4.25 0 0 0-5.988-.524L6.437 11.12 4.51 12.737a4.25 4.25 0 1 0 5.464 6.511zM12.1 6.369a.75.75 0 1 0 .964 1.149l1.927-1.617a2.75 2.75 0 1 1 3.536 4.213l-1.927 1.617-1.604 1.346a2.75 2.75 0 0 1-3.875-.339.75.75 0 0 0-1.149.964 4.25 4.25 0 0 0 5.988.524l1.604-1.346 1.927-1.617a4.25 4.25 0 1 0-5.464-6.511z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y8 = { render: s }, v = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u(a, l) {
  return r(), n("svg", v, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.469 4.242a.75.75 0 1 0-1.5 0v.969H3.78a.75.75 0 1 0 0 1.5H7.97v1.031a.75.75 0 0 0 1.5 0zM11.5 5.961a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75m5.563 7.781v-.992h3.218a.75.75 0 1 0 0-1.5h-3.218v-1.008a.75.75 0 1 0-1.5 0v3.5a.75.75 0 0 0 1.5 0M3.78 11.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 1 0 0-1.5zm6.313 6.766a.75.75 0 0 1 .75-.75h9.437a.75.75 0 1 1 0 1.5h-9.437a.75.75 0 0 1-.75-.75m-7.063 0a.75.75 0 0 1 .75-.75h3.313v-1.008a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0v-.992H3.78a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const k8 = { render: u }, m = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w(a, l) {
  return r(), n("svg", m, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.75 2.749a.75.75 0 0 0-1.5 0v1.035a8.25 8.25 0 0 0-7.466 7.463H2.742a.75.75 0 0 0 0 1.5h1.041a8.25 8.25 0 0 0 7.467 7.47v1.038a.75.75 0 0 0 1.5 0v-1.039a8.25 8.25 0 0 0 7.467-7.47h1.03a.75.75 0 1 0 0-1.5h-1.03a8.25 8.25 0 0 0-7.467-7.462zm-6.008 9.998H5.291a6.75 6.75 0 0 0 5.959 5.962v-1.454a.75.75 0 0 1 1.5 0v1.454a6.75 6.75 0 0 0 5.96-5.962h-1.462a.75.75 0 1 1 0-1.5h1.46A6.75 6.75 0 0 0 12.75 5.29V6.75a.75.75 0 0 1-1.5 0V5.291a6.75 6.75 0 0 0-5.958 5.956h1.45a.75.75 0 0 1 0 1.5m5.253.755a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const S8 = { render: w }, f = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z(a, l) {
  return r(), n("svg", f, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.294 21.013h-2.56v-1.5h2.56a2.25 2.25 0 0 0 2.25-2.25v-2.781h1.5v2.78a3.75 3.75 0 0 1-3.75 3.75m3.75-11.531V6.688a3.75 3.75 0 0 0-3.75-3.75h-2.56v1.5h2.56a2.25 2.25 0 0 1 2.25 2.25v2.794zM6.72 4.438h3.015v-1.5H6.72a3.75 3.75 0 0 0-3.75 3.75v2.794h1.5V6.688a2.25 2.25 0 0 1 2.25-2.25m-2.25 10.044h-1.5v2.78a3.75 3.75 0 0 0 3.75 3.75h3.015v-1.5H6.72a2.25 2.25 0 0 1-2.25-2.25zm10.843-3.42a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.313 4.35a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-7.25-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D8 = { render: z }, g = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p(a, l) {
  return r(), n("svg", g, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.016 5c-5.553 0-8.629 4.405-9.663 6.226a1.55 1.55 0 0 0 0 1.548C3.387 14.594 6.463 19 12.016 19c5.56 0 8.615-4.416 9.638-6.233a1.55 1.55 0 0 0 0-1.534C20.63 9.416 17.575 5 12.016 5m-8.358 6.967C4.645 10.229 7.334 6.5 12.016 6.5c4.684 0 7.355 3.735 8.33 5.468.01.018.01.028.01.032s0 .014-.01.032c-.975 1.733-3.646 5.468-8.33 5.468-4.682 0-7.371-3.73-8.358-5.467A.1.1 0 0 1 3.647 12c0-.004 0-.015.01-.033",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const F8 = { render: p }, M = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x(a, l) {
  return r(), n("svg", M, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.64 5.375c1.807 0 3.089.002 4.06.129.953.124 1.494.357 1.886.739.389.378.624.896.751 1.813.13.941.132 2.184.132 3.944s-.002 3.003-.132 3.944c-.127.917-.362 1.435-.751 1.813-.392.382-.933.615-1.885.74-.972.127-2.254.128-4.061.128h-2.43c-1.041 0-1.77 0-2.349-.055-.562-.052-.924-.15-1.233-.317-.308-.166-.584-.41-.925-.844-.352-.447-.738-1.046-1.29-1.906l-.627-.977c-.467-.726-.784-1.222-.991-1.634-.2-.396-.264-.654-.264-.892s.065-.496.264-.892c.207-.412.524-.908.99-1.634l.628-.977c.552-.86.938-1.46 1.29-1.906.341-.433.617-.678.925-.844s.67-.265 1.233-.317c.578-.054 1.308-.055 2.348-.055zm6.992-.207c-.718-.7-1.625-1.006-2.737-1.152-1.08-.141-2.46-.141-4.2-.141h-2.522c-.996 0-1.795 0-2.45.061-.68.063-1.259.195-1.807.491-.55.296-.974.707-1.391 1.236-.402.51-.827 1.171-1.354 1.992l-.669 1.042c-.44.684-.8 1.247-1.048 1.738-.258.514-.423 1.01-.423 1.565s.165 1.05.423 1.565c.247.492.609 1.054 1.048 1.738l.67 1.042c.526.821.95 1.482 1.353 1.992.417.53.841.94 1.39 1.236.55.296 1.129.428 1.807.491.656.061 1.455.061 2.451.061h2.522c1.74 0 3.12 0 4.2-.141 1.112-.146 2.019-.453 2.737-1.152.721-.701 1.04-1.592 1.191-2.683.146-1.056.146-2.402.146-4.092v-.114c0-1.69 0-3.036-.146-4.092-.15-1.091-.47-1.982-1.191-2.683M11.03 8.97a.75.75 0 0 0-1.06 1.06L11.94 12l-1.97 1.97a.75.75 0 1 0 1.06 1.06L13 13.06l1.97 1.97a.75.75 0 0 0 1.06-1.06L14.06 12l1.97-1.97a.75.75 0 0 0-1.06-1.06L13 10.94z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const T8 = { render: x }, _ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $(a, l) {
  return r(), n("svg", _, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.812 3.094A5.75 5.75 0 0 0 4.5 12.647v2.025A7.25 7.25 0 1 1 14.618 4.5H12.58a5.73 5.73 0 0 0-3.768-1.406m-1.03 2.918a1.75 1.75 0 0 0-1.75 1.75v9c0 .966.783 1.75 1.75 1.75h2.1l.005-.028.013-.047c.071-.271.211-.515.406-.71l.708-.715H7.78a.25.25 0 0 1-.25-.25v-9a.25.25 0 0 1 .25-.25h9a.25.25 0 0 1 .25.25v3.17l.91-.918a2.5 2.5 0 0 1 .59-.443V7.762a1.75 1.75 0 0 0-1.75-1.75zm12.679 5.38a1.063 1.063 0 0 0-1.51-.014l-.634.634 2.673 2.674.62-.619c.407-.41.4-1.082-.003-1.496zm-.744 4.567-2.673-2.673-5.298 5.297a.45.45 0 0 0-.114.19l-.573 2.646v.012c0 .127 0 .328.116.443.111.11.266.109.421.108h.034l2.608-.615a.45.45 0 0 0 .183-.111z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b8 = { render: $ }, C = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H(a, l) {
  return r(), n("svg", C, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M3.755 9.746a.75.75 0 0 1-.75-.75V3.75a.75.75 0 0 1 .75-.75h5.243a.75.75 0 1 1 0 1.5H5.565l3.966 3.965a.75.75 0 1 1-1.061 1.06L4.505 5.562v3.435a.75.75 0 0 1-.75.75M21.013 15.012a.75.75 0 0 0-1.5 0v3.432l-3.963-3.962a.75.75 0 0 0-1.06 1.06l3.965 3.966H15.02a.75.75 0 0 0 0 1.5h5.243a.75.75 0 0 0 .75-.75zM12 13.493a1.493 1.493 0 1 0 0-2.986 1.493 1.493 0 0 0 0 2.986M13.005 3.001a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM16.005 3.501a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM20.005 3.001a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM20.005 11.501a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5zM19.505 7.501a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5zM11.505 20.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V20a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zM4.005 21a.5.5 0 0 0 .5-.5V20a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5zM8.005 20.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V20a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zM4.512 13a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zM4.012 16a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5z"
    }, null, -1)
  ]));
}
const E8 = { render: H }, V = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I(a, l) {
  return r(), n("svg", V, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.015 2.243a.75.75 0 0 1 .528-.217H16.4a.75.75 0 0 1 .75.75v15.473a.75.75 0 0 1-.75.75H4.508a.75.75 0 0 1-.75-.75V5.778c0-.2.08-.393.223-.533zm.836 1.283L5.258 6.09v11.408h10.393V3.526z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.4 6.173a.75.75 0 0 1 .75-.75h2.342a.75.75 0 0 1 .75.75V21.24a.75.75 0 0 1-.75.75H7.598a.75.75 0 0 1-.75-.75v-2.68a.75.75 0 0 1 1.5 0v1.93h10.392V6.923h-1.59a.75.75 0 0 1-.75-.75M7.838 2.01a.75.75 0 0 1 .75.75v3.285a.75.75 0 0 1-.75.75h-2.86a.75.75 0 0 1 0-1.5h2.11V2.76a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.787 10.35a.75.75 0 0 1 .75-.75h5.861a.75.75 0 1 1 0 1.5H7.537a.75.75 0 0 1-.75-.75M6.787 13.362a.75.75 0 0 1 .75-.75h5.861a.75.75 0 1 1 0 1.5H7.537a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const B8 = { render: I }, q = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L(a, l) {
  return r(), n("svg", q, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.25 3.25c.966 0 1.75.784 1.75 1.75v13.994c0 1.033-1.181 1.62-2.005.997l-4.844-3.67a.25.25 0 0 0-.302 0l-4.844 3.67C6.18 20.614 5 20.027 5 18.994V5c0-.966.784-1.75 1.75-1.75zM17.5 5a.25.25 0 0 0-.25-.25H6.75A.25.25 0 0 0 6.5 5v13.491l4.443-3.365a1.75 1.75 0 0 1 2.114 0L17.5 18.49z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const P8 = { render: L }, A = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y(a, l) {
  return r(), n("svg", A, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3.031h-.05c-1.843 0-3.293 0-4.426.132-1.154.134-2.092.414-2.843 1.062-.766.661-1.113 1.513-1.276 2.558-.155.998-.155 2.267-.155 3.841v.166c0 1.536 0 2.616.16 3.426.184.923.577 1.522 1.271 2.122.75.647 1.69.928 2.843 1.062 1.133.131 2.583.131 4.427.131h.099c1.843 0 3.293 0 4.426-.131 1.154-.134 2.092-.415 2.843-1.062.694-.6 1.087-1.199 1.27-2.122.161-.81.161-1.89.161-3.426v-.166c0-1.574 0-2.843-.155-3.84-.163-1.046-.51-1.898-1.276-2.56-.75-.647-1.69-.927-2.843-1.061-1.133-.132-2.583-.132-4.426-.132zm-6.338 2.33c.421-.364 1.011-.59 2.035-.708 1.036-.12 2.399-.122 4.303-.122s3.267.001 4.303.122c1.024.119 1.614.344 2.035.707.406.35.644.819.774 1.654.136.87.138 2.021.138 3.673 0 1.666-.004 2.59-.132 3.237q-.03.156-.072.289l-2.084-1.875a3.086 3.086 0 0 0-3.838-.231l-.232.163a.81.81 0 0 1-1.035-.09l-3.34-3.34a2.54 2.54 0 0 0-3.469-.115l-.29.253c.014-.794.047-1.432.13-1.964.13-.835.368-1.304.774-1.654m-.912 5.618c0 1.484.011 2.338.132 2.945.11.552.303.867.78 1.278.421.364 1.011.589 2.035.708 1.036.12 2.399.121 4.303.121s3.267 0 4.303-.121c.845-.098 1.394-.269 1.797-.53l-2.142-1.928a1.585 1.585 0 0 0-1.972-.118l-.232.163a2.31 2.31 0 0 1-2.958-.256L7.456 9.9a1.04 1.04 0 0 0-1.42-.047zm11.031-3.92a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m1.188 12.504a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-9.719-.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const R8 = { render: y }, k = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S(a, l) {
  return r(), n("svg", k, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M18.217 2.8c.08-.295.5-.295.58 0L19.28 4.6a.3.3 0 0 0 .212.211l1.798.485c.296.08.296.5 0 .579l-1.799.484a.3.3 0 0 0-.211.212l-.484 1.798c-.08.296-.5.296-.58 0l-.484-1.798a.3.3 0 0 0-.212-.212l-1.798-.484c-.296-.08-.296-.5 0-.58l1.798-.484a.3.3 0 0 0 .212-.211z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.367 3.393c.263.351.346.852.134 1.31a7.331 7.331 0 0 0 8.222 10.239c.493-.107.964.083 1.25.416.298.347.42.887.129 1.383a9.453 9.453 0 0 1-17.614-4.773 9.46 9.46 0 0 1 6.557-9.001 1.18 1.18 0 0 1 1.322.426M8.912 4.612a7.956 7.956 0 0 0 3.029 15.31 7.94 7.94 0 0 0 6.527-3.41 8.831 8.831 0 0 1-9.556-11.9",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M15.594 8.121c-.08-.296-.5-.296-.58 0l-.275 1.023a.3.3 0 0 1-.212.211l-1.022.276c-.296.08-.296.5 0 .579l1.022.275a.3.3 0 0 1 .212.212l.275 1.022c.08.296.5.296.58 0l.275-1.022a.3.3 0 0 1 .212-.212l1.022-.275c.296-.08.296-.5 0-.58l-1.023-.275a.3.3 0 0 1-.211-.211z"
    }, null, -1)
  ]));
}
const U8 = { render: S }, D = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F(a, l) {
  return r(), n("svg", D, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M10.25 8.125a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.533 2.023c-.685 0-1.307.4-1.592 1.023L6.41 4.21H3.75a.75.75 0 1 0 0 1.5h1.078v7.25a2.75 2.75 0 0 0 2.75 2.75h4a2.75 2.75 0 0 0 2.75-2.75V5.71h.922a.75.75 0 0 0 0-1.5h-2.503l-.532-1.165a1.75 1.75 0 0 0-1.592-1.023zm4.295 3.688h-6.5v7.25c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25zm-1.73-1.5-.247-.542a.25.25 0 0 0-.228-.146h-2.09a.25.25 0 0 0-.227.147l-.248.54z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M18.812 16.75a.75.75 0 0 0-1.061 1.062l.72.72H3.78a.75.75 0 0 0 0 1.5h14.69l-.72.719a.75.75 0 0 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06z"
    }, null, -1)
  ]));
}
const O8 = { render: F }, T = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b(a, l) {
  return r(), n("svg", T, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M13.766 8.098a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.483 1.996c.684 0 1.306.4 1.591 1.023l.533 1.165h2.659a.75.75 0 0 1 0 1.5h-1.078v7.25a2.75 2.75 0 0 1-2.75 2.75h-4a2.75 2.75 0 0 1-2.75-2.75v-7.25h-.922a.75.75 0 1 1 0-1.5h2.502l.533-1.165a1.75 1.75 0 0 1 1.591-1.023zm-4.296 3.688h6.5v7.25c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25zm1.73-1.5.248-.542a.25.25 0 0 1 .227-.146h2.09a.25.25 0 0 1 .228.146l.247.542z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M5.204 16.724a.75.75 0 0 1 1.06 1.06l-.719.72h14.69a.75.75 0 0 1 0 1.5H5.544l.72.72a.75.75 0 1 1-1.061 1.06l-2-2a.75.75 0 0 1 0-1.06z"
    }, null, -1)
  ]));
}
const G8 = { render: b }, E = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B(a, l) {
  return r(), n("svg", E, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 19.503h14a.5.5 0 0 0 .5-.5v-14a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5m14 1.5H5a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.75 12.753H3.25v-1.5h17.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const N8 = { render: B }, P = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R(a, l) {
  return r(), n("svg", P, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.834 11.25a.75.75 0 0 0 0 1.5h2.645v1.184c0 .615.322 1.184.85 1.5l3.039 2.424a2.75 2.75 0 0 0 1.415.392h9.446a2.75 2.75 0 0 0 2.75-2.75v-7a2.75 2.75 0 0 0-2.75-2.75H9.783a2.75 2.75 0 0 0-1.415.392l-3.04 2.424a1.75 1.75 0 0 0-.85 1.5v1.184zm4.145 1.5v1.184c0 .088.046.169.121.214l3.04 2.424c.194.116.416.178.643.178h9.446c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H9.783a1.25 1.25 0 0 0-.643.178L6.1 9.852a.25.25 0 0 0-.121.214v1.184h2.924a2 2 0 1 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Q8 = { render: R }, U = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O(a, l) {
  return r(), n("svg", U, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.012 7.913a.75.75 0 0 1 .75-.75h6.096a.75.75 0 0 1 0 1.5H6.762a.75.75 0 0 1-.75-.75M6.012 10.695a.75.75 0 0 1 .75-.75h10.482a.75.75 0 0 1 0 1.5H6.762a.75.75 0 0 1-.75-.75M6.012 13.746a.75.75 0 0 1 .75-.75h10.482a.75.75 0 0 1 0 1.5H6.762a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.214 16.905a1.29 1.29 0 0 0 1.291-1.29V5.794a1.29 1.29 0 0 0-1.291-1.29H5.794a1.29 1.29 0 0 0-1.292 1.29v9.823a1.29 1.29 0 0 0 1.292 1.29H8.14a1.5 1.5 0 0 1 1.5 1.5v.272l2.412-1.538a1.5 1.5 0 0 1 .806-.235zm-9.305 4.018a.5.5 0 0 1-.769-.421v-2.097H5.796a2.79 2.79 0 0 1-2.794-2.79V5.794a2.79 2.79 0 0 1 2.794-2.79h12.416a2.79 2.79 0 0 1 2.793 2.79v9.823a2.79 2.79 0 0 1-2.793 2.79h-5.354z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z8 = { render: O }, G = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N(a, l) {
  return r(), n("svg", G, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.786 4.5h6.75v15h-6.75a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5m14 0h-5.75v6.813h6.25V5a.5.5 0 0 0-.5-.5m.5 8.313V19a.5.5 0 0 1-.5.5h-5.75v-6.687zM18.786 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const W8 = { render: N }, Q = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z(a, l) {
  return r(), n("svg", Q, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M11.105 11.814v-.352a1.6 1.6 0 0 1 .195-.79c.184-.285.423-.53.704-.72.249-.157.471-.353.658-.58a.83.83 0 0 0 .157-.489.53.53 0 0 0-.227-.484 1.1 1.1 0 0 0-.634-.162 3.6 3.6 0 0 0-1.623.501l-.521-1.043a4.5 4.5 0 0 1 2.248-.613c.559-.023 1.109.148 1.556.485a1.55 1.55 0 0 1 .576 1.242 1.7 1.7 0 0 1-.245.87 3.4 3.4 0 0 1-.906.848 3 3 0 0 0-.555.517.8.8 0 0 0-.12.464v.282zm-.149 1.623a.8.8 0 0 1 .216-.604.83.83 0 0 1 .616-.178.83.83 0 0 1 .613.207.93.93 0 0 1 0 1.192.83.83 0 0 1-.608.215.83.83 0 0 1-.613-.21.78.78 0 0 1-.224-.622"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.464 7.764c-.4-.3-.892-.453-1.392-.432h-.01a4.25 4.25 0 0 0-1.917.467l.298.595a3.9 3.9 0 0 1 1.5-.406h.002c.273-.014.544.055.777.198l.011.007a.78.78 0 0 1 .336.7 1.08 1.08 0 0 1-.205.625l-.004.007-.005.006a3 3 0 0 1-.714.63c-.249.17-.461.386-.626.639a1.34 1.34 0 0 0-.16.658v.101l.763-.015v-.03c-.01-.212.045-.423.159-.603l.008-.014.01-.012q.266-.319.602-.561l.01-.008c.323-.206.606-.47.834-.777.131-.221.201-.474.203-.732v-.004a1.3 1.3 0 0 0-.48-1.04m-1.408-.932a2.67 2.67 0 0 1 1.713.535l.007.005a1.8 1.8 0 0 1 .668 1.44c-.003.351-.1.695-.28.995l-.006.01-.007.01a3.7 3.7 0 0 1-.967.907 2.7 2.7 0 0 0-.492.457.54.54 0 0 0-.074.303v.541l-1.763.034v-.604a1.84 1.84 0 0 1 .226-.913l.004-.008.005-.008c.202-.313.465-.582.773-.791l.008-.005a2.5 2.5 0 0 0 .593-.52.58.58 0 0 0 .105-.336v-.012l.001-.011a.28.28 0 0 0-.115-.253.85.85 0 0 0-.483-.12 3.4 3.4 0 0 0-1.509.465l-.231.138-.747-1.494.203-.118a4.75 4.75 0 0 1 2.368-.647m-.297 6.071a.58.58 0 0 0-.417.114.55.55 0 0 0-.136.402l-.25.018.25.023a.53.53 0 0 0 .146.417.58.58 0 0 0 .423.143l.016-.001h.017a.58.58 0 0 0 .412-.139.68.68 0 0 0 .001-.843.57.57 0 0 0-.414-.133l-.024.002zm-1.053.532a1.04 1.04 0 0 1 .284-.774l.011-.012.014-.01a1.08 1.08 0 0 1 .779-.235 1.08 1.08 0 0 1 .773.27l.014.013.012.014a1.18 1.18 0 0 1 0 1.514l-.011.012-.012.011a1.08 1.08 0 0 1-.776.282 1.08 1.08 0 0 1-.782-.276l-.01-.01a1.03 1.03 0 0 1-.296-.8",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.214 16.905a1.29 1.29 0 0 0 1.291-1.29V5.794a1.29 1.29 0 0 0-1.291-1.29H5.794a1.29 1.29 0 0 0-1.292 1.29v9.823a1.29 1.29 0 0 0 1.292 1.29H8.14a1.5 1.5 0 0 1 1.5 1.5v.272l2.412-1.538a1.5 1.5 0 0 1 .806-.235zm-9.305 4.018a.5.5 0 0 1-.769-.421v-2.097H5.796a2.79 2.79 0 0 1-2.794-2.79V5.794a2.79 2.79 0 0 1 2.794-2.79h12.416a2.79 2.79 0 0 1 2.793 2.79v9.823a2.79 2.79 0 0 1-2.793 2.79h-5.354z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const j8 = { render: Z }, W = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j(a, l) {
  return r(), n("svg", W, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M9.969 10.563a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75M14.719 11.313a.75.75 0 0 0-1.5 0v4.5a.75.75 0 1 0 1.5 0z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m8.333 6 .319-1.434A2 2 0 0 1 10.604 3h2.792a2 2 0 0 1 1.952 1.566L15.667 6h3.583a.75.75 0 0 1 0 1.5h-1v10.844a2.75 2.75 0 0 1-2.75 2.75h-7a2.75 2.75 0 0 1-2.75-2.75V7.5h-1a.75.75 0 0 1 0-1.5zm2.271-1.5h2.792a.5.5 0 0 1 .488.392L14.13 6H9.87l.246-1.108a.5.5 0 0 1 .488-.392M7.25 7.531v10.813c0 .69.56 1.25 1.25 1.25h7c.69 0 1.25-.56 1.25-1.25V7.53z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K8 = { render: j }, K = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J(a, l) {
  return r(), n("svg", K, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.887 2.581a.75.75 0 0 1 .803-.036L19.977 11.3a.75.75 0 0 1-.185 1.377l-7.477 1.933-4.343 6.413a.75.75 0 0 1-1.36-.292L3.58 3.324a.75.75 0 0 1 .308-.743M5.331 4.64l2.44 14.006 3.46-5.11a.75.75 0 0 1 .434-.306l5.968-1.543z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J8 = { render: J }, X = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y(a, l) {
  return r(), n("svg", X, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14 5.486a2 2 0 1 1-4 0 2 2 0 0 1 4 0m.392 2.555a3.5 3.5 0 1 0-4.762.02l-5.12.32a1.17 1.17 0 0 0-1.096 1.167v1.168c0 .556.39 1.035.935 1.147l4.259.87.073.31-1.174 8.344a.75.75 0 0 0 .743.855h1.625a.75.75 0 0 0 .69-.457l1.359-3.202 1.32 3.203a.75.75 0 0 0 .694.464h1.671a.75.75 0 0 0 .742-.86l-1.242-8.315.1-.328 4.436-.883a1.17 1.17 0 0 0 .941-1.148V9.548a1.17 1.17 0 0 0-1.092-1.167zM11.53 9.493l.827-.007 1.29.009 5.438.362v.588l-4.61.919a.75.75 0 0 0-.572.517l-.28.919a.75.75 0 0 0-.024.329l1.139 7.621h-.3l-1.812-4.396a.75.75 0 0 0-1.384-.007l-1.865 4.395h-.265l1.074-7.63a.8.8 0 0 0-.013-.279l-.218-.912a.75.75 0 0 0-.579-.562l-4.463-.912v-.589l5.298-.33z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X8 = { render: Y }, l0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e0(a, l) {
  return r(), n("svg", l0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.406 8.125a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1.5a3.5 3.5 0 1 0-3.378-2.58L9.357 9.85a3.5 3.5 0 1 0-.09 4.408l4.75 2.743q-.11.42-.11.873a3.5 3.5 0 1 0 .788-2.213l-4.727-2.73a3.5 3.5 0 0 0 .037-1.72l4.72-2.836a3.5 3.5 0 0 0 2.681 1.249M6.594 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m12.812 3.875a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y8 = { render: e0 }, n0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r0(a, l) {
  return r(), n("svg", n0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.754 3.496a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zM12.254 5.748a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.772 11.393a.75.75 0 0 0 0 1.218l6.043 4.344a.75.75 0 0 0 1.188-.61V7.66a.75.75 0 0 0-1.188-.61zm1.723.61 4.008-2.882v5.762zM1.994 16.346a.75.75 0 0 0 1.188.609l6.043-4.344a.75.75 0 0 0 0-1.218L3.182 7.05a.75.75 0 0 0-1.188.609zm5.508-4.344-4.008 2.881V9.121z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M12.754 11.75a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zM12.254 14.001a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5zM12.754 17.252a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zM12.254 19.504a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5zM12.754 8.999a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5z"
    }, null, -1)
  ]));
}
const l9 = { render: r0 }, a0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t0(a, l) {
  return r(), n("svg", a0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.043 4.008h12.02a.5.5 0 0 1 .5.5v4.485a7 7 0 0 1 1.5.184V4.508a2 2 0 0 0-2-2H4.043a2 2 0 0 0-2 2v13.063a2 2 0 0 0 2 2h6.396a7 7 0 0 1-.669-1.5H4.043a.5.5 0 0 1-.5-.5V4.508a.5.5 0 0 1 .5-.5m2.266 6.219h6.176a7 7 0 0 0-1.58 1.5H6.31a.75.75 0 0 1 0-1.5m0-3.5a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm-.75 7.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m16.397 1.515a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.018.52a.75.75 0 0 1-.22-.53v-2.736a.75.75 0 1 1 1.5 0v2.426l1.78 1.779a.75.75 0 1 1-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const e9 = { render: t0 }, o0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c0(a, l) {
  return r(), n("svg", o0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 3h3v.685h10.487V3h3v3h-.737v1.727a8 8 0 0 0-1.5-.574V6h-.764v-.815H6V6h-.75v10.377H6v.808h1.496q.239.789.625 1.5H6v.692H3v-3h.75V6H3zm11.408 6.492a.75.75 0 0 0 1.5 0v-1a.75.75 0 0 0-1.5 0zm-1.5 5.385a2.25 2.25 0 0 1 2.25-2.25v4.5a2.25 2.25 0 0 1-2.25-2.25m2.25-3.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m6.877 3.75a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 .75.75m-12.262.75a.75.75 0 1 0 0-1.5H8.759a.75.75 0 0 0 0 1.5zM15.158 22a.75.75 0 0 1-.75-.75v-.987a.75.75 0 1 1 1.5 0v.987a.75.75 0 0 1-.75.75m-5.05-2.073a.75.75 0 0 1 0-1.06l.712-.712a.75.75 0 0 1 1.06 1.06l-.711.712a.75.75 0 0 1-1.06 0m8.328-9.388a.75.75 0 0 0 1.06 1.06l.708-.707a.75.75 0 0 0-1.06-1.06zm-8.325-.71a.75.75 0 0 1 1.06 0l.71.71a.75.75 0 0 1-1.061 1.06l-.71-.71a.75.75 0 0 1 0-1.06m9.386 8.326a.75.75 0 1 0-1.06 1.06l.706.708a.75.75 0 1 0 1.061-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const n9 = { render: c0 }, i0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d0(a, l) {
  return r(), n("svg", i0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 4.5h-6.75v15H19a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5m-14 0h5.75v6.813H4.5V5a.5.5 0 0 1 .5-.5m-.5 8.313V19a.5.5 0 0 0 .5.5h5.75v-6.687zM5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const r9 = { render: d0 }, h0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s0(a, l) {
  return r(), n("svg", h0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.253 2.998h-.042c-1.37 0-2.454 0-3.32.088-.888.09-1.63.279-2.277.712a4.8 4.8 0 0 0-1.311 1.31c-.433.649-.622 1.39-.712 2.278-.088.866-.088 1.95-.088 3.32v.083c0 1.37 0 2.454.088 3.32.09.888.279 1.63.712 2.278.347.518.792.963 1.31 1.31.649.433 1.39.622 2.277.712.703.072 1.55.085 2.575.088l.222-1.152q.054-.18.135-.348c-1.197 0-2.08-.009-2.78-.08-.769-.078-1.234-.226-1.595-.467a3.3 3.3 0 0 1-.897-.897c-.24-.36-.389-.826-.467-1.595-.05-.494-.07-1.078-.076-1.799l1.098-1.04a1.25 1.25 0 0 1 1.736.018l3.09 3.043a2.22 2.22 0 0 0 1.915.607l2.303-2.303a2.95 2.95 0 0 0-2.205.667.716.716 0 0 1-.96-.04l-3.09-3.043a2.75 2.75 0 0 0-3.82-.037l-.071.066c.002-1.086.013-1.903.08-2.56.078-.769.226-1.234.467-1.595a3.3 3.3 0 0 1 .897-.897c.36-.24.826-.389 1.595-.467.782-.08 1.79-.08 3.21-.08h2c1.42 0 2.43 0 3.21.08.77.078 1.236.226 1.596.467.355.237.66.542.897.897.24.36.389.826.467 1.595.033.326.053.692.064 1.11a3 3 0 0 1 1.5-.05 17 17 0 0 0-.072-1.211c-.09-.888-.279-1.63-.712-2.277a4.8 4.8 0 0 0-1.31-1.31c-.649-.434-1.39-.623-2.277-.713-.867-.088-1.952-.088-3.32-.088h-2.043M14.22 7.06a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7.826 2.853a1.06 1.06 0 0 0-1.51-.015l-.635.635 2.674 2.673.619-.619c.408-.409.4-1.082-.003-1.496zm-.744 4.566-2.674-2.673-5.297 5.297a.45.45 0 0 0-.114.19l-.574 2.647v.011c0 .127 0 .328.116.443.112.11.267.109.422.108h.034l2.608-.614a.45.45 0 0 0 .183-.112zM4.723 20.19a.75.75 0 1 0-.009 1.5l4.688.029.009-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a9 = { render: s0 }, v0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u0(a, l) {
  return r(), n("svg", v0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.84 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5zm7.14 16.051A6.5 6.5 0 1 1 11.34 7.5v6.41zM11.34 6a8 8 0 1 1 0 16 8 8 0 0 1 0-16m7.407-1.414a.5.5 0 0 0-.708 0l-1.06 1.06a.5.5 0 0 0 0 .708l1.768 1.767a.5.5 0 0 0 .707 0l1.06-1.06a.5.5 0 0 0 0-.707z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const t9 = { render: u0 }, m0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w0(a, l) {
  return r(), n("svg", m0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.707 17.67H5.44c-1.032 0-1.937-.287-2.572-.976-.625-.678-.874-1.622-.874-2.69v-6.85c0-1.067.249-2.007.882-2.68.642-.68 1.553-.955 2.587-.955h11.082c1.035 0 1.945.275 2.587.956.634.672.883 1.612.883 2.68v3.591a5.5 5.5 0 1 1-8.31 6.924M3.495 7.155c0-.362.036-.66.097-.907l3.444 4.106L3.55 14.71a4 4 0 0 1-.055-.707zM4.44 16l3.579-4.474.394.47c.33.396.73.718 1.181.942a3.24 3.24 0 0 0 1.682.333 5.523 5.523 0 0 0-.142 2.9H5.441c-.424 0-.75-.065-1-.171m14.076-6.14V7.155c0-.335-.031-.615-.084-.85l-2.71 3.231a5.55 5.55 0 0 1 2.794.324m-1.97-4.84c.37 0 .666.045.902.123l-4.94 5.89v.001a2.2 2.2 0 0 1-.697.56 1.74 1.74 0 0 1-.775.186 1.74 1.74 0 0 1-.776-.186 2.2 2.2 0 0 1-.696-.56L4.61 5.128c.228-.069.509-.109.854-.109zm2.61 7.31a.75.75 0 0 1 0 1.06l-1.662 1.663 1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.591-1.59-1.519 1.518a.75.75 0 0 1-1.06-1.06l1.518-1.519-1.59-1.59a.75.75 0 0 1 1.06-1.062l1.59 1.591 1.664-1.663a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const o9 = { render: w0 }, f0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z0(a, l) {
  return r(), n("svg", f0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M19.487 8.328a.75.75 0 1 0 1.5 0V3.775a.75.75 0 0 0-.75-.75H15.72a.75.75 0 1 0 0 1.5H18.4L3.22 19.705a.75.75 0 1 0 1.06 1.062L19.487 5.56z"
    }, null, -1)
  ]));
}
const c9 = { render: z0 }, g0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p0(a, l) {
  return r(), n("svg", g0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M7 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i9 = { render: p0 }, M0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x0(a, l) {
  return r(), n("svg", M0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.657 2a.75.75 0 0 0-.61 1.187l4.344 6.043a.75.75 0 0 0 1.218 0l4.344-6.043a.75.75 0 0 0-.61-1.188zM12 7.506 9.12 3.5h5.76zM12.609 14.777a.75.75 0 0 0-1.218 0l-4.343 6.044a.75.75 0 0 0 .609 1.187h8.686a.75.75 0 0 0 .61-1.187zM12 16.5l2.88 4.008H9.12z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M11.754 11.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM14.005 11.75a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM17.256 11.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM19.507 11.75a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM9.002 11.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM5.751 11.75a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM3.5 11.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5H4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z"
    }, null, -1)
  ]));
}
const d9 = { render: x0 }, _0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $0(a, l) {
  return r(), n("svg", _0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 19.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const h9 = { render: $0 }, C0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H0(a, l) {
  return r(), n("svg", C0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M10.234 13.75a.75.75 0 0 0 1.5 0v-2h2.047a.75.75 0 1 0 0-1.5h-2.047v-2a.75.75 0 0 0-1.5 0v2H8.281a.75.75 0 0 0 0 1.5h1.953z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.164 16.137a8 8 0 1 0-1.067 1.055l3.623 3.622a.75.75 0 1 0 1.06-1.06zM11.031 17.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const s9 = { render: H0 }, V0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I0(a, l) {
  return r(), n("svg", V0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.016 5.135a.75.75 0 0 1 .75-.75H8.38a.75.75 0 0 1 0 1.5H6.516v13.623h11.018V5.885H15.72a.75.75 0 0 1 0-1.5h2.565a.75.75 0 0 1 .75.75v15.123a.75.75 0 0 1-.75.75H5.766a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.897 10.348a.75.75 0 0 1 .75-.75h3.112a.75.75 0 0 1 0 1.5h-3.112a.75.75 0 0 1-.75-.75M10.897 13.652a.75.75 0 0 1 .75-.75h3.112a.75.75 0 0 1 0 1.5h-3.112a.75.75 0 0 1-.75-.75M10.897 16.962a.75.75 0 0 1 .75-.75h3.112a.75.75 0 0 1 0 1.5h-3.112a.75.75 0 0 1-.75-.75M8.492 10.348a.75.75 0 0 1 .75-.75h.016a.75.75 0 0 1 0 1.5h-.016a.75.75 0 0 1-.75-.75M8.492 13.652a.75.75 0 0 1 .75-.75h.016a.75.75 0 0 1 0 1.5h-.016a.75.75 0 0 1-.75-.75M8.492 16.962a.75.75 0 0 1 .75-.75h.016a.75.75 0 0 1 0 1.5h-.016a.75.75 0 0 1-.75-.75M8.129 3.748a.75.75 0 0 1 .75-.75h6.243a.75.75 0 0 1 .75.75v2.768a.75.75 0 0 1-.75.75H8.88a.75.75 0 0 1-.75-.75zm1.5.75v1.268h4.743V4.498z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v9 = { render: I0 }, q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L0(a, l) {
  return r(), n("svg", q0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.252 3.71a.75.75 0 0 0 1.5 0v-.999a.75.75 0 0 0-1.5 0zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5.5-4a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m4.508-.002a.75.75 0 0 1-.75.75h-.999a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 .75.75m-18.262.75a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5zm8.256 9.319a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-.75.75m-7.074-2.994a.75.75 0 0 1 0-1.06l.706-.707a.75.75 0 1 1 1.061 1.06l-.707.707a.75.75 0 0 1-1.06 0M17.31 5.63a.75.75 0 0 0 1.06 1.061l.707-.706a.75.75 0 0 0-1.06-1.061zM4.928 4.924a.75.75 0 0 1 1.06 0l.707.706a.75.75 0 0 1-1.06 1.061l-.707-.706a.75.75 0 0 1 0-1.061M18.37 17.306a.75.75 0 1 0-1.06 1.06l.706.707a.75.75 0 1 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const u9 = { render: L0 }, A0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y0(a, l) {
  return r(), n("svg", A0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.965 7.052a1.5 1.5 0 0 1-1.254-.677L9.82 5.02H6.596a.5.5 0 0 0-.5.5v3.797h11.477a2 2 0 0 1 1.936 1.5l.411 1.595v-4.86a.5.5 0 0 0-.5-.5zm9.455 11.423V7.552a2 2 0 0 0-2-2h-7.455l-1.038-1.581a1 1 0 0 0-.836-.451H6.596a2 2 0 0 0-2 2v3.797h-.015a2 2 0 0 0-1.937 2.499l1.847 7.164a2 2 0 0 0 1.937 1.5H19.42q.102 0 .2-.01a2 2 0 0 0 1.8-1.995M4.58 10.817h12.993a.5.5 0 0 1 .484.375l1.846 7.163a.5.5 0 0 1-.484.625H6.428a.5.5 0 0 1-.485-.375l-1.846-7.164a.5.5 0 0 1 .484-.624",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const m9 = { render: y0 }, k0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S0(a, l) {
  return r(), n("svg", k0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.383 6.606a.75.75 0 0 1 .75.75v8.533l6.847 3.514 6.873-3.515v-8.38a.75.75 0 1 1 1.5 0v8.84a.75.75 0 0 1-.408.667l-7.624 3.898a.75.75 0 0 1-.684 0L4.04 17.015a.75.75 0 0 1-.407-.668V7.356a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.804 3.076a.75.75 0 0 1 .65.01l7.478 3.725a.75.75 0 0 1 .024 1.33l-7.478 4.077a.75.75 0 0 1-.718 0l-7.734-4.22A.75.75 0 0 1 4.07 6.66zM6.05 7.395l6.068 3.31 5.857-3.192-5.869-2.925z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.743 11.56v8.154h-1.5V11.56z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const w9 = { render: S0 }, D0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F0(a, l) {
  return r(), n("svg", D0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.063 4.497H4.043a.5.5 0 0 0-.5.5v14.062a.5.5 0 0 0 .5.5h6.268l-.107 1.22.018.143.001.01.018.127H4.044a2 2 0 0 1-2-2V4.997a2 2 0 0 1 2-2h13.02a2 2 0 0 1 2 2V7.67c-.491.126-.949.402-1.298.823l-.203.244V4.997a.5.5 0 0 0-.5-.5M5.559 7.966a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 3.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 1 0 0-1.5zM20.34 9.73a1.06 1.06 0 0 0-1.506.117l-.577.687 2.897 2.43.563-.67a1.073 1.073 0 0 0-.134-1.49zm-.343 4.614-2.897-2.43-4.816 5.738a.45.45 0 0 0-.096.2l-.341 2.686v.011c.012.127.029.327.155.431.12.1.275.086.43.071l.033-.003 2.544-.84a.45.45 0 0 0 .173-.127z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const f9 = { render: F0 }, T0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b0(a, l) {
  return r(), n("svg", T0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.26 7.371a.75.75 0 0 0 1.06.005l1.947-1.932v10.712a.75.75 0 0 0 1.5 0V5.464l1.91 1.91a.75.75 0 0 0 1.06-1.061l-3.194-3.195a.75.75 0 0 0-1.059-.002L8.264 6.31a.75.75 0 0 0-.004 1.06M3.72 19.375a.75.75 0 0 0 0 1.5H20.28a.75.75 0 1 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const z9 = { render: b0 }, E0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B0(a, l) {
  return r(), n("svg", E0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    }, null, -1)
  ]));
}
const g9 = { render: B0 }, P0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R0(a, l) {
  return r(), n("svg", P0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.32 6.478a.75.75 0 1 1-1.056-1.065l3.22-3.195a.75.75 0 0 1 1.059.002l3.195 3.195a.75.75 0 0 1-1.06 1.06l-1.91-1.91v9.693a.75.75 0 0 1-1.5 0V4.546zM5.72 11.25c0-.69.56-1.25 1.25-1.25h2.484a.75.75 0 0 0 0-1.5H6.969a2.75 2.75 0 0 0-2.75 2.75v8A2.75 2.75 0 0 0 6.969 22H17.03a2.75 2.75 0 0 0 2.75-2.75v-8a2.75 2.75 0 0 0-2.75-2.75h-2.406a.75.75 0 0 0 0 1.5h2.406c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H6.97c-.69 0-1.25-.56-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const p9 = { render: R0 }, U0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O0(a, l) {
  return r(), n("svg", U0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M7.688 3a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0V4.5h5.312v15h-2.062a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5H15.25v-15h5.25v1.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.781-.75H7.687"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M2.813 12a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-.75H5.75v6h-.437a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5H7.25v-6h2.344v.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75H2.813"
    }, null, -1)
  ]));
}
const M9 = { render: O0 }, G0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N0(a, l) {
  return r(), n("svg", G0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.5 19.003v-14a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5m1.5-14v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.75 3.253v17.5h-1.5v-17.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const x9 = { render: N0 }, Q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z0(a, l) {
  return r(), n("svg", Q0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M3.5 5.117a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM9.5 5.117a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM3 11.543a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM9.5 11.043a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM3 17.469a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM9.5 16.969a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
    }, null, -1)
  ]));
}
const _9 = { render: Z0 }, W0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j0(a, l) {
  return r(), n("svg", W0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.782 4.281c0-.966.783-1.75 1.75-1.75h1.724c.966 0 1.75.784 1.75 1.75v12.5a1.75 1.75 0 0 1-1.75 1.75h-1.724a1.75 1.75 0 0 1-1.75-1.75zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.111.25.25.25h1.724a.25.25 0 0 0 .25-.25v-12.5a.25.25 0 0 0-.25-.25zm-6.401 1.5a1.75 1.75 0 0 0-1.75 1.75v9.5c0 .967.783 1.75 1.75 1.75h1.724a1.75 1.75 0 0 0 1.75-1.75v-9.5a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h1.724a.25.25 0 0 1 .25.25v9.5a.25.25 0 0 1-.25.25H11.13a.25.25 0 0 1-.25-.25zM4.73 9.531a1.75 1.75 0 0 0-1.75 1.75v5.5c0 .967.783 1.75 1.75 1.75h1.724a1.75 1.75 0 0 0 1.75-1.75v-5.5a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h1.724a.25.25 0 0 1 .25.25v5.5a.25.25 0 0 1-.25.25H4.73a.25.25 0 0 1-.25-.25zM3.432 19.97a.75.75 0 1 0 0 1.5h17.136a.75.75 0 1 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $9 = { render: j0 }, K0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J0(a, l) {
  return r(), n("svg", K0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.25 7.7c0-3.598 3.059-6.45 6.75-6.45 3.608 0 6.612 2.725 6.745 6.208l.44.147.038.012c.463.154.87.29 1.191.44.348.162.667.37.911.709s.341.707.385 1.088c.04.353.04.78.04 1.269v5.748c0 .61 0 1.13-.047 1.547-.05.438-.161.87-.463 1.237a2.3 2.3 0 0 1-.62.525c-.412.237-.855.276-1.296.253-.42-.022-.932-.107-1.533-.208l-.042-.007c-1.293-.215-1.814-.296-2.322-.254q-.278.023-.552.083c-.498.109-.976.342-2.159.933l-.122.061c-1.383.692-2.234 1.118-3.154 1.251q-.415.06-.835.06c-.928-.002-1.825-.301-3.28-.786l-.127-.043-.384-.128-.037-.012c-.463-.154-.87-.29-1.191-.44-.348-.162-.667-.37-.911-.709s-.341-.707-.385-1.088c-.04-.353-.04-.78-.04-1.269v-5.019c0-.787 0-1.45.067-1.969.07-.541.23-1.07.666-1.47a2.3 2.3 0 0 1 .42-.303l.366.655-.365-.655c.516-.287 1.068-.27 1.604-.166q.185.036.389.09A6.3 6.3 0 0 1 5.25 7.7m11.785 4.675c.734-1.026 1.33-2.137 1.583-3.378l.094.03c.51.171.834.28 1.07.39.217.1.287.171.326.226s.084.143.111.381c.03.258.031.6.031 1.138v5.667c0 .663-.001 1.097-.038 1.42-.035.31-.093.409-.132.456a.8.8 0 0 1-.206.175c-.053.03-.16.071-.472.055-.324-.017-.752-.087-1.407-.196l-.1-.017c-1.16-.193-1.876-.313-2.593-.253q-.377.032-.747.113c-.703.153-1.356.48-2.417 1.01l-.093.047c-1.544.772-2.17 1.075-2.82 1.169q-.306.045-.617.044c-.657-.002-1.312-.21-2.936-.752l-.384-.128c-.51-.17-.834-.28-1.07-.389-.217-.1-.287-.171-.326-.226s-.084-.143-.111-.381c-.03-.258-.031-.6-.031-1.138v-4.93c0-.85.002-1.415.055-1.825.052-.4.137-.508.19-.556a.8.8 0 0 1 .14-.1c.061-.035.191-.082.586-.005.327.064.737.19 1.304.377.287.585.637 1.142 1.016 1.67.793 1.106 1.768 2.153 2.659 3.108q.336.36.65.702c.402.44.921.895 1.595.919.696.024 1.25-.417 1.709-.923q.391-.432.799-.871c.907-.982 1.837-1.989 2.582-3.03M12 2.75c-2.936 0-5.25 2.252-5.25 4.95 0 1.336.591 2.616 1.51 3.895.731 1.02 1.62 1.975 2.504 2.923q.349.374.692.748c.379.413.528.432.541.432q.003.001.025-.004a.4.4 0 0 0 .094-.044c.098-.06.237-.173.425-.38q.433-.478.855-.933c.893-.967 1.734-1.878 2.419-2.835.887-1.24 1.435-2.458 1.435-3.802 0-2.698-2.314-4.95-5.25-4.95M10.75 8a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M12 5.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const C9 = { render: J0 }, X0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y0(a, l) {
  return r(), n("svg", X0, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.206 13.643a.75.75 0 0 0 1.06 1.061l9.14-9.14v2.732a.75.75 0 0 0 1.5 0V3.754a.75.75 0 0 0-.75-.75h-4.542a.75.75 0 0 0 0 1.5h2.732zM12 3.75h-.056c-1.72 0-3.088 0-4.159.144-1.104.148-2.005.462-2.717 1.174S4.042 6.681 3.894 7.785c-.144 1.071-.144 2.439-.144 4.159v.112c0 1.72 0 3.088.144 4.159.148 1.104.462 2.005 1.174 2.717s1.613 1.026 2.717 1.174c1.071.144 2.439.144 4.159.144h.112c1.72 0 3.088 0 4.159-.144 1.104-.149 2.005-.462 2.717-1.174s1.026-1.613 1.174-2.717c.144-1.072.144-2.439.144-4.159V12a.75.75 0 0 0-1.5 0c0 1.789-.002 3.055-.13 4.015-.127.938-.362 1.47-.749 1.856-.386.387-.918.622-1.856.748-.96.13-2.226.131-4.015.131s-3.055-.002-4.015-.13c-.938-.127-1.47-.362-1.856-.749-.387-.386-.622-.918-.748-1.856-.13-.96-.131-2.226-.131-4.015s.002-3.055.13-4.015c.127-.938.362-1.47.749-1.856.386-.387.918-.622 1.856-.748.96-.13 2.226-.131 4.015-.131a.75.75 0 0 0 0-1.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const H9 = { render: Y0 }, l1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e1(a, l) {
  return r(), n("svg", l1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M7.688 5.997a.75.75 0 0 0 1.5 0v-3a.75.75 0 1 0-1.5 0zM6.008 7.677a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zM17.242 15.529c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75M16.312 18.003a.75.75 0 1 0-1.5 0v3a.75.75 0 0 0 1.5 0zM11.742 7.34a.75.75 0 0 1 0-1.06l1.634-1.635a4.214 4.214 0 1 1 5.96 5.96L17.7 12.237a.75.75 0 0 1-1.06-1.06l1.634-1.634a2.714 2.714 0 0 0-3.838-3.838L12.803 7.34a.75.75 0 0 1-1.06 0M12.239 17.701a.75.75 0 1 0-1.061-1.06l-1.634 1.634a2.714 2.714 0 0 1-3.838-3.838l1.634-1.634a.75.75 0 0 0-1.06-1.06l-1.635 1.633a4.214 4.214 0 0 0 5.96 5.96z"
    }, null, -1)
  ]));
}
const V9 = { render: e1 }, n1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r1(a, l) {
  return r(), n("svg", n1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.969 6a.75.75 0 0 1-.75.75H3.78a.75.75 0 0 1 0-1.5H20.22a.75.75 0 0 1 .75.75m0 12a.75.75 0 0 1-.75.75H3.78a.75.75 0 0 1 0-1.5H20.22a.75.75 0 0 1 .75.75m-.75-7.25a.75.75 0 0 0 0-1.5h-7.306a.75.75 0 0 0 0 1.5zm.75 3.25a.75.75 0 0 1-.75.75h-7.306a.75.75 0 0 1 0-1.5h7.306a.75.75 0 0 1 .75.75M5.28 8.25a2.25 2.25 0 0 0-2.25 2.25v3a2.25 2.25 0 0 0 2.25 2.25h3a2.25 2.25 0 0 0 2.25-2.25v-3a2.25 2.25 0 0 0-2.25-2.25zm-.75 2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const I9 = { render: r1 }, a1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t1(a, l) {
  return r(), n("svg", a1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 19.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.75 12.75H3.25v-1.5h17.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.75 3.25v17.5h-1.5V3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q9 = { render: t1 }, o1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c1(a, l) {
  return r(), n("svg", o1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.75 8.325a.75.75 0 0 0-1.5 0v4.161a.75.75 0 0 0 .216.527l2.469 2.502a.75.75 0 0 0 1.068-1.054l-2.253-2.283z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18m-7.5 9a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const L9 = { render: c1 }, i1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d1(a, l) {
  return r(), n("svg", i1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.498 7.353a3.385 3.385 0 1 1 6.769 0 3.385 3.385 0 0 1-6.77 0m3.384-4.885a4.885 4.885 0 1 0 0 9.77 4.885 4.885 0 0 0 0-9.77m7.188 9.064c.22 0 .4.18.4.4v.945a.43.43 0 0 0 .257.385q.3.139.57.33a.43.43 0 0 0 .462.03l.82-.473a.4.4 0 0 1 .546.147l.85 1.472a.4.4 0 0 1-.147.547l-.819.472a.43.43 0 0 0-.205.415 3.6 3.6 0 0 1 0 .66.43.43 0 0 0 .205.415l.82.473a.4.4 0 0 1 .146.546l-.85 1.472a.4.4 0 0 1-.547.146l-.819-.472a.43.43 0 0 0-.462.03 3.6 3.6 0 0 1-.57.33.43.43 0 0 0-.258.385v.945a.4.4 0 0 1-.4.4h-1.7a.4.4 0 0 1-.4-.4v-.944a.43.43 0 0 0-.257-.386 3.6 3.6 0 0 1-.57-.33.43.43 0 0 0-.463-.03l-.818.473a.4.4 0 0 1-.547-.147l-.85-1.472a.4.4 0 0 1 .147-.547l.818-.472a.43.43 0 0 0 .205-.415 3.7 3.7 0 0 1 0-.66.43.43 0 0 0-.205-.415l-.818-.473a.4.4 0 0 1-.147-.546l.85-1.472a.4.4 0 0 1 .547-.146l.818.472a.43.43 0 0 0 .463-.03q.268-.191.57-.33a.43.43 0 0 0 .258-.386v-.944c0-.22.179-.4.4-.4zm-.85 6.538a1.538 1.538 0 1 0 0-3.076 1.538 1.538 0 0 0 0 3.076m-5.875-4.216H7.333c-1.112 0-2.202.358-3.026 1.027-.829.672-1.335 1.622-1.335 2.655v2.237a.75.75 0 0 0 1.5 0v-2.237c0-.522.254-1.064.78-1.49.53-.431 1.278-.692 2.081-.692H9.98c-.05-.457.04-.935.288-1.364z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A9 = { render: d1 }, h1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s1(a, l) {
  return r(), n("svg", h1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.484 12c0-3.923 3.162-7.053 7-7.053 1.284 0 2.485.347 3.52.955.354.208.815.1 1.03-.242a.71.71 0 0 0-.25-.994 8.47 8.47 0 0 0-4.3-1.166c-4.722 0-8.5 3.833-8.5 8.5s3.778 8.5 8.5 8.5 8.5-3.833 8.5-8.5c0-.4-.335-.723-.75-.723a.737.737 0 0 0-.75.723c0 3.923-3.161 7.053-7 7.053s-7-3.13-7-7.053M20.8 5.964a.75.75 0 0 0-1.069-1.053l-8.185 8.31-.05-.054c-.445-.464-1.19-1.233-2.398-2.46a.75.75 0 0 0-1.07 1.053 257 257 0 0 1 2.384 2.445 58 58 0 0 1 .543.574l.02.021.003.004a.75.75 0 0 0 1.091.024z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y9 = { render: s1 }, v1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u1(a, l) {
  return r(), n("svg", v1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.529 2.898a.75.75 0 0 1 .75.75v1.454h7.501V3.648a.75.75 0 0 1 1.5 0v1.454H19a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h1.779V3.648a.75.75 0 0 1 .75-.75m8.251 3.704v.546a.75.75 0 0 0 1.5 0v-.546H19a.5.5 0 0 1 .5.5v2.375h-15V7.102a.5.5 0 0 1 .5-.5h1.779v.546a.75.75 0 1 0 1.5 0v-.546zM4.5 10.977v8.125a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-8.125zm9.523 3.643a.5.5 0 0 1 .5-.5h2.959a.5.5 0 0 1 .5.5v2.958a.5.5 0 0 1-.5.5h-2.959a.5.5 0 0 1-.5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const k9 = { render: u1 }, m1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w1(a, l) {
  return r(), n("svg", m1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.406 8.719a.75.75 0 0 1-1.5 0v-3a2.75 2.75 0 0 1 2.75-2.75h2a.75.75 0 0 1 0 1.5h-2c-.69 0-1.25.56-1.25 1.25zm3.25 10.812a.75.75 0 0 1 0 1.5h-2a2.75 2.75 0 0 1-2.75-2.75v-3a.75.75 0 0 1 1.5 0v3c0 .69.56 1.25 1.25 1.25zm9.844.75a.75.75 0 0 1 .75-.75h2c.69 0 1.25-.56 1.25-1.25v-3a.75.75 0 0 1 1.5 0v3a2.75 2.75 0 0 1-2.75 2.75h-2a.75.75 0 0 1-.75-.75m4-11.562a.75.75 0 0 0 1.5 0v-3a2.75 2.75 0 0 0-2.75-2.75h-2a.75.75 0 0 0 0 1.5h2c.69 0 1.25.56 1.25 1.25zm-14.03-.25a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.061l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H2.655a.75.75 0 0 1 0-1.5H8.19L6.47 9.53a.75.75 0 0 1 0-1.06m10 0a.75.75 0 1 1 1.06 1.061l-1.72 1.72h5.534a.75.75 0 0 1 0 1.5H15.81l1.72 1.72a.75.75 0 1 1-1.061 1.06l-3-3a.75.75 0 0 1 0-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const S9 = { render: w1 }, f1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z1(a, l) {
  return r(), n("svg", f1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.879 3.509c-5.153-.229-9.491 4.173-9.39 9.428.044 2.293 1.331 5.064 3.047 6.965l1.649-1.647a2.05 2.05 0 0 1 .509-2.042l7.637-7.651a2.05 2.05 0 0 1 2.055-.51l1.492-1.494c-2.156-1.852-4.532-2.94-7-3.049m.066-1.499C6.878 1.74 1.872 6.896 1.99 12.966c.058 3.006 1.845 6.48 4.057 8.582a.71.71 0 0 0 .994-.029l2.71-2.709a.545.545 0 0 0 .003-.769.545.545 0 0 1 .003-.768l7.636-7.652a.547.547 0 0 1 .774 0c.214.214.56.214.774 0l2.567-2.572a.73.73 0 0 0-.006-1.047C19.006 3.65 16.093 2.15 12.945 2.01",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.696 7.721c2.58-2.585 5.314-2.347 6.764-1.932.518.149.86.555.95 1.027.09.458-.06.937-.406 1.283L8.19 14.912a1.43 1.43 0 0 1-1.223.416 1.32 1.32 0 0 1-1.047-.858 5.87 5.87 0 0 1-.31-2.893c.178-1.207.77-2.543 2.086-3.856m6.116-.551c-1.153-.274-3.115-.332-5.055 1.612h-.001c-1.102 1.1-1.534 2.146-1.662 3.015a4.3 4.3 0 0 0 .158 1.932zM18.506 3.8a.5.5 0 0 1 .13.695l-1.001 1.468a.5.5 0 0 1-.826-.564l1.002-1.468a.5.5 0 0 1 .695-.13M10.612 2.435a.5.5 0 0 1 .597.38l.321 1.433a.5.5 0 1 1-.976.218l-.32-1.433a.5.5 0 0 1 .378-.598M5 14.038a.5.5 0 0 1-.409.577l-1.618.277a.5.5 0 1 1-.169-.986l1.619-.277a.5.5 0 0 1 .577.409M4.082 6.812a.5.5 0 0 1 .69-.155l1.294.82a.5.5 0 1 1-.534.845l-1.295-.82a.5.5 0 0 1-.155-.69M6.22 16.91a.5.5 0 0 1-.151.69l-1.443.926a.5.5 0 0 1-.54-.842l1.443-.925a.5.5 0 0 1 .69.15M14.525 2.44a.5.5 0 0 1 .374.6l-.334 1.44a.5.5 0 1 1-.974-.225l.334-1.441a.5.5 0 0 1 .6-.375M2.453 10.615a.5.5 0 0 1 .58-.406l1.453.255a.5.5 0 1 1-.173.985l-1.454-.255a.5.5 0 0 1-.406-.579M6.79 4.07a.5.5 0 0 1 .7.106l.875 1.187a.5.5 0 1 1-.804.594L6.685 4.77a.5.5 0 0 1 .105-.7",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D9 = { render: z1 }, g1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p1(a, l) {
  return r(), n("svg", g1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.063 6.5a1.5 1.5 0 1 0-3 0v11a1.5 1.5 0 0 0 3 0zM18 6.5a1.5 1.5 0 0 0-3 0v11a1.5 1.5 0 0 0 3 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const F9 = { render: p1 }, M1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x1(a, l) {
  return r(), n("svg", M1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.969 3.781a.75.75 0 0 0-1.5 0v16.532a.75.75 0 1 0 1.5 0zM5.25 8.75A2.25 2.25 0 0 0 3 11v2a2.25 2.25 0 0 0 2.25 2.25h10.188a2.25 2.25 0 0 0 2.25-2.25v-2a2.25 2.25 0 0 0-2.25-2.25zM4.5 11a.75.75 0 0 1 .75-.75h10.188a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75H5.25A.75.75 0 0 1 4.5 13z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const T9 = { render: x1 }, _1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $1(a, l) {
  return r(), n("svg", _1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.594 3.781a.75.75 0 0 0-1.5 0v16.532a.75.75 0 0 0 1.5 0zm3.843 5.016a2.25 2.25 0 0 0-2.25 2.25v2a2.25 2.25 0 0 0 2.25 2.25h10.188a2.25 2.25 0 0 0 2.25-2.25v-2a2.25 2.25 0 0 0-2.25-2.25zm-.75 2.25a.75.75 0 0 1 .75-.75h10.188a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75H8.438a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b9 = { render: $1 }, C1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H1(a, l) {
  return r(), n("svg", C1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 6.25a2.25 2.25 0 0 1 2.25 2.25v2.75h5.063a.75.75 0 0 1 0 1.5H15.25v2.75A2.25 2.25 0 0 1 13 17.75h-2a2.25 2.25 0 0 1-2.25-2.25v-2.75H3.719a.75.75 0 0 1 0-1.5H8.75V8.5A2.25 2.25 0 0 1 11 6.25zM10.25 12v3.5c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75h-2a.75.75 0 0 0-.75.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const E9 = { render: H1 }, V1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I1(a, l) {
  return r(), n("svg", V1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.158 4.725c-.082.069-.266.333-.427.847a5.5 5.5 0 0 0-.242 1.66c.038.926.421 2.326 1.13 3.8.705 1.468 1.7 2.935 2.895 4.01 1.365 1.225 2.691 2.24 3.914 2.975 1.232.741 2.313 1.17 3.193 1.278 1.156.141 2.03.086 2.644-.049.635-.139.929-.346 1.015-.441.001-.001.021-.026.05-.09q.043-.096.083-.268c.052-.231.08-.53.07-.868-.02-.684-.19-1.434-.515-2.01q.005.007-.007-.004a1.8 1.8 0 0 0-.344-.239 6.6 6.6 0 0 0-.955-.43 9 9 0 0 0-1.04-.314 4 4 0 0 0-.398-.072 2 2 0 0 0-.17-.012h-.01l-.004.001c-.145.015-.372.131-.744.455-.132.114-.26.233-.4.364l-.143.133a8 8 0 0 1-.617.53.75.75 0 0 1-.788.073 13.7 13.7 0 0 1-3.347-2.362 15.7 15.7 0 0 1-2.162-2.631.75.75 0 0 1 .08-.935c.445-.466 1.147-1.337 1.462-2a.6.6 0 0 0 .028-.12q.02-.125.018-.325a4.6 4.6 0 0 0-.12-.94c-.157-.684-.44-1.312-.783-1.676a3 3 0 0 0-.638-.232A7.5 7.5 0 0 0 6.73 4.63a5.7 5.7 0 0 0-1.105-.014 2 2 0 0 0-.362.067c-.074.023-.103.041-.105.042M8.27 3.383c.411.11.835.26 1.143.469a1 1 0 0 1 .103.083c.665.643 1.06 1.625 1.253 2.47.1.436.154.871.158 1.26.004.363-.034.775-.191 1.106-.314.659-.863 1.394-1.322 1.934.366.515.893 1.192 1.633 1.912a12 12 0 0 0 2.54 1.868 15 15 0 0 0 .271-.25c.144-.134.3-.28.455-.414.38-.33.918-.746 1.571-.814.315-.033.715.032 1.07.113.383.086.813.215 1.227.368.412.152.83.335 1.18.536.313.178.707.444.913.807.472.837.683 1.84.708 2.705a5 5 0 0 1-.105 1.238c-.08.357-.222.746-.484 1.036-.379.42-1.016.729-1.807.902-.812.177-1.86.23-3.147.072-1.177-.144-2.466-.688-3.784-1.481-1.327-.798-2.73-1.877-4.143-3.146-1.378-1.238-2.48-2.88-3.246-4.476-.762-1.585-1.23-3.198-1.276-4.4v-.02a7 7 0 0 1 .31-2.14c.187-.594.483-1.21.914-1.562.357-.29.853-.393 1.255-.435.438-.045.931-.034 1.408.013.479.047.964.133 1.393.246",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const B9 = { render: I1 }, q1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L1(a, l) {
  return r(), n("svg", q1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M5.66 20.531V3.47h5.977q3.105 0 4.71 1.195 1.606 1.185 1.606 3.48 0 1.255-.644 2.215-.645.95-1.793 1.395 1.312.328 2.062 1.324.762.996.762 2.438 0 2.46-1.57 3.726t-4.477 1.29zm3.516-7.43v4.606h3.012q1.242 0 1.933-.586.703-.597.703-1.64 0-2.344-2.426-2.38zm0-2.484h2.601q2.66-.047 2.66-2.12 0-1.161-.68-1.665-.667-.516-2.12-.516H9.176z"
    }, null, -1)
  ]));
}
const P9 = { render: L1 }, A1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y1(a, l) {
  return r(), n("svg", A1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const R9 = { render: y1 }, k1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S1(a, l) {
  return r(), n("svg", k1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.01 7.752a.75.75 0 0 1 .75-.749h12.493a.75.75 0 0 1 .75.75v9.578c0 1.22-.28 2.22-1.052 2.875-.742.63-1.774.795-2.897.795H8.945c-1.123 0-2.155-.165-2.897-.795-.773-.656-1.052-1.655-1.052-2.875zm1.499.751-.013 8.828c0 1.028.238 1.49.523 1.732.316.268.883.438 1.926.438h6.109c1.042 0 1.61-.17 1.926-.438.285-.242.523-.704.523-1.732V8.503z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.138 4.957c-.421.28-.624.633-.624 1.049v.901h-1.5v-.9c0-1.01.537-1.798 1.295-2.3.742-.492 1.707-.727 2.7-.721.986.006 1.948.24 2.689.728.758.499 1.297 1.28 1.297 2.292v.901a.75.75 0 0 1-1.5 0v-.9c0-.415-.2-.763-.622-1.04-.439-.289-1.097-.476-1.873-.481-.77-.005-1.425.181-1.862.471m-2.124 1.95a.75.75 0 1 0 1.5 0zM13.871 13.701c.421-.279.624-.632.624-1.048v-.902h1.5v.902c0 1.01-.537 1.796-1.295 2.299-.742.491-1.707.727-2.7.72-.986-.005-1.948-.24-2.689-.727-.758-.5-1.297-1.28-1.297-2.292v-.902a.75.75 0 0 1 1.5 0v.902c0 .413.2.762.622 1.039.439.288 1.097.476 1.873.48.77.006 1.425-.18 1.862-.47m2.124-1.95a.75.75 0 1 0-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const U9 = { render: S1 }, D1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F1(a, l) {
  return r(), n("svg", D1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.632 3.219a1.918 1.918 0 0 1 3.322 1.918l-3.027 5.242 1.799 1.038a.75.75 0 0 1 .375.639c.013.891-.244 1.928-.595 2.933-.355 1.02-.83 2.071-1.299 3.013a44 44 0 0 1-1.84 3.317l-.034.052-.008.014-.003.005-.635-.4.635.4a.75.75 0 0 1-1.01.25l-1.116-.644a.75.75 0 0 1-.357-.813l.146-.658-.582.464a.75.75 0 0 1-.852.057l-1.79-1.07a.75.75 0 0 1-.364-.677l.046-1.03-.931.57a.75.75 0 0 1-1.087-.36l-.304-.754-.78.122a.75.75 0 0 1-.49-.092l-1.687-.974a.75.75 0 0 1-.149-1.186c1.479-1.442 4.726-4.886 6.108-7.279a.75.75 0 0 1 1.024-.274l2.458 1.419zm2.023 1.168-2.996 5.19-.724-.419 2.996-5.19a.418.418 0 1 1 .724.419m-4.23 15.587q.09-.148.192-.327a42 42 0 0 0 1.248-2.314c.323-.648.641-1.337.916-2.02l-7.457-4.305A60 60 0 0 1 5.76 14.97l.61.353 1.108-.173a.75.75 0 0 1 .812.461l.194.485 1.38-.844a.75.75 0 0 1 1.14.673l-.09 1.993.96.573 1.835-1.462a.75.75 0 0 1 1.2.75l-.488 2.192zm3.157-7.485c-.04.406-.14.874-.292 1.386l-7.036-4.062c.28-.377.541-.749.774-1.108z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O9 = { render: F1 }, T1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b1(a, l) {
  return r(), n("svg", T1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.751 3.024a.75.75 0 0 1 .53 0l8.221 3.098a.75.75 0 0 1 .003 1.402l-8.222 3.13a.75.75 0 0 1-.53.002L3.485 7.55a.75.75 0 0 1-.001-1.404zm.266 1.503-6.14 2.319 6.137 2.306 6.106-2.325z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.675 6.222A.75.75 0 0 1 21 6.84v9.296a.75.75 0 0 1-.412.67l-8.202 4.138a.75.75 0 0 1-1.087-.67V9.986a.75.75 0 0 1 .48-.7l8.202-3.147a.75.75 0 0 1 .694.083m-7.876 4.28v8.554l6.701-3.382V7.931z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M3.75 6.84v9.325l8.266 4.101V9.954z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.412 20.904a.75.75 0 0 0 .354-.638V9.954a.75.75 0 0 0-.485-.702L4.014 6.138A.75.75 0 0 0 3 6.84v9.325a.75.75 0 0 0 .417.672l8.266 4.101a.75.75 0 0 0 .729-.034M4.5 15.7V7.924l6.766 2.549v8.584z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const G9 = { render: b1 }, E1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B1(a, l) {
  return r(), n("svg", E1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.895 5.152a1.25 1.25 0 0 0-1.602-.01L5.387 10.01a1.75 1.75 0 0 0-.637 1.35V19.5c0 .138.112.25.25.25h3.813v-2.373a3.277 3.277 0 1 1 6.554 0v2.373H19a.25.25 0 0 0 .25-.25v-8.159a1.75 1.75 0 0 0-.62-1.335zM10.34 3.984a2.75 2.75 0 0 1 3.525.023L19.6 8.86a3.25 3.25 0 0 1 1.15 2.48V19.5A1.75 1.75 0 0 1 19 21.25h-4.12c-.56 0-1.013-.453-1.013-1.013v-2.86a1.777 1.777 0 1 0-3.554 0v2.86c0 .56-.454 1.013-1.013 1.013H5a1.75 1.75 0 0 1-1.75-1.75v-8.139c0-.97.434-1.89 1.183-2.508z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const N9 = { render: B1 }, P1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R1(a, l) {
  return r(), n("svg", P1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M11.167 15.333a.83.83 0 0 1-.59-.244l-2.5-2.5a.832.832 0 1 1 1.179-1.178l1.855 1.855 3.582-4.3a.835.835 0 0 1 1.281 1.068l-4.167 5a.83.83 0 0 1-.602.298zM12 22l-.203-.025c-3.799-.95-8.13-6.263-8.13-9.975V4.5c0-.46.373-.833.833-.833 1.143 0 2.865-.463 5.045-1.048.7-.188 1.45-.389 2.248-.593a.83.83 0 0 1 .417.001c.732.19 1.426.378 2.08.556 2.236.606 4.002 1.084 5.21 1.084.46 0 .833.373.833.833V12c0 3.77-3.643 9.063-8.167 9.983zM5.333 5.282V12c0 2.86 3.7 7.418 6.688 8.31 3.538-.852 6.646-5.295 6.646-8.31V5.284c-1.299-.14-2.891-.573-4.813-1.093-.586-.158-1.205-.327-1.856-.497q-1.07.279-2.02.535c-1.859.499-3.402.913-4.645 1.053"
    }, null, -1)
  ]));
}
const Q9 = { render: R1 }, U1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O1(a, l) {
  return r(), n("svg", U1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.984 21.968a.75.75 0 0 0 .752-.749l.013-6.062h5.385a.726.726 0 0 0 .716-.852 7.34 7.34 0 0 0-1.562-3.383c-.974-1.183-2.189-2.676-2.304-2.89V4.595l1.51-.863a.91.91 0 0 0-.451-1.7H7.89a.907.907 0 0 0-.445 1.698l1.538.865v3.437c-.203.268-1.37 1.738-2.295 2.9a7.6 7.6 0 0 0-1.521 3.329.757.757 0 0 0 .744.896h5.337v.001l-.014 6.058a.75.75 0 0 0 .749.752m5.15-8.31a5.9 5.9 0 0 0-1.005-1.783c-.829-1.008-1.707-2.062-2.465-3.129a1.5 1.5 0 0 1-.18-.714V4.595a1.5 1.5 0 0 1 .44-1.063h-3.881a1.5 1.5 0 0 1 .44 1.063v3.437a1.5 1.5 0 0 1-.303.904c-.217.288-1.402 1.78-2.317 2.93a6.1 6.1 0 0 0-.987 1.791z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z9 = { render: O1 }, G1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N1(a, l) {
  return r(), n("svg", G1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.74 12.652a.75.75 0 0 0-1.06-.004l-1.947 1.931V3.867a.75.75 0 0 0-1.5 0v10.692l-1.91-1.91a.75.75 0 0 0-1.06 1.061l3.194 3.195a.75.75 0 0 0 1.059.002l3.22-3.195a.75.75 0 0 0 .004-1.06M3.719 19.594a.75.75 0 0 0 0 1.5H20.28a.75.75 0 1 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const W9 = { render: N1 }, Q1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z1(a, l) {
  return r(), n("svg", Q1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.98 2.996a.75.75 0 0 1 .75.75v13.232c0 .69.559 1.25 1.25 1.25h13.274a.75.75 0 0 1 0 1.5H6.979a2.75 2.75 0 0 1-2.75-2.75V3.746a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.768 5.588a.75.75 0 0 1-1.06-.014l-1.705-1.75-1.708 1.75a.75.75 0 0 1-1.073-1.047l2.244-2.301a.75.75 0 0 1 1.075 0l2.241 2.302a.75.75 0 0 1-.014 1.06M18.415 21.769a.75.75 0 0 1 .014-1.061l1.75-1.705-1.75-1.707a.75.75 0 1 1 1.047-1.074l2.302 2.245a.75.75 0 0 1 0 1.074l-2.302 2.241a.75.75 0 0 1-1.06-.014",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const j9 = { render: Z1 }, W1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j1(a, l) {
  return r(), n("svg", W1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.992 3.619a.76.76 0 0 0-.006 1.067l1.528 1.564h-2.592a3.75 3.75 0 0 0-2.903 1.375l-7.2 8.8a2.25 2.25 0 0 1-1.74.825H2.702a.75.75 0 0 0 0 1.5h2.375a3.75 3.75 0 0 0 2.903-1.375l7.2-8.8a2.25 2.25 0 0 1 1.74-.825h2.596L17.96 9.308a.76.76 0 0 0-.006 1.067.74.74 0 0 0 1.054.006l2.829-2.828a.76.76 0 0 0 .006-1.067l-2.796-2.861a.74.74 0 0 0-1.054-.006m-1.07 14.131a3.75 3.75 0 0 1-2.903-1.375l-1.665-2.036.968-1.186 1.858 2.272a2.25 2.25 0 0 0 1.742.825h2.576l-1.512-1.548a.76.76 0 0 1 .006-1.067.74.74 0 0 1 1.054.006l2.796 2.861a.76.76 0 0 1-.006 1.067l-2.829 2.828a.74.74 0 0 1-1.054-.006.76.76 0 0 1 .006-1.066l1.574-1.575zm-6.508-8.151L7.98 6.625A3.75 3.75 0 0 0 5.078 5.25H2.766a.75.75 0 1 0 0 1.5h2.312a2.25 2.25 0 0 1 1.742.825l2.626 3.21z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K9 = { render: j1 }, K1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J1(a, l) {
  return r(), n("svg", K1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 5.5v9h.5a1 1 0 0 0 1-1v-8a2 2 0 0 0-2-2h-8a1 1 0 0 0-1 1V5h9a.5.5 0 0 1 .5.5m-3 3v9h.5a1 1 0 0 0 1-1v-8a2 2 0 0 0-2-2h-8a1 1 0 0 0-1 1V8h9a.5.5 0 0 1 .5.5m-11.5 1a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J9 = { render: J1 }, X1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y1(a, l) {
  return r(), n("svg", X1, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3.25h-.057c-1.955 0-3.5 0-4.706.162-1.24.167-2.238.517-3.023 1.302S3.08 6.496 2.912 7.737c-.162 1.207-.162 2.75-.162 4.706v.151c0 1.92 0 3.226.166 4.196.184 1.069.572 1.77 1.298 2.496.785.784 1.782 1.135 3.023 1.302 1.207.162 2.75.162 4.706.162h.114c1.955 0 3.5 0 4.706-.162 1.24-.167 2.238-.518 3.022-1.303.727-.726 1.115-1.427 1.299-2.495.166-.97.166-2.277.166-4.196v-.151c0-1.955 0-3.5-.162-4.706-.167-1.24-.518-2.238-1.303-3.023s-1.781-1.135-3.022-1.302c-1.207-.162-2.75-.162-4.706-.162zM5.275 5.775c.46-.46 1.087-.732 2.162-.876C8.532 4.752 9.975 4.75 12 4.75s3.468.002 4.564.149c1.074.144 1.701.416 2.16.876s.733 1.087.877 2.162c.147 1.095.149 2.538.149 4.563 0 1.568-.002 2.624-.067 3.405l-2.003-1.802a3.29 3.29 0 0 0-4.094-.247l-.253.178a.945.945 0 0 1-1.211-.105l-3.635-3.634a2.7 2.7 0 0 0-3.685-.123l-.546.478c.011-1.104.045-1.985.143-2.713.144-1.075.416-1.702.876-2.162M4.25 12.643c0 1.948.006 3.085.145 3.894.128.746.361 1.17.88 1.688.46.46 1.087.732 2.162.876 1.095.147 2.538.149 4.563.149s3.468-.002 4.564-.149c1.074-.144 1.701-.416 2.16-.876.233-.232.408-.445.542-.677l-2.59-2.33a1.79 1.79 0 0 0-2.228-.134l-.253.177a2.445 2.445 0 0 1-3.134-.271l-3.634-3.635a1.2 1.2 0 0 0-1.637-.054l-1.484 1.298zm11.424-5.366a.945.945 0 1 0 0 1.89.945.945 0 0 0 0-1.89m-2.445.945a2.445 2.445 0 1 1 4.889 0 2.445 2.445 0 0 1-4.89 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X9 = { render: Y1 }, l5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e5(a, l) {
  return r(), n("svg", l5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.9 3.964a1.25 1.25 0 0 1 2.2 0L15.649 8.7l4.294.433c1.083.11 1.519 1.454.706 2.178l-3.296 2.932 1.583 4.958c.33 1.031-.72 1.965-1.706 1.519L12 18.354 6.771 20.72c-.986.446-2.035-.488-1.706-1.52l1.583-4.957-3.296-2.932c-.813-.724-.377-2.069.706-2.178L8.352 8.7zm1.1 1.12L9.61 9.527a1.25 1.25 0 0 1-.975.652l-3.86.39 2.992 2.661c.369.329.51.844.36 1.314l-1.462 4.578 4.82-2.181a1.25 1.25 0 0 1 1.03 0l4.82 2.18-1.462-4.577a1.25 1.25 0 0 1 .36-1.314l2.992-2.662-3.86-.389a1.25 1.25 0 0 1-.975-.652z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y9 = { render: e5 }, n5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r5(a, l) {
  return r(), n("svg", n5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.25 10.47a.75.75 0 0 1 .75.75v9.04a.75.75 0 0 1-1.5 0v-9.04a.75.75 0 0 1 .75-.75M3.75 3a.75.75 0 0 1 .75.75v16.51a.75.75 0 0 1-1.5 0V3.75A.75.75 0 0 1 3.75 3M14.65 4.5a1.293 1.293 0 1 0 0 2.586 1.293 1.293 0 0 0 0-2.586m-2.793 1.293a2.793 2.793 0 1 1 5.586 0 2.793 2.793 0 0 1-5.586 0M9.34 10.247a1.293 1.293 0 1 0 0 2.586 1.293 1.293 0 0 0 0-2.586M6.547 11.54a2.793 2.793 0 1 1 5.586 0 2.793 2.793 0 0 1-5.586 0M13.34 16.937a1.293 1.293 0 1 0 0 2.586 1.293 1.293 0 0 0 0-2.586m-2.793 1.293a2.793 2.793 0 1 1 5.586 0 2.793 2.793 0 0 1-5.586 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ll = { render: r5 }, a5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t5(a, l) {
  return r(), n("svg", a5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3.118a.75.75 0 0 1 .75.75v7.382h7.382a.75.75 0 0 1 0 1.5H12.75v7.382a.75.75 0 0 1-1.5 0V12.75h-7.3a.75.75 0 0 1 0-1.5h7.3V3.868a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const el = { render: t5 }, o5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c5(a, l) {
  return r(), n("svg", o5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.17 14.455a.75.75 0 1 0 1.06-1.06l-3.67-3.67h11.19a4.75 4.75 0 1 1 0 9.5H7.122a.75.75 0 0 0 0 1.5h8.628a6.25 6.25 0 1 0 0-12.5H4.56l3.67-3.67a.75.75 0 0 0-1.06-1.06L2.222 8.442a.8.8 0 0 0-.158.226.75.75 0 0 0 .158.841z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const nl = { render: c5 }, i5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d5(a, l) {
  return r(), n("svg", i5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.824 8.167a.75.75 0 0 1 .75.75V18.2a.75.75 0 0 1-1.5 0V8.917a.75.75 0 0 1 .75-.75M7.887 8.167a.75.75 0 0 1 .75.75V18.2a.75.75 0 0 1-1.5 0V8.917a.75.75 0 0 1 .75-.75M10.981 8.167a.75.75 0 0 1 .75.75V18.2a.75.75 0 0 1-1.5 0V8.917a.75.75 0 0 1 .75-.75M13.044 8.167a.75.75 0 0 1 .75.75V18.2a.75.75 0 0 1-1.5 0V8.917a.75.75 0 0 1 .75-.75M16.139 8.167a.75.75 0 0 1 .75.75V18.2a.75.75 0 0 1-1.5 0V8.917a.75.75 0 0 1 .75-.75M18.202 8.167a.75.75 0 0 1 .75.75V18.2a.75.75 0 0 1-1.5 0V8.917a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.011 18.2a.75.75 0 0 1 .75-.75h16.504a.75.75 0 0 1 .75.75v2.063a.75.75 0 0 1-.75.75H3.76a.75.75 0 0 1-.75-.75zm1.5.75v.563h15.004v-.563zM11.373 3.136a1.54 1.54 0 0 1 1.223 0l7.939 3.067c.289.112.48.39.48.7v2.014a.75.75 0 0 1-.75.75H3.76a.75.75 0 0 1-.75-.75V6.903c0-.31.19-.587.478-.699zm.602 1.375h-.005l-.037.017L4.51 7.416v.75h15.004v-.749l-7.476-2.889-.04-.016-.003-.001a.1.1 0 0 0-.021 0",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.231 6.854a.75.75 0 0 1 .75-.75h2.063a.75.75 0 0 1 0 1.5h-2.063a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rl = { render: d5 }, h5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s5(a, l) {
  return r(), n("svg", h5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-1.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const al = { render: s5 }, v5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u5(a, l) {
  return r(), n("svg", v5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12 7.56a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M13.457 13.524c.364 0 .724.069 1.062.204.337.136.645.335.905.589s.468.554.61.888c.143.334.216.692.216 1.054v.957a.75.75 0 0 1-.75.75h-7a.75.75 0 0 1-.75-.75v-.957c0-.732.299-1.43.824-1.94a2.82 2.82 0 0 1 1.964-.795z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.5 2.003a.5.5 0 0 0-.5.5v.494H6a1.5 1.5 0 0 0-1.5 1.5v16a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-16a1.5 1.5 0 0 0-1.5-1.5h-2v-.494a.5.5 0 0 0-.5-.5zM8 4.497v.506a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.506h1.5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tl = { render: u5 }, m5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w5(a, l) {
  return r(), n("svg", m5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 5.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5M4 6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm11-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5M13 6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm5 8.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5M15 13a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2zm-9 1.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5M4 15a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ol = { render: w5 }, f5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z5(a, l) {
  return r(), n("svg", f5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.031 3.33a5.75 5.75 0 0 0-4.312 9.553v2.026A7.25 7.25 0 1 1 14.837 4.736h-2.038A5.73 5.73 0 0 0 9.03 3.33M8 6.248a1.75 1.75 0 0 0-1.75 1.75v9c0 .967.784 1.75 1.75 1.75h2.032a7 7 0 0 1-.29-1.5H8a.25.25 0 0 1-.25-.25v-9a.25.25 0 0 1 .25-.25h9a.25.25 0 0 1 .25.25V9.69q.779.06 1.5.28V7.997A1.75 1.75 0 0 0 17 6.248zm8.719 15.922a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m.833-7.557a.818.818 0 0 0-1.637 0v1.364h-1.378a.818.818 0 0 0 0 1.636h1.378v1.364a.818.818 0 0 0 1.637 0v-1.364H18.9a.818.818 0 0 0 0-1.636h-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cl = { render: z5 }, g5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p5(a, l) {
  return r(), n("svg", g5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21 8.75a.75.75 0 0 1-.75.75h-3a2.75 2.75 0 0 1-2.75-2.75v-3a.75.75 0 0 1 1.5 0v3c0 .69.56 1.25 1.25 1.25h3a.75.75 0 0 1 .75.75M6.75 8C7.442 8 8 7.44 8 6.75v-3a.75.75 0 1 1 1.5 0v3A2.75 2.75 0 0 1 6.75 9.5h-3a.75.75 0 1 1 0-1.5zM21 15.282a.75.75 0 0 0-.75-.75h-3a2.75 2.75 0 0 0-2.75 2.75v3a.75.75 0 0 0 1.5 0v-3c0-.69.56-1.25 1.25-1.25h3a.75.75 0 0 0 .75-.75M6.75 16.031c.691 0 1.25.56 1.25 1.25v3a.75.75 0 0 0 1.5 0v-3a2.75 2.75 0 0 0-2.75-2.75h-3a.75.75 0 1 0 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const il = { render: p5 }, M5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x5(a, l) {
  return r(), n("svg", M5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.81 4.167H5.771a2.5 2.5 0 0 1 .675-1.258 2.48 2.48 0 0 1 1.756-.731h11.034a2.46 2.46 0 0 1 1.755.73 2.5 2.5 0 0 1 .728 1.77v8.804a2.52 2.52 0 0 1-.728 1.769 2.5 2.5 0 0 1-1.18.663V5.167a1 1 0 0 0-1-1M6.447 10.553a.75.75 0 0 0 0 1.5h6.096a.75.75 0 0 0 0-1.5zm-.75 3.532a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75m10.475 3.882a1 1 0 0 1-.371.074h-4.76a1.5 1.5 0 0 0-.812.238L8.348 19.49a1.5 1.5 0 0 0-1.5-1.449H4.762a.96.96 0 0 1-.689-.288 1 1 0 0 1-.292-.712V8.237a1.02 1.02 0 0 1 .292-.712.98.98 0 0 1 .689-.288H15.8a.96.96 0 0 1 .688.288 1 1 0 0 1 .292.712v8.804a1.02 1.02 0 0 1-.291.712 1 1 0 0 1-.318.214m-9.325 3.354a.5.5 0 0 0 .77.421l3.424-2.2h4.757a2.46 2.46 0 0 0 1.756-.732 2.5 2.5 0 0 0 .727-1.769V8.237a2.52 2.52 0 0 0-.727-1.769 2.48 2.48 0 0 0-1.756-.73H4.764a2.46 2.46 0 0 0-1.755.73 2.5 2.5 0 0 0-.728 1.77v8.803a2.52 2.52 0 0 0 .728 1.77 2.48 2.48 0 0 0 1.755.73h2.083z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dl = { render: x5 }, _5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $5(a, l) {
  return r(), n("svg", _5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 4.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.25 14.25h17.5v1.5H3.25zM3.25 8.25h17.5v1.5H3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hl = { render: $5 }, C5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H5(a, l) {
  return r(), n("svg", C5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M10.576 15.447H8.177v-3.601H5.4v3.601H3V6.605h2.399v3.278h2.778V6.605h2.399zM20.75 11.014c0 2-.63 3.352-1.908 4.056L21 17.55h-2.973l-1.565-1.962a4.2 4.2 0 0 1-3.186-1.167 4.75 4.75 0 0 1-1.111-3.397 4.73 4.73 0 0 1 1.093-3.398 4.21 4.21 0 0 1 3.204-1.167 4.2 4.2 0 0 1 3.204 1.167 4.78 4.78 0 0 1 1.084 3.388m-6.075 0c0 1.713.592 2.565 1.778 2.565a1.55 1.55 0 0 0 1.352-.62 3.47 3.47 0 0 0 .435-1.945 3.42 3.42 0 0 0-.444-1.953 1.51 1.51 0 0 0-1.334-.63c-1.195 0-1.787.861-1.787 2.583"
    }, null, -1)
  ]));
}
const sl = { render: H5 }, V5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I5(a, l) {
  return r(), n("svg", V5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.806 2.466a1.75 1.75 0 0 1 2.475 0l3.75 3.751a2.25 2.25 0 0 1 .624 1.994l-.545 2.992c-.06.33-.22.634-.457.872l-9.46 9.459a1.75 1.75 0 0 1-2.474 0L4.036 17.85a2.25 2.25 0 0 1-.654-1.732l.177-2.823a1.65 1.65 0 0 1 .48-1.063zm1.414 1.06a.25.25 0 0 0-.353 0L10.554 7.84l3.98 3.981a2.25 2.25 0 0 1 .649 1.816l-.088.875 3.497-3.497a.15.15 0 0 0 .042-.08l.545-2.992a.75.75 0 0 0-.208-.664zm-1.8 12.66.27-2.7a.75.75 0 0 0-.216-.605L9.494 8.9 5.1 13.293a.15.15 0 0 0-.044.096l-.177 2.823a.75.75 0 0 0 .218.578l3.683 3.682a.25.25 0 0 0 .353 0zm-.827-1.419a.75.75 0 0 1 0 1.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06l2.72-2.72a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vl = { render: I5 }, q5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L5(a, l) {
  return r(), n("svg", q5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.098 17.192a8 8 0 1 1 1.067-1.055l3.616 3.616a.75.75 0 1 1-1.06 1.061zM17.53 11a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ul = { render: L5 }, A5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y5(a, l) {
  return r(), n("svg", A5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 4.5H5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM19 4.5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5M15 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM19 14.5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5M15 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM9 14.5H5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5M5 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ml = { render: y5 }, k5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S5(a, l) {
  return r(), n("svg", k5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M17.536 9.227a.75.75 0 1 0-1.06-1.061l-6.078 6.077-2.873-2.873a.75.75 0 0 0-1.06 1.06l3.403 3.404a.75.75 0 0 0 1.06 0z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.444 2.75c-1.838 0-3.294 0-4.433.153-1.172.158-2.121.49-2.87 1.238-.748.749-1.08 1.698-1.238 2.87-.153 1.14-.153 2.595-.153 4.433v1.112c0 1.838 0 3.294.153 4.433.158 1.172.49 2.121 1.238 2.87.749.748 1.698 1.08 2.87 1.238 1.14.153 2.595.153 4.433.153h1.112c1.838 0 3.294 0 4.433-.153 1.172-.158 2.121-.49 2.87-1.238.748-.749 1.08-1.698 1.238-2.87.153-1.14.153-2.595.153-4.433v-1.112c0-1.838 0-3.294-.153-4.433-.158-1.172-.49-2.121-1.238-2.87-.749-.748-1.698-1.08-2.87-1.238-1.14-.153-2.595-.153-4.433-.153zM5.202 5.202c.423-.423 1.003-.677 2.009-.812 1.028-.138 2.382-.14 4.289-.14h1c1.907 0 3.262.002 4.29.14 1.005.135 1.585.389 2.008.812s.677 1.003.812 2.009c.138 1.028.14 2.382.14 4.289v1c0 1.907-.002 3.262-.14 4.29-.135 1.005-.389 1.585-.812 2.008s-1.003.677-2.009.812c-1.028.138-2.382.14-4.289.14h-1c-1.907 0-3.261-.002-4.29-.14-1.005-.135-1.585-.389-2.008-.812s-.677-1.003-.812-2.009c-.138-1.028-.14-2.382-.14-4.289v-1c0-1.907.002-3.261.14-4.29.135-1.005.389-1.585.812-2.008",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wl = { render: S5 }, D5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F5(a, l) {
  return r(), n("svg", D5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.016 6.924c0-.967.783-1.75 1.75-1.75h16.468c.967 0 1.75.783 1.75 1.75v10.152a1.75 1.75 0 0 1-1.75 1.75H3.766a1.75 1.75 0 0 1-1.75-1.75zm1.75-.25a.25.25 0 0 0-.25.25v10.152c0 .138.112.25.25.25h16.468a.25.25 0 0 0 .25-.25V6.924a.25.25 0 0 0-.25-.25zM17 15.25a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 .75.75M6 9.969a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 13.234a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const fl = { render: F5 }, T5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b5(a, l) {
  return r(), n("svg", T5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-10 8.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m1.079-7.41.301-2.293v-4.26a.25.25 0 0 0-.25-.25h-2.26a.25.25 0 0 0-.25.25v4.26l.301 2.293a.25.25 0 0 0 .248.217h1.662a.25.25 0 0 0 .248-.217m0 2.088q-.225-.24-.84-.24h-.463q-.615 0-.855.24-.225.225-.225.84v.614q0 .615.225.855.24.226.855.226h.463q.615 0 .84-.226.24-.24.24-.854v-.616q0-.615-.24-.84",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zl = { render: b5 }, E5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B5(a, l) {
  return r(), n("svg", E5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.636 9.41a.784.784 0 0 1-1.077-.067.72.72 0 0 1 .064-1.042A14.7 14.7 0 0 1 12 4.938a14.7 14.7 0 0 1 9.339 3.332c.32.262.342.736.066 1.043a.784.784 0 0 1-1.076.07A13.2 13.2 0 0 0 12 6.437 13.2 13.2 0 0 0 3.636 9.41m14.011 2.95c.329.255.804.234 1.082-.075.276-.307.254-.781-.07-1.037A10.7 10.7 0 0 0 12 8.938c-2.533 0-4.861.876-6.699 2.341-.321.257-.342.73-.067 1.035.279.31.756.33 1.085.073A9.2 9.2 0 0 1 12 10.437a9.2 9.2 0 0 1 5.647 1.924m-1.89 3.225c-.296.33-.811.32-1.162.05A4.23 4.23 0 0 0 12 14.75c-.991 0-1.904.34-2.626.909-.35.275-.87.287-1.168-.044-.254-.282-.255-.715.032-.964A5.73 5.73 0 0 1 12 13.25c1.419 0 2.718.514 3.72 1.366.292.248.293.685.037.97m-2.466 2.176c.187.158.17.438.003.617l-.949 1.017a.5.5 0 0 1-.731 0l-.93-.998c-.166-.177-.184-.452-.002-.612A2 2 0 0 1 12 17.289c.492 0 .943.177 1.29.472",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gl = { render: B5 }, P5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R5(a, l) {
  return r(), n("svg", P5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25zM9.057 4.5h3.574L4.5 12.631V9.057zm-2.122 0H5.75c-.69 0-1.25.56-1.25 1.25v1.185zm-1.183 9L13.5 5.752v3.77L9.521 13.5zm5.89 0h1.608a.25.25 0 0 0 .25-.25v-1.607zM4.75 15q-.127 0-.25-.018v3.268c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25h-3.268q.018.123.018.25v8.5A1.75 1.75 0 0 1 13.25 15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pl = { render: R5 }, U5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O5(a, l) {
  return r(), n("svg", U5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.623 2.084a.75.75 0 0 1 .751 0l8.251 4.771a.75.75 0 0 1 0 1.299l-2.882 1.665 2.856 1.503a.75.75 0 0 1 .026 1.313l-2.796 1.617 2.787 1.558a.75.75 0 0 1 .01 1.303l-8.252 4.772a.75.75 0 0 1-.751 0l-8.249-4.772a.75.75 0 0 1 .017-1.307l2.814-1.534-2.83-1.637a.75.75 0 0 1 .016-1.308l2.817-1.535-2.833-1.638a.75.75 0 0 1 0-1.299zm-3.895 8.587-2.447 1.334L12 15.891l6.7-3.874-2.491-1.31-3.834 2.215a.75.75 0 0 1-.75 0zm-.003 4.48-2.443 1.333 6.717 3.885 6.733-3.894-2.414-1.349-3.944 2.28a.75.75 0 0 1-.751 0zM12 3.6l-6.75 3.904 6.75 3.903 6.752-3.903z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ml = { render: O5 }, G5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N5(a, l) {
  return r(), n("svg", G5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5m0 14a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 19m0-7a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const xl = { render: N5 }, Q5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z5(a, l) {
  return r(), n("svg", Q5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17 3.688H5a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h7.5v.678q0 .422.08.822H5a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v3.927a4.2 4.2 0 0 0-1.5-.47V5.188a1.5 1.5 0 0 0-1.5-1.5m3.75 10.928H21a1 1 0 0 1 1 1v3.75a2.75 2.75 0 0 1-2.75 2.75h-2.5a2.75 2.75 0 0 1-2.75-2.75v-3.75a1 1 0 0 1 1-1h.25v-1.75a2.75 2.75 0 0 1 5.5 0zm-1.5 0v-1.75a1.25 1.25 0 0 0-2.5 0v1.75zm-3.75 4.75v-3.25h5v3.25c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25m2.5-2.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _l = { render: Z5 }, W5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j5(a, l) {
  return r(), n("svg", W5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M5.794 19.476a.75.75 0 0 0 1.412.508zM12 4.27l.706-.253a.75.75 0 0 0-1.413.003zm4.793 15.709a.75.75 0 0 0 1.415-.498zM15.449 13.9l.707-.249-.001-.004zm-4.155-9.378 3.449 9.63 1.412-.505-3.449-9.63zm3.447 9.627 2.052 5.829 1.415-.498-2.052-5.829zm-7.535 5.833 2.096-5.828-1.412-.508-2.096 5.829zm2.097-5.832 3.404-9.63-1.414-.5-3.404 9.63zm6.146-1H8.596v1.5h6.853z"
    }, null, -1)
  ]));
}
const $l = { render: j5 }, K5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J5(a, l) {
  return r(), n("svg", K5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.664 4.498c-2.229.113-4.577.976-6.26 2.423-1.67 1.436-2.72 3.533-3.05 5.647-.331 2.124.077 4.164 1.184 5.537.695.862 1.917 1.445 3.066 1.408a2.66 2.66 0 0 0 1.534-.515c.443-.331.847-.861 1.114-1.68.294-.909.707-2.088 1.539-3.096.855-1.036 2.115-1.85 4.015-2.102 1.657-.22 2.513-1.183 2.82-2.3.321-1.17.04-2.528-.68-3.435-1.078-1.355-3.038-2.001-5.282-1.887M13.588 3c2.512-.128 5.04.576 6.531 2.451 1.026 1.29 1.399 3.143.953 4.766-.46 1.677-1.792 3.089-4.07 3.39-1.526.203-2.442.828-3.054 1.57-.635.768-.978 1.704-1.27 2.604-.348 1.073-.918 1.877-1.642 2.419a4.16 4.16 0 0 1-2.384.813c-1.63.051-3.298-.745-4.282-1.966-1.443-1.79-1.875-4.295-1.498-6.71.377-2.422 1.582-4.857 3.554-6.553C8.386 4.098 11.062 3.128 13.588 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cl = { render: J5 }, X5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y5(a, l) {
  return r(), n("svg", X5, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m15.14 3.736.047.013.049.013c1.666.446 2.982.799 3.978 1.196 1.018.405 1.81.895 2.337 1.683.539.804.643 1.679.533 2.681-.105.956-.418 2.123-.804 3.566l-.016.06-.026.096c-.377 1.407-.643 2.401-.99 3.109q-.178.364-.393.644c.04-.74.04-1.667.04-2.869q.001-.888-.005-1.649c.366-1.369.618-2.344.703-3.12.087-.796-.014-1.274-.288-1.683-.285-.425-.753-.77-1.646-1.125-.904-.36-2.134-.69-3.86-1.153-1.725-.462-2.956-.79-3.92-.931-.95-.139-1.528-.075-1.987.15-.42.208-.737.547-1.044 1.21-.599.01-1.144.025-1.641.054q.108-.293.221-.554c.406-.923.934-1.628 1.802-2.055.851-.419 1.782-.448 2.866-.29 1.061.155 2.377.507 4.043.954m-4.795 2.777h.1c1.725 0 3.087 0 4.152.125 1.088.128 1.98.397 2.693 1.022.728.637 1.056 1.455 1.209 2.451.146.95.146 2.158.146 3.652v.163c0 1.456 0 2.486-.152 3.258-.173.884-.545 1.46-1.203 2.035-.713.625-1.605.894-2.693 1.022-1.065.125-2.427.125-4.152.125h-.1c-1.726 0-3.088 0-4.153-.125-1.087-.128-1.98-.397-2.693-1.022-.658-.575-1.03-1.151-1.203-2.035-.151-.773-.151-1.802-.151-3.258v-.163c0-1.494 0-2.701.146-3.652.153-.996.48-1.814 1.208-2.451.714-.625 1.606-.894 2.693-1.022 1.065-.125 2.427-.125 4.153-.125m.059 3.368c.382-.463.992-1.044 1.93-1.044.789 0 1.367.613 1.712 1.17.377.609.649 1.409.758 2.26.216 1.691-.193 3.813-2.036 5.12-.94.665-2.03.752-2.998.577-.963-.174-1.868-.615-2.542-1.1-.825-.594-1.21-1.54-1.282-2.44-.072-.895.154-1.856.692-2.572.31-.412.657-.705 1.083-.825.405-.113.768-.032.973.014l.009.002c.238.053.336.074.448.064.086-.008.237-.041.484-.235.049-.039.13-.13.278-.332l.095-.132a10 10 0 0 1 .396-.527m.157 2.17c.233-.183.424-.436.563-.627l.126-.174c.106-.148.202-.282.312-.415.299-.363.525-.498.772-.498q-.006 0 .002.002c.03.012.2.08.435.459.247.398.458.986.545 1.659.173 1.356-.177 2.828-1.415 3.705-.518.367-1.163.453-1.864.326-.707-.128-1.407-.463-1.933-.841-.374-.27-.615-.754-.663-1.342-.047-.592.113-1.175.396-1.551.1-.133.174-.204.222-.242.044-.034.068-.04.068-.04.009-.003.04-.012.249.035l.049.011c.188.043.504.116.863.083.42-.038.838-.208 1.273-.55m2.043.301c0 .389-.238.703-.532.703-.293 0-.531-.314-.531-.703s.238-.703.531-.703.532.315.532.703m-2.994.473a.75.75 0 0 1 .622-.168c.36.066.623.274.793.456.173.185.302.396.394.572a4 4 0 0 1 .263.63c.1.31.028.66-.24.868-.268.21-.62.195-.9.018a3.349 3.349 0 0 1-.511-.403 1.22 1.22 0 0 1-.608.463c-.537.195-1.091.024-1.238-.381-.148-.406.168-.893.705-1.088.167-.06.336-.085.494-.08a1.6 1.6 0 0 1-.036-.298.75.75 0 0 1 .262-.589",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hl = { render: Y5 }, l2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e2(a, l) {
  return r(), n("svg", l2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.017 2.016v19.949h-1.5V2.015z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 10.531H2.033v-1.5H22z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.62 4.065c1.857-.018 4.613.695 5.933 2.002a6.87 6.87 0 0 1 2.05 4.914.75.75 0 0 1-.083.342l-.578 1.13 1.95 3.184.024.06c.126.313.087.669-.102.948l-.621-.42.622.418c-.19.282-.507.45-.844.45h-1.316v1.93c0 .858-.697 1.555-1.554 1.555h-1.52v1.387h-1.5v-2.137a.75.75 0 0 1 .75-.75h2.27a.05.05 0 0 0 .038-.016.05.05 0 0 0 .016-.038v-2.681a.75.75 0 0 1 .75-.75h1.201l-1.663-2.715a.75.75 0 0 1-.028-.733l.685-1.34a5.37 5.37 0 0 0-1.602-3.672c-1.036-1.026-3.407-1.582-4.864-1.568-2.97.029-5.383 2.496-5.363 5.513.012 1.621.297 2.785.65 3.657.33.817.727 1.398 1.078 1.912l.077.112a.75.75 0 0 1 .13.422v4.784h-1.5v-4.552c-.347-.507-.8-1.188-1.176-2.116-.427-1.055-.746-2.407-.759-4.209-.026-3.83 3.038-6.986 6.848-7.023",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Vl = { render: e2 }, n2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r2(a, l) {
  return r(), n("svg", n2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.497 10.22a.75.75 0 0 1 .75-.75h11.506a.75.75 0 0 1 .75.75v6.6c0 1.256-.535 2.45-1.468 3.32a5.1 5.1 0 0 1-3.48 1.35h-3.11c-1.296 0-2.549-.48-3.48-1.35-.933-.87-1.468-2.064-1.468-3.32zm1.5.75v5.85c0 .824.35 1.625.991 2.224.644.601 1.527.947 2.458.947h3.108c.93 0 1.814-.346 2.458-.947.641-.599.991-1.4.991-2.224v-5.85z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 4a3.14 3.14 0 0 0-3.135 3.296v2.608a.75.75 0 1 1-1.5 0V7.31a4.638 4.638 0 1 1 9.27 0v2.593a.75.75 0 1 1-1.5 0V7.266A3.14 3.14 0 0 0 12 3.999",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M13.529 14.609a1.53 1.53 0 1 0-2.176 1.378v1.248a.653.653 0 0 0 1.307 0v-1.248a1.52 1.52 0 0 0 .869-1.379"
    }, null, -1)
  ]));
}
const Il = { render: r2 }, a2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t2(a, l) {
  return r(), n("svg", a2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.719 3.438c-.69 0-1.25.56-1.25 1.25V17.28c0 .69.56 1.25 1.25 1.25h6.675a5.5 5.5 0 0 1-.356-1.688h-.054a3.25 3.25 0 1 1 2.734-5.008 5.5 5.5 0 0 1 2.813-.773c.67 0 1.313.12 1.907.34v-3.31c0-.28-.095-.552-.268-.772L15.49 3.915a1.2 1.2 0 0 0-.267-.245l.035 3.354v.007a1.75 1.75 0 0 1-1.75 1.75H7.688a1.75 1.75 0 0 1-1.75-1.75V3.437zm15.218 8.806V8.093a2.75 2.75 0 0 0-.588-1.7l-2.68-3.406c-.53-.675-1.373-1.05-2.2-1.05H4.718a2.75 2.75 0 0 0-2.75 2.75v12.594a2.75 2.75 0 0 0 2.75 2.75h7.545a5.5 5.5 0 1 0 7.675-7.787m-7.401.539a1.75 1.75 0 1 0-1.367 2.551 5.5 5.5 0 0 1 1.367-2.551M7.438 3.438V7.03c0 .138.111.25.25.25h5.82a.25.25 0 0 0 .25-.247l-.036-3.596zm12.17 11.32a.75.75 0 0 1 0 1.061l-3.125 3.125a.75.75 0 0 1-1.06 0l-1.969-1.968a.75.75 0 0 1 1.06-1.061l1.44 1.438 2.594-2.594a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ql = { render: t2 }, o2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c2(a, l) {
  return r(), n("svg", o2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M20.719 10.997q0 1.548-.48 2.835t-1.352 1.996a3.1 3.1 0 0 1-2.007.709q-.937 0-1.581-.567a2.28 2.28 0 0 1-.763-1.45h-.088a3.44 3.44 0 0 1-1.254 1.482q-.807.535-1.92.535-1.635 0-2.562-1.113-.915-1.124-.916-3.042 0-2.225 1.287-3.61 1.287-1.395 3.38-1.396.742 0 1.68.142.498.07.945.17c.444.1.728.518.704.972l-.231 4.354v.24q0 1.941 1.45 1.941.993 0 1.614-1.167.622-1.178.622-3.053 0-1.974-.807-3.457a5.5 5.5 0 0 0-2.302-2.28q-1.482-.806-3.413-.806-2.431 0-4.231 1.014-1.8 1.003-2.748 2.879-.95 1.865-.949 4.318 0 3.327 1.756 5.115 1.755 1.788 5.06 1.788 2.13 0 4.414-.812a.254.254 0 0 1 .34.237v.761c0 .199-.117.38-.301.453q-1.982.79-4.453.79-3.96 0-6.15-2.17-2.182-2.18-2.182-6.085 0-2.835 1.167-5.05a8.25 8.25 0 0 1 3.326-3.424q2.16-1.221 4.951-1.221 2.345 0 4.166.992a6.8 6.8 0 0 1 2.825 2.803q1.002 1.811 1.003 4.177M9.443 12.425q0 2.77 2.126 2.77 2.257 0 2.454-3.413l.131-2.445a.47.47 0 0 0-.369-.495 6.7 6.7 0 0 0-1.322-.125q-1.417 0-2.224.982-.795.981-.796 2.726"
    }, null, -1)
  ]));
}
const Ll = { render: c2 }, i2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d2(a, l) {
  return r(), n("svg", i2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 4.563a.25.25 0 0 0-.25.25v14.375c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25V9.342h-2.904c-.69 0-1.25-.56-1.25-1.25v-3.53zm7.596 1.256 1.759 2.023h-1.759zM5.25 4.813c0-.967.784-1.75 1.75-1.75h6.846a.75.75 0 0 1 .566.258L18.566 8.1a.75.75 0 0 1 .184.492v10.596a1.75 1.75 0 0 1-1.75 1.75H7a1.75 1.75 0 0 1-1.75-1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Al = { render: d2 }, h2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s2(a, l) {
  return r(), n("svg", h2, l[0] || (l[0] = [
    t('<path fill="currentColor" fill-rule="evenodd" d="M4.8 8.173a.35.35 0 0 0-.237.096.3.3 0 0 0-.065.097.3.3 0 0 0-.02.109v8.516c0 .072.03.145.088.202.059.057.143.093.235.093h1.022a.75.75 0 0 1 0 1.5H4.8c-.477 0-.939-.184-1.282-.519a1.78 1.78 0 0 1-.541-1.276V8.498a1.77 1.77 0 0 1 .527-1.292A1.83 1.83 0 0 1 4.8 6.672h1.022a.75.75 0 1 1 0 1.5zM8.874 18.036a.75.75 0 0 1 .75-.75h5.336a.75.75 0 0 1 0 1.5H9.624a.75.75 0 0 1-.75-.75" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M8.874 7.423a.75.75 0 0 1 .75-.75h9.621a1.85 1.85 0 0 1 1.271.546 1.8 1.8 0 0 1 .514 1.28v8.492c0 .482-.197.94-.541 1.276-.344.335-.805.52-1.283.52h-5.08a.75.75 0 0 1 0-1.5h5.08a.34.34 0 0 0 .236-.094.28.28 0 0 0 .087-.203V8.475a.3.3 0 0 0-.019-.107.3.3 0 0 0-.063-.096.347.347 0 0 0-.227-.098H9.624a.75.75 0 0 1-.75-.75" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M12.8 10.237v.513h4.43v-.513zm-1.5-.294c0-.684.563-1.206 1.217-1.206h4.994c.655 0 1.218.522 1.218 1.206v1.101c0 .684-.563 1.206-1.218 1.206h-4.994a1.21 1.21 0 0 1-1.218-1.206zM6.69 7.138c-.083 0-.117.061-.117.096V18.43c0 .035.034.096.117.096h2.066c.083 0 .118-.061.118-.096V7.234c0-.035-.035-.096-.118-.096zm-1.617.096c0-.9.742-1.596 1.617-1.596h2.066c.875 0 1.618.697 1.618 1.596V18.43c0 .9-.743 1.596-1.618 1.596H6.69c-.875 0-1.617-.697-1.617-1.596zM12.52 5.392v2.031a.75.75 0 0 1-1.5 0V5.337c0-.39.159-.76.435-1.029a1.47 1.47 0 0 1 1.028-.416h5.034c.382 0 .752.147 1.028.416.276.27.435.64.435 1.029v2.086a.75.75 0 0 1-1.5 0V5.392zM13.8 13.586a.75.75 0 0 1 .75-.75h.935a.75.75 0 0 1 0 1.5h-.936a.75.75 0 0 1-.75-.75" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M11.322 13.586a.75.75 0 0 1 .75-.75h.936a.75.75 0 0 1 0 1.5h-.936a.75.75 0 0 1-.75-.75M16.282 13.586a.75.75 0 0 1 .75-.75h.93a.75.75 0 0 1 0 1.5h-.93a.75.75 0 0 1-.75-.75M13.8 15.41a.75.75 0 0 1 .75-.75h.935a.75.75 0 0 1 0 1.5h-.936a.75.75 0 0 1-.75-.75" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M11.322 15.41a.75.75 0 0 1 .75-.75h.936a.75.75 0 0 1 0 1.5h-.936a.75.75 0 0 1-.75-.75M16.282 15.41a.75.75 0 0 1 .75-.75h.93a.75.75 0 0 1 0 1.5h-.93a.75.75 0 0 1-.75-.75" clip-rule="evenodd"></path>', 5)
  ]));
}
const yl = { render: s2 }, v2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u2(a, l) {
  return r(), n("svg", v2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.5 19V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5M21 5v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.75 3.25v17.5h-1.5V3.25zM15.75 3.25v17.5h-1.5V3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kl = { render: u2 }, m2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w2(a, l) {
  return r(), n("svg", m2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "m6.3 20.568.24-1.176h.312q.768 0 1.392-.264.648-.264.864-1.272l2.496-11.688a3.2 3.2 0 0 0 .096-.696q0-.552-.504-.696-.48-.168-1.224-.168H9.66l.24-1.176h7.8l-.264 1.176h-.312q-.792 0-1.44.264t-.84 1.296l-2.496 11.76a4 4 0 0 1-.072.336q-.024.168-.024.264 0 .552.48.72.504.144 1.272.144h.312l-.24 1.176z"
    }, null, -1)
  ]));
}
const Sl = { render: w2 }, f2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function z2(a, l) {
  return r(), n("svg", f2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.688 18.375a2.75 2.75 0 0 0-5.396-.75h-2.854c-.964 0-1.612-.002-2.095-.067-.461-.062-.659-.169-.789-.3s-.237-.327-.3-.788c-.064-.483-.066-1.131-.066-2.095v-2h6.041a2.751 2.751 0 1 0 0-1.5h-6.04V8.27a2.751 2.751 0 1 0-1.5 0v3.364l-.001 2.792c0 .898 0 1.648.08 2.242.084.628.27 1.195.725 1.65.456.456 1.023.642 1.65.726.595.08 1.345.08 2.243.08h2.906a2.751 2.751 0 0 0 5.396-.75m-2.75-1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m1.188-5.5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-9.438-6a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dl = { render: z2 }, g2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function p2(a, l) {
  return r(), n("svg", g2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.686 15.96c-.322 0-.619 0-.864.026-.267.027-.555.09-.825.27a1.8 1.8 0 0 0-.483.483c-.18.27-.243.558-.27.824a4 4 0 0 0-.016.226h-.197c-.964 0-1.612-.002-2.095-.067-.461-.062-.659-.169-.789-.3s-.238-.327-.3-.788c-.065-.483-.066-1.131-.066-2.095v-2h3.452l.011.132c.027.266.09.555.27.825.128.19.292.355.483.482.27.18.558.243.825.27.245.025.542.025.864.025h4.566c.323 0 .62 0 .865-.024.266-.028.555-.09.824-.27.192-.128.356-.292.483-.483.18-.27.243-.559.27-.825.025-.246.025-.542.025-.865v-.066c0-.322 0-.619-.025-.864-.027-.266-.09-.555-.27-.825a1.8 1.8 0 0 0-.483-.483c-.27-.18-.558-.243-.824-.27-.246-.025-.542-.025-.865-.025h-4.566c-.322 0-.619 0-.864.025-.267.027-.555.09-.825.27a1.8 1.8 0 0 0-.483.483c-.18.27-.243.559-.27.825q-.008.078-.013.163h-3.45V8.435a2.751 2.751 0 1 0-1.5 0v6.156c0 .898 0 1.648.08 2.243.084.627.27 1.194.725 1.65.456.455 1.023.64 1.65.725.595.08 1.344.08 2.243.08h.259l.006.07c.027.266.09.554.27.824.128.191.292.355.483.483.27.18.558.243.825.27.245.025.541.025.864.025h4.566c.323 0 .62 0 .865-.025.266-.027.555-.09.824-.27.192-.128.356-.292.483-.483.18-.27.243-.558.27-.825.025-.245.025-.541.025-.864v-.066c0-.323 0-.62-.025-.865-.027-.266-.09-.554-.27-.824a1.8 1.8 0 0 0-.483-.483c-.27-.18-.558-.243-.824-.27a9 9 0 0 0-.865-.025zm-.713 1.518a.6.6 0 0 0-.146.027.3.3 0 0 0-.064.065.6.6 0 0 0-.027.145c-.016.16-.017.38-.017.746 0 .367.001.585.017.745.01.096.022.135.027.146a.3.3 0 0 0 .065.065c.01.005.05.017.146.027.16.016.378.017.745.017h4.5c.367 0 .585-.001.746-.017a.6.6 0 0 0 .146-.027.3.3 0 0 0 .064-.065.6.6 0 0 0 .027-.146c.016-.16.017-.378.017-.745s0-.585-.017-.746a.6.6 0 0 0-.027-.145.3.3 0 0 0-.064-.065.6.6 0 0 0-.146-.027 8 8 0 0 0-.746-.017h-4.5c-.367 0-.585 0-.745.017m-.21.091.002-.003-.001.001zm.061 1.846h.001l.003.002zm.003-8.597a.6.6 0 0 1 .146-.027c.16-.017.38-.018.746-.018h4.5c.367 0 .585.001.746.018.095.01.134.022.146.026a.3.3 0 0 1 .064.065c.005.011.017.05.027.146.016.16.017.379.017.745 0 .367 0 .586-.017.746a.6.6 0 0 1-.027.146.3.3 0 0 1-.064.065.6.6 0 0 1-.146.026c-.16.017-.38.017-.746.017h-4.5c-.367 0-.585 0-.745-.017a.6.6 0 0 1-.146-.027.3.3 0 0 1-.065-.064.6.6 0 0 1-.027-.146 8 8 0 0 1-.017-.746c0-.366.001-.585.017-.745a.6.6 0 0 1 .027-.146.3.3 0 0 1 .064-.064m6.284 0h.003-.003M8.28 5.788a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fl = { render: p2 }, M2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x2(a, l) {
  return r(), n("svg", M2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.452 5.083a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5m0-1.5a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5m5.213 8.06a4.25 4.25 0 1 0 0-7.622 4.25 4.25 0 0 1 0 7.623",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M16.974 20.417v-3.9290000000000003c0-.67-.163-1.325-.47-1.926a4.7 4.7 0 0 0-.53-.813h1.657c.554-.001 1.105.087 1.623.26s.997.43 1.408.764c.41.332.747.736.98 1.193.234.457.358.955.358 1.464v2.237a.75.75 0 0 1-.75.75h-4.276M10.535 13.749c.553-.001 1.105.087 1.623.26s.997.43 1.408.764c.41.332.747.736.98 1.193.234.457.358.955.358 1.464v2.237a.75.75 0 0 1-.747.75h-.006a.75.75 0 0 1-.747-.75V17.43c0-.526-.26-1.07-.783-1.492-.523-.424-1.293-.69-2.085-.69H6.362c-.804 0-1.551.261-2.082.692-.526.427-.78.968-.78 1.49v2.237a.75.75 0 1 1-1.5 0V17.43c0-1.033.507-1.983 1.335-2.655.824-.67 1.915-1.026 3.027-1.026z"
    }, null, -1)
  ]));
}
const Tl = { render: x2 }, _2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $2(a, l) {
  return r(), n("svg", _2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.386 4.76a1.5 1.5 0 1 1 2.82-1.025l.302.831A5.75 5.75 0 0 1 15.4 8.33l1.517 4.17 2.228.96a.75.75 0 0 1 .407.432l.394 1.08a.75.75 0 0 1-.448.962L6.342 20.722a.75.75 0 0 1-.962-.448l-.393-1.08a.75.75 0 0 1 .035-.594l1.089-2.167-1.518-4.17a5.75 5.75 0 0 1 2.095-6.67zm2.158 1.543a4.25 4.25 0 0 0-2.54 5.447l1.628 4.474a.75.75 0 0 1-.035.593l-1.089 2.168.027.071 11.746-4.275-.026-.072-2.228-.96a.75.75 0 0 1-.408-.432l-1.628-4.474a4.25 4.25 0 0 0-5.447-2.54m5.408 14.859a2 2 0 0 1-2.563-1.195l3.758-1.368a2 2 0 0 1-1.195 2.563",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bl = { render: $2 }, C2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H2(a, l) {
  return r(), n("svg", C2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0m1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0M9.03 7.97a.75.75 0 0 0-1.06 1.06L10.94 12l-2.97 2.97a.75.75 0 1 0 1.06 1.06L12 13.06l2.97 2.97a.75.75 0 1 0 1.06-1.06L13.06 12l2.97-2.97a.75.75 0 0 0-1.06-1.06L12 10.94z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const El = { render: H2 }, V2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I2(a, l) {
  return r(), n("svg", V2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.013 3.047c.199 0 .39.079.53.22l2.606 2.607a.75.75 0 1 1-1.061 1.06L12.763 5.61v5.621h5.631l-1.326-1.327a.75.75 0 0 1 1.06-1.06l2.606 2.607a.75.75 0 0 1 0 1.06l-2.605 2.608a.75.75 0 1 1-1.062-1.06l1.327-1.328h-5.631v5.661l1.325-1.326a.75.75 0 0 1 1.06 1.06l-2.605 2.608a.75.75 0 0 1-1.06 0l-2.606-2.607a.75.75 0 0 1 1.06-1.06l1.326 1.325v-5.66H5.607l1.326 1.327a.75.75 0 0 1-1.061 1.06L3.266 12.51a.75.75 0 0 1 0-1.06l2.606-2.607a.75.75 0 1 1 1.061 1.06L5.607 11.23h5.656V5.61L9.938 6.935a.75.75 0 1 1-1.061-1.06l2.605-2.608a.75.75 0 0 1 .53-.22"
    }, null, -1)
  ]));
}
const Bl = { render: I2 }, q2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L2(a, l) {
  return r(), n("svg", q2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 4.813a2.75 2.75 0 0 1 2.75-2.75h2.875a.75.75 0 0 1 0 1.5H4.75c-.69 0-1.25.56-1.25 1.25v2.875a.75.75 0 0 1-1.5 0zm19.938 0a2.75 2.75 0 0 0-2.75-2.75h-2.875a.75.75 0 0 0 0 1.5h2.875c.69 0 1.25.56 1.25 1.25v2.875a.75.75 0 0 0 1.5 0zM4.75 22A2.75 2.75 0 0 1 2 19.25v-2.875a.75.75 0 0 1 1.5 0v2.875c0 .69.56 1.25 1.25 1.25h2.875a.75.75 0 0 1 0 1.5zm17.188-2.75a2.75 2.75 0 0 1-2.75 2.75h-2.875a.75.75 0 0 1 0-1.5h2.875c.69 0 1.25-.56 1.25-1.25v-2.875a.75.75 0 0 1 1.5 0zM6.858 8.648a1 1 0 0 0-1 1v6.22a1 1 0 0 0 1 1h10.282a1 1 0 0 0 1-1v-6.22a1 1 0 0 0-1-1h-1.889a.5.5 0 0 1-.351-.144l-1.097-1.083a1 1 0 0 0-.703-.288H10.93a1 1 0 0 0-.703.288L9.13 8.504a.5.5 0 0 1-.35.144zM12 15.375a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M8.375 10.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Pl = { render: L2 }, A2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y2(a, l) {
  return r(), n("svg", A2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m10.528 3.93.059-.046c.511-.388.933-.663 1.178-.815a.45.45 0 0 1 .472-.004c.681.409 2.702 1.73 4.326 3.894C18.82 9.97 19 11.711 19 13.46c0 3.866-3.134 7.5-7 7.5s-7-3.634-7-7.5c0-1.748.281-3.5 2.5-6.5.975-1.318 2.132-2.343 3.028-3.03M12 19.46V4.71l.012-.008c.832.565 2.208 1.634 3.35 3.157 1.058 1.41 1.573 2.45 1.836 3.278.26.816.302 1.511.302 2.322 0 3.174-2.592 6-5.5 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rl = { render: y2 }, k2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S2(a, l) {
  return r(), n("svg", k2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M9.417 15.127q.96 1.07 2.797 1.07.747 0 1.267-.117.386-.087.737-.254a.46.46 0 0 0 .252-.42v-.79c0-.191-.206-.313-.38-.236q-.856.381-1.795.381-1.011 0-1.538-.68-.52-.69-.52-2.052 0-2.79 2.102-2.79.632 0 1.565.336a.255.255 0 0 0 .326-.148l.35-.93a.24.24 0 0 0-.132-.31q-.944-.384-2.094-.384-1.89 0-2.894 1.099-.996 1.098-.996 3.142 0 2.007.952 3.083",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ul = { render: S2 }, D2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F2(a, l) {
  return r(), n("svg", D2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.883 4H17.75l-2.612 3.246a2 2 0 0 0 0 2.508L17.75 13H5.383V4.5a.5.5 0 0 1 .5-.5m-2 2.25V4.5a2 2 0 0 1 2-2h13.434c.63 0 .98.73.584 1.22l-3.595 4.466a.5.5 0 0 0 0 .628l3.595 4.466a.75.75 0 0 1-.584 1.22H5.383v6.25a.75.75 0 0 1-1.5 0V6.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ol = { render: F2 }, T2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b2(a, l) {
  return r(), n("svg", T2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M4.296 15.987 2.883 9.933H2.84q.1 1.27.1 1.977v4.076H1.283V8h2.686l1.245 5.313h.05L6.406 8h2.766v7.986H7.457V11.36c0-.192.023-.673.064-1.413h-.044l-1.402 6.04zM15.669 10.2a2.3 2.3 0 0 1-.673 1.788 2.76 2.76 0 0 1-1.94.633h-.538v3.365h-1.873V8h2.394q1.311-.002 1.967.572a2.04 2.04 0 0 1 .663 1.627m-3.151.897h.336a.93.93 0 0 0 .673-.235.85.85 0 0 0 .249-.653q0-.701-.777-.702h-.481zM18.638 12.399v3.588h-1.87V8h2.284q2.818 0 2.818 2.041a2.04 2.04 0 0 1-1.17 1.86L22.718 16h-1.812l-1.793-3.601zm0-1.406h.337q.978-.001.978-.864 0-.717-.958-.717h-.37z"
    }, null, -1)
  ]));
}
const Gl = { render: b2 }, E2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B2(a, l) {
  return r(), n("svg", E2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.591 10.884a.76.76 0 0 1 1.067.006.74.74 0 0 1-.006 1.055l-1.43 1.397a.76.76 0 0 1-1.068-.006L1.74 11.922a.74.74 0 0 1 .006-1.055.76.76 0 0 1 1.067.007l.156.155V9.271a5.39 5.39 0 0 1 4.179-5.252.75.75 0 1 1 .336 1.462 3.89 3.89 0 0 0-3.015 3.79v1.732zM8.934 9.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5m-1.5 5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2zm10.908-1.39a.76.76 0 0 0 1.067.006l.122-.12v1.733a3.89 3.89 0 0 1-3.015 3.79.75.75 0 0 0 .336 1.462 5.39 5.39 0 0 0 4.18-5.252v-1.758l.155.155a.76.76 0 0 0 1.067.007.74.74 0 0 0 .006-1.055l-1.414-1.414a.76.76 0 0 0-1.067-.006l-1.43 1.398a.74.74 0 0 0-.007 1.054",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nl = { render: B2 }, P2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R2(a, l) {
  return r(), n("svg", P2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.997 10.283a.75.75 0 0 1 .75-.75h12.506a.75.75 0 0 1 .75.75v6.6c0 1.256-.535 2.45-1.468 3.32a5.1 5.1 0 0 1-3.48 1.35h-4.11c-1.296 0-2.549-.48-3.48-1.35-.933-.87-1.468-2.064-1.468-3.32zm1.5.75v5.85c0 .823.35 1.625.991 2.224.644.6 1.527.947 2.458.947h4.108c.93 0 1.814-.346 2.458-.947.641-.6.991-1.4.991-2.224v-5.85z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.874 3.937A3.14 3.14 0 0 0 8.94 5.964a.75.75 0 1 1-1.403-.532 4.638 4.638 0 0 1 8.972 1.817V9.84a.75.75 0 0 1-1.5 0V7.204a3.14 3.14 0 0 0-3.135-3.267",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M13.529 14.671a1.53 1.53 0 1 0-2.176 1.379v1.248a.653.653 0 0 0 1.307 0V16.05a1.52 1.52 0 0 0 .869-1.379"
    }, null, -1)
  ]));
}
const Ql = { render: R2 }, U2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O2(a, l) {
  return r(), n("svg", U2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.485 4.19A9.355 9.355 0 1 1 5.63 18.202a.75.75 0 0 1 1.123-.994 7.855 7.855 0 1 0-1.538-7.79.75.75 0 1 1-1.417-.493A9.36 9.36 0 0 1 7.485 4.19",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.434 5.887a.75.75 0 0 1 .997.362l1.23 2.637 2.637-1.23a.75.75 0 1 1 .634 1.36l-3.316 1.547a.75.75 0 0 1-.997-.363L2.07 6.883a.75.75 0 0 1 .363-.996",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zl = { render: O2 }, G2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N2(a, l) {
  return r(), n("svg", G2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.752 3.75a.75.75 0 0 0-1.5 0v.835a.75.75 0 1 0 1.5 0zM3.003 12a.75.75 0 0 1 .75-.75h.835a.75.75 0 0 1 0 1.5h-.835a.75.75 0 0 1-.75-.75M18.667 12a.75.75 0 0 1 .75-.75h.835a.75.75 0 0 1 0 1.5h-.835a.75.75 0 0 1-.75-.75M12.002 18.665a.75.75 0 0 1 .75.75v.835a.75.75 0 0 1-1.5 0v-.835a.75.75 0 0 1 .75-.75M18.737 7.188a.75.75 0 0 0-.977-1.138l-.635.545a.75.75 0 1 0 .978 1.138zM6.946 16.348a.75.75 0 0 1-.08 1.057l-.635.545a.75.75 0 0 1-.977-1.138l.634-.545a.75.75 0 0 1 1.058.08M18.092 16.286a.75.75 0 0 0-.983 1.133l.632.548a.75.75 0 1 0 .982-1.133zM5.192 6.108a.75.75 0 0 1 1.058-.075l.632.548a.75.75 0 0 1-.983 1.133l-.631-.548a.75.75 0 0 1-.076-1.058"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.002 6.167a5.833 5.833 0 1 0 0 11.666 5.833 5.833 0 0 0 0-11.666m0 1.5a4.333 4.333 0 0 0 0 8.666z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wl = { render: N2 }, Q2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z2(a, l) {
  return r(), n("svg", Q2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.238 3.357a1 1 0 0 0-.777-.373H5.486a1 1 0 0 0-.786.385L3.212 5.276A1 1 0 0 0 3 5.89v14.125a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5.899a1 1 0 0 0-.221-.627zm-.088 2.284-.93-1.157H5.731L4.83 5.641zm.35 1.5h-15v12.375h15zm-4.222 5.766a.75.75 0 0 1 0 1.06l-2.788 2.789a.75.75 0 0 1-1.06 0l-2.788-2.788a.75.75 0 1 1 1.06-1.06l1.508 1.507V9.868a.75.75 0 0 1 1.5 0v4.547l1.507-1.508a.75.75 0 0 1 1.061 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const jl = { render: Z2 }, W2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j2(a, l) {
  return r(), n("svg", W2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.508 4.578v4.994a4.5 4.5 0 0 0 2.047 3.773l1.18.767a.5.5 0 0 0 .545 0l1.18-.767a4.5 4.5 0 0 0 2.048-3.773V4.578zm5.77 10.025a6 6 0 0 0 2.396-3.056h1.209a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-.875v-.469a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v.469h-.89a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1.224a6 6 0 0 0 2.396 3.056l1.18.767a2 2 0 0 0 .326.171v3.88H8.758a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-2.514v-3.869a2 2 0 0 0 .354-.182zm2.73-5.031V6.047h.875a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.875zM6.118 6.047h.874v4h-.875a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Kl = { render: j2 }, K2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J2(a, l) {
  return r(), n("svg", K2, l[0] || (l[0] = [
    e("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.403 3.5H8.769l-2.925 9.82h3.758l-1 7.18 9.554-10.484h-4.991z"
    }, null, -1)
  ]));
}
const Jl = { render: J2 }, X2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y2(a, l) {
  return r(), n("svg", X2, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.25 6.719a3.75 3.75 0 1 1 7.5 0 .75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75m5.872-.75a2.251 2.251 0 0 0-4.244 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M9.491 15.201a.75.75 0 0 1 .75-.75h3.5a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75M10.241 11.514a.75.75 0 1 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.162 6.834a.75.75 0 1 0-.86 1.228L6.5 9.602V13H3.75a.75.75 0 0 0 0 1.5H6.5c0 1.099.322 2.122.877 2.982L4.33 19.615a.75.75 0 1 0 .86 1.229l3.17-2.22A5.48 5.48 0 0 0 12 20a5.48 5.48 0 0 0 3.649-1.384l3.182 2.228a.75.75 0 0 0 .86-1.229l-3.062-2.144c.551-.857.871-1.876.871-2.971h2.75a.75.75 0 0 0 0-1.5H17.5V9.602l2.198-1.54a.75.75 0 1 0-.86-1.228L16.458 8.5H7.542zM8 10.089A1 1 0 0 0 8.115 10h7.77a1 1 0 0 0 .115.09v4.41a4 4 0 0 1-8 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xl = { render: Y2 }, l7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e7(a, l) {
  return r(), n("svg", l7, l[0] || (l[0] = [
    t('<path fill="currentColor" fill-rule="evenodd" d="M9.859 13.207a3.025 3.025 0 0 0-4.223.166l-.011.011q-.109.111-.203.234l-.04.049a3.018 3.018 0 1 0 4.516 4.005l.162-.161.035-.048.031-.039a3.025 3.025 0 0 0-.267-4.217M7.654 10.93a4.525 4.525 0 0 1 3.627 7.451l-.054.071a1 1 0 0 1-.07.08l-.185.186a4.518 4.518 0 0 1-6.726-6.032q.142-.185.306-.35a4.53 4.53 0 0 1 3.102-1.406M19.088 10.038a9.7 9.7 0 0 0-4.937.004l-.014.004h.002v-.001l-.006.002-.035.01-.052.02a1 1 0 0 1-.091.04l-.094.037q.125.055.306.114c1.613.42 3.307.42 4.92 0l.141-.045.03-.014.042-.017.099-.039a3 3 0 0 0-.31-.115M13.772 8.59a11.2 11.2 0 0 1 5.749.01c.389.122.736.277 1.008.474.262.19.544.486.61.907.071.457-.142.83-.393 1.074-.238.231-.556.402-.897.533l-.049.021a1 1 0 0 1-.075.029l-.2.064-.038.011a11.27 11.27 0 0 1-5.752-.01c-.39-.122-.736-.276-1.008-.474-.262-.19-.543-.486-.609-.907-.07-.457.143-.829.394-1.073.234-.226.544-.394.878-.523a2 2 0 0 1 .344-.126l.03-.008z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M13.355 16.184a.5.5 0 0 0-1 .014c-.005.369.212.654.46.849.25.196.591.353.998.477l.018.005a10.95 10.95 0 0 0 5.61-.004l.2-.06.058-.022.057-.025c.308-.121.576-.268.775-.45.204-.187.37-.444.37-.763a.5.5 0 0 0-1-.025.3.3 0 0 1-.045.05c-.077.07-.223.163-.473.26l-.023.009-.039.017-.16.049a9.95 9.95 0 0 1-5.065 0c-.339-.104-.549-.215-.663-.305a.4.4 0 0 1-.079-.076M13.355 13.233a.5.5 0 0 0-1 .015c-.005.368.212.653.46.848.25.196.591.354.998.478l.018.005a10.95 10.95 0 0 0 5.61-.005l.2-.06.058-.022.057-.025c.308-.12.576-.268.775-.45.204-.186.37-.444.37-.763a.5.5 0 0 0-1-.025.3.3 0 0 1-.045.05c-.077.07-.223.163-.473.26l-.023.01-.039.017-.16.048a9.95 9.95 0 0 1-5.065 0c-.339-.104-.549-.214-.663-.304a.4.4 0 0 1-.079-.077M9.43 7.794a.5.5 0 0 0-1 .015c-.004.368.213.653.46.848.25.196.592.353.999.477l.018.006a10.95 10.95 0 0 0 5.61-.005l.199-.06.058-.022.057-.025c.304-.119.561-.259.747-.444.207-.206.312-.455.312-.727a.5.5 0 0 0-1 0l-.017.018c-.046.046-.16.126-.414.225l-.023.01-.04.017-.16.048a9.95 9.95 0 0 1-5.064 0c-.34-.104-.55-.214-.664-.304a.4.4 0 0 1-.078-.077" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M9.43 10.97a.5.5 0 0 0-1 .015c-.004.368.213.653.46.848.25.197.592.354.999.478l.018.005c1.804.476 2.756.416 2.925.401a.5.5 0 0 0-.086-.996c-.052.004-.886.075-2.574-.37-.34-.104-.55-.214-.664-.304a.4.4 0 0 1-.078-.077" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M12.855 9.518a.75.75 0 0 1 .75.75v8.643c.088.064.262.155.56.25 1.614.42 3.309.42 4.922 0l.158-.05.044-.018h.001c.188-.074.3-.14.361-.186v-8.64a.75.75 0 1 1 1.5 0v8.773c0 .413-.218.731-.451.944-.232.212-.533.376-.862.505l-.003.001-.067.027-.043.015-.2.064-.038.01a11.27 11.27 0 0 1-5.75-.008c-.42-.13-.793-.299-1.076-.52-.278-.219-.56-.567-.556-1.041v-.006l.75.01h-.75v-8.774a.75.75 0 0 1 .75-.75M10.206 4.786l-.005.002a3 3 0 0 0-.303.115q.125.055.306.114c1.613.419 3.306.419 4.919 0l.154-.05.034-.013.02-.008q.057-.021.105-.042a3 3 0 0 0-.314-.117 9.7 9.7 0 0 0-4.916 0M9.775 3.35l.03-.008a11.2 11.2 0 0 1 5.75.01c.388.121.735.276 1.008.473.262.19.543.486.61.908.07.456-.142.828-.393 1.074-.24.234-.561.407-.907.539l-.054.022-.06.022-.204.064-.035.01a11.27 11.27 0 0 1-5.748-.01c-.389-.122-.736-.276-1.008-.473-.262-.19-.543-.486-.61-.907-.071-.457.142-.83.394-1.074.239-.231.557-.401.9-.53a3 3 0 0 1 .291-.108l.024-.008.008-.002.002-.001z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M8.892 4.091a.75.75 0 0 1 .75.75v6.804a.75.75 0 0 1-1.5 0V4.84a.75.75 0 0 1 .75-.75M9.464 18.252a.75.75 0 0 1 .907-.549 9.2 9.2 0 0 0 2.463.264.75.75 0 1 1 .042 1.5 10.7 10.7 0 0 1-2.864-.307.75.75 0 0 1-.548-.908M16.438 4.154a.75.75 0 0 1 .75.75v3.437a.75.75 0 0 1-1.5 0V4.904a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path>', 5)
  ]));
}
const Yl = { render: e7 }, n7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r7(a, l) {
  return r(), n("svg", n7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.346 4.532c-.65-.65-1.179-1.004-1.519-1.19-.012-.007-.023-.01-.049-.005a.3.3 0 0 0-.14.085l-1.102 1.103c.423.286.959.702 1.537 1.28s.994 1.114 1.28 1.537l1.103-1.103a.3.3 0 0 0 .085-.14c.005-.025.001-.036-.005-.049-.186-.34-.54-.868-1.19-1.518m-1.078 3.895-.072-.115a9 9 0 0 0-1.184-1.447 9 9 0 0 0-1.561-1.255l-.51.51.799.798a.75.75 0 1 1-1.06 1.061l-.8-.799-8.682 8.682c.207.3.597.787 1.314 1.504s1.204 1.107 1.503 1.313zM6.398 19.313a18 18 0 0 1-.947-.886c-.36-.36-.65-.674-.886-.947l-.702 2.535zm8.622-13.94-.002-.002zm3.527-3.347c.47.257 1.113.698 1.86 1.445s1.188 1.39 1.445 1.86c.397.726.13 1.504-.336 1.969L8.68 20.136a.75.75 0 0 1-.33.192l-4.938 1.369a1 1 0 0 1-1.23-1.231l1.367-4.939a.75.75 0 0 1 .193-.33L16.578 2.361c.465-.465 1.242-.732 1.969-.335",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const le = { render: r7 }, a7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t7(a, l) {
  return r(), n("svg", a7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M6.167 2.9a.75.75 0 0 0-1.228.86l1.58 2.258a15 15 0 0 0-4.091 2.418.72.72 0 0 0-.054 1.05c.28.302.75.318 1.069.057a13.5 13.5 0 0 1 3.964-2.257l1.455 2.077a10.5 10.5 0 0 0-3.696 2.051.71.71 0 0 0-.039 1.025c.288.31.774.316 1.098.044a9 9 0 0 1 3.548-1.819l1.846 2.637a5.97 5.97 0 0 0-3.452 1.372c-.303.251-.302.702-.034.99.295.316.796.309 1.14.046a4.48 4.48 0 0 1 3.425-.866L16.78 21.1a.75.75 0 1 0 1.229-.86zM12.185 8.888 13.3 10.48c1.68.242 3.21.95 4.455 1.986.325.27.808.263 1.096-.046a.71.71 0 0 0-.04-1.027 10.46 10.46 0 0 0-6.625-2.505M9.587 5.178l.969 1.383q.712-.075 1.444-.076c3.238 0 6.21 1.14 8.535 3.04a.784.784 0 0 0 1.069-.058.72.72 0 0 0-.055-1.05A14.94 14.94 0 0 0 12 4.984q-1.233.001-2.413.193"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M13.294 18.378c.167-.18.184-.459-.003-.617A2 2 0 0 0 12 17.29c-.505 0-.966.187-1.319.496-.181.16-.163.435.002.612l.931.999a.5.5 0 0 0 .731 0z"
    }, null, -1)
  ]));
}
const ee = { render: t7 }, o7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c7(a, l) {
  return r(), n("svg", o7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.734 2.49c-.965 0-1.75.78-1.75 1.748v7.149l-1.382.995-1.7-1.238a.75.75 0 0 0-1.19.606v6.822c0 1.561 1.204 2.862 2.75 2.935v.003h12.08a3.747 3.747 0 0 0 3.747-3.75V4.24a1.75 1.75 0 0 0-1.75-1.75zm-1.75 10.745v5.03c0 1.009-.75 1.72-1.426 1.744-.732-.022-1.347-.64-1.347-1.437v-5.348l.947.69a.75.75 0 0 0 .88.002zm1.133 6.775h9.425a2.25 2.25 0 0 0 2.247-2.25V4.24a.25.25 0 0 0-.25-.25H8.734c-.14 0-.25.112-.25.248v7.464l.003.067v6.802a3 3 0 0 1-.37 1.439m1.977-2.383a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m4.843-11.513a.75.75 0 1 0-1.5 0v.633a2.29 2.29 0 0 0-1.51 2.163c0 .67.354 1.146.735 1.472.347.298.789.53 1.14.715l.036.019c.398.21.693.37.9.546.185.159.21.255.21.332 0 .299-.101.484-.215.595a.77.77 0 0 1-.546.198c-.296 0-.47-.078-.564-.162-.08-.072-.195-.234-.195-.63a.75.75 0 0 0-1.5 0c0 .712.222 1.32.689 1.743.245.221.528.364.82.448v.537a.75.75 0 0 0 1.5 0v-.554c.311-.101.599-.27.84-.504.432-.419.67-1.005.67-1.67 0-.67-.353-1.146-.734-1.472-.348-.298-.789-.53-1.14-.716l-.036-.018c-.398-.21-.693-.37-.9-.546-.185-.16-.21-.255-.21-.333 0-.452.356-.792.76-.792.297 0 .472.077.565.162.08.072.195.234.195.63a.75.75 0 0 0 1.5 0c0-.712-.222-1.32-.69-1.743a2.06 2.06 0 0 0-.82-.448z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ne = { render: c7 }, i7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d7(a, l) {
  return r(), n("svg", i7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.99 4.434a.75.75 0 0 1 .75-.75h3.325c.347 0 .65.239.73.577l2.694 11.41h8.507a.75.75 0 0 1 0 1.5H8.895a.75.75 0 0 1-.73-.578L5.471 5.183h-2.73a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.35 6.613a.75.75 0 0 1 .75-.75h14.165a.75.75 0 0 1 .716.974l-2.391 7.628a.75.75 0 0 1-.716.526H8.928a.75.75 0 0 1 0-1.5h9.395l1.921-6.128H7.1a.75.75 0 0 1-.75-.75M10.368 18.26a.34.34 0 1 0 0 .68.34.34 0 0 0 0-.68m-1.84.34a1.84 1.84 0 1 1 3.68 0 1.84 1.84 0 0 1-3.68 0M16.907 18.26a.34.34 0 1 0 0 .68.34.34 0 0 0 0-.68m-1.84.34a1.84 1.84 0 1 1 3.68 0 1.84 1.84 0 0 1-3.68 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const re = { render: d7 }, h7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s7(a, l) {
  return r(), n("svg", h7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M20.662 8.464a.75.75 0 0 0-1.06-1.06s-4.923 4.929-7.599 7.604L4.399 7.404a.75.75 0 0 0-1.061 1.06l8.132 8.132a.75.75 0 0 0 1.06 0z"
    }, null, -1)
  ]));
}
const ae = { render: s7 }, v7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u7(a, l) {
  return r(), n("svg", v7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M3.338 15.536a.75.75 0 0 0 1.06 1.06s4.923-4.929 7.599-7.604l7.604 7.604a.75.75 0 1 0 1.061-1.06L12.53 7.404a.75.75 0 0 0-1.06 0z"
    }, null, -1)
  ]));
}
const te = { render: u7 }, m7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w7(a, l) {
  return r(), n("svg", m7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M9.464 3.338a.75.75 0 1 0-1.06 1.06s4.929 4.923 7.604 7.599l-7.604 7.604a.75.75 0 0 0 1.06 1.061l8.132-8.132a.75.75 0 0 0 0-1.06z"
    }, null, -1)
  ]));
}
const oe = { render: w7 }, f7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z7(a, l) {
  return r(), n("svg", f7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M14.536 20.662a.75.75 0 0 0 1.06-1.06s-4.929-4.923-7.604-7.599l7.604-7.604a.75.75 0 1 0-1.06-1.061L6.404 11.47a.75.75 0 0 0 0 1.06z"
    }, null, -1)
  ]));
}
const ce = { render: z7 }, g7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p7(a, l) {
  return r(), n("svg", g7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.784 5.817V16h14.432V5.817zM3.635 4.668a1.2 1.2 0 0 1 .848-.35h15.034a1.2 1.2 0 0 1 1.2 1.198v10.497h.916a.75.75 0 0 1 .75.75l-.003.13a4.6 4.6 0 0 1-.22 1.195c-.217.645-.766 1.595-1.991 1.595H3.782c-1.182 0-1.708-.99-1.917-1.589a4.8 4.8 0 0 1-.243-1.174c-.021-.246.022-.492.2-.677a.75.75 0 0 1 .54-.23h.922V5.516a1.2 1.2 0 0 1 .351-.848m-.382 12.845.029.088c.169.486.353.582.5.582H20.17c.24 0 .422-.136.57-.575q.017-.047.03-.095zm12.425-6.63a.75.75 0 1 0-1.451-.38c-.277 1.06-1.082 1.681-2.028 1.876-.969.199-1.993-.073-2.618-.716a.75.75 0 1 0-1.076 1.046c1.035 1.065 2.606 1.425 3.996 1.139 1.415-.29 2.734-1.27 3.177-2.966m-5.47-1.317a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ie = { render: p7 }, M7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x7(a, l) {
  return r(), n("svg", M7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M10.752 13.037v.434h1.553v-.352q0-.351.146-.568.153-.217.715-.633.82-.585 1.113-1.055.293-.468.293-1.113 0-.967-.715-1.547-.707-.58-1.916-.58-1.464 0-2.771.732l.639 1.284q1.125-.575 2.004-.575.503 0 .785.2.28.199.28.58 0 .339-.198.615-.195.276-.809.715-.639.468-.879.885-.24.415-.24.978M10.828 14.73q-.264.252-.263.745 0 .474.269.738.27.258.762.258.48 0 .75-.264.27-.27.27-.732 0-.48-.27-.739-.264-.257-.75-.258-.504 0-.768.252"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m8.5-10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const de = { render: x7 }, _7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $7(a, l) {
  return r(), n("svg", _7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.698 10.41a.76.76 0 0 0 0-1.067L8.155 7.78h6.697c2.752 0 4.94 2.07 4.587 4.516a9 9 0 0 1-.333 1.502.75.75 0 0 0 1.427.464c.18-.553.304-1.152.391-1.752.521-3.618-2.698-6.23-6.072-6.23H8.155L9.698 4.72a.76.76 0 0 0 0-1.067.74.74 0 0 0-1.054 0L5.832 6.498a.75.75 0 0 0 0 1.067l2.812 2.844a.74.74 0 0 0 1.054 0m-5.13 1.36c-.37 2.406 1.797 4.449 4.534 4.449h6.743l-1.543-1.562a.76.76 0 0 1 0-1.066.74.74 0 0 1 1.055 0l2.812 2.844a.75.75 0 0 1 0 1.067l-2.812 2.845a.74.74 0 0 1-1.055 0 .76.76 0 0 1 0-1.067l1.543-1.561H9.102c-3.34 0-6.57-2.575-6.016-6.176.096-.625.237-1.25.443-1.827a.75.75 0 1 1 1.412.506 8.5 8.5 0 0 0-.373 1.549",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const he = { render: $7 }, C7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H7(a, l) {
  return r(), n("svg", C7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 11.969a.75.75 0 0 1-.75.75h-1.69v1.75a.75.75 0 0 1-1.5 0v-1.75h-1.81a.75.75 0 0 1 0-1.5h1.81v-1.75a.75.75 0 0 1 1.5 0v1.75h1.69a.75.75 0 0 1 .75.75m-7.25-8.5a.75.75 0 0 1 0-1.5h2a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25zM18 17.28a.75.75 0 0 1 1.5 0v2a2.75 2.75 0 0 1-2.75 2.75h-2a.75.75 0 1 1 0-1.5h2c.69 0 1.25-.56 1.25-1.25zM10.5 9.75v4.531h-5V9.75zm-5 6.031h5V20a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5zm5-7.531V4a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0-.5.5v4.25zM10 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const se = { render: H7 }, V7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I7(a, l) {
  return r(), n("svg", V7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.969 2a.75.75 0 0 1 .75.75v1.69h1.75a.75.75 0 0 1 0 1.5h-1.75v1.81a.75.75 0 0 1-1.5 0V5.94h-1.75a.75.75 0 0 1 0-1.5h1.75V2.75a.75.75 0 0 1 .75-.75m-8.5 7.25a.75.75 0 0 1-1.5 0v-2a2.75 2.75 0 0 1 2.75-2.75h2a.75.75 0 0 1 0 1.5h-2c-.69 0-1.25.56-1.25 1.25zM17.28 6a.75.75 0 0 1 0-1.5h2a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 1 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25zM9.75 13.5h4.531v5H9.75zm6.031 5v-5H20a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm-7.531-5H4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4.25zM2 14a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ve = { render: I7 }, q7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L7(a, l) {
  return r(), n("svg", q7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.75 5.5h4.531v5H9.75zm6.031 5v-5H20a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm-7.531-5H4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4.25zM2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm1.469 8.75a.75.75 0 0 0-1.5 0v2a2.75 2.75 0 0 0 2.75 2.75h2a.75.75 0 0 0 0-1.5h-2c-.69 0-1.25-.56-1.25-1.25zM17.28 18a.75.75 0 0 0 0 1.5h2a2.75 2.75 0 0 0 2.75-2.75v-2a.75.75 0 1 0-1.5 0v2c0 .69-.56 1.25-1.25 1.25zm-5.312-2.5a.75.75 0 0 1 .75.75v1.69h1.75a.75.75 0 0 1 0 1.5h-1.75v1.81a.75.75 0 0 1-1.5 0v-1.81h-1.75a.75.75 0 0 1 0-1.5h1.75v-1.69a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ue = { render: L7 }, A7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y7(a, l) {
  return r(), n("svg", A7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 12.031a.75.75 0 0 1 .75-.75h1.69v-1.75a.75.75 0 0 1 1.5 0v1.75h1.81a.75.75 0 0 1 0 1.5H5.94v1.75a.75.75 0 1 1-1.5 0v-1.75H2.75a.75.75 0 0 1-.75-.75m7.25 8.5a.75.75 0 0 1 0 1.5h-2a2.75 2.75 0 0 1-2.75-2.75v-2a.75.75 0 0 1 1.5 0v2c0 .69.56 1.25 1.25 1.25zM6 6.72a.75.75 0 0 1-1.5 0v-2a2.75 2.75 0 0 1 2.75-2.75h2a.75.75 0 0 1 0 1.5h-2c-.69 0-1.25.56-1.25 1.25zm7.5 7.531V9.719h5v4.531zm5-6.031h-5V4a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5zm-5 7.531V20a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4.25zM14 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const me = { render: y7 }, k7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function S7(a, l) {
  return r(), n("svg", k7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.47 14.202a.75.75 0 0 1 1.06-1.06l2.22 2.22V2.75a.75.75 0 0 1 1.5 0v12.611l2.22-2.22a.75.75 0 1 1 1.06 1.061l-3.5 3.5a.75.75 0 0 1-1.06 0zM4.5 19.5a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const we = { render: S7 }, D7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function F7(a, l) {
  return r(), n("svg", D7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.47 6.142a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 0 0-1.06-1.06l-1.22 1.22V2.75a.75.75 0 0 0-1.5 0v4.611l-1.22-1.22a.75.75 0 0 0-1.06 0m6.06 11.716a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v4.612a.75.75 0 0 0 1.5 0v-4.611l1.22 1.22a.75.75 0 0 0 1.06 0M4.5 11.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const fe = { render: F7 }, T7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function b7(a, l) {
  return r(), n("svg", T7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 3a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5zm3.97 6.813a.75.75 0 0 0 1.06 1.061l2.22-2.22v12.612a.75.75 0 0 0 1.5 0V8.654l2.22 2.22a.75.75 0 1 0 1.06-1.06l-3.5-3.5a.75.75 0 0 0-1.06 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ze = { render: b7 }, E7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B7(a, l) {
  return r(), n("svg", E7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "m19.806 7.872.59-.464zm-2.679-3.406.59-.463zm-8.643-.763a.75.75 0 0 0-1.5 0zm7.072 4.344h.75v-.008zm-.04-3.906h-.75v.007zm-12.5 1.562v12.594h1.5V5.703zm2.75 15.344h12.468v-1.5H5.766zm15.218-2.75V9.108h-1.5v9.189zm-.588-10.89-2.68-3.404-1.178.927 2.679 3.405zm-4.88-4.454h-9.75v1.5h9.75zm2.2 1.05c-.53-.675-1.373-1.05-2.2-1.05v1.5c.399 0 .794.188 1.022.477zm3.268 5.105a2.75 2.75 0 0 0-.588-1.7l-1.18.927c.174.22.268.493.268.773zm-2.75 11.939a2.75 2.75 0 0 0 2.75-2.75h-1.5c0 .69-.56 1.25-1.25 1.25zm-15.218-2.75a2.75 2.75 0 0 0 2.75 2.75v-1.5c-.69 0-1.25-.56-1.25-1.25zm1.5-12.594c0-.69.56-1.25 1.25-1.25v-1.5a2.75 2.75 0 0 0-2.75 2.75zm2.468-2v4.344h1.5V3.703zm1.75 6.094h5.822v-1.5H8.734zm7.571-1.758-.04-3.906-1.5.015.04 3.907zm-1.75 1.758a1.75 1.75 0 0 0 1.75-1.75h-1.5a.25.25 0 0 1-.25.25zm-7.57-1.75c0 .966.783 1.75 1.75 1.75v-1.5a.25.25 0 0 1-.25-.25zm6.796 6.562a1.75 1.75 0 0 1-1.75 1.75v1.5a3.25 3.25 0 0 0 3.25-3.25zm-1.75 1.75a1.75 1.75 0 0 1-1.75-1.75h-1.5a3.25 3.25 0 0 0 3.25 3.25zm-1.75-1.75c0-.966.784-1.75 1.75-1.75v-1.5a3.25 3.25 0 0 0-3.25 3.25zm1.75-1.75c.967 0 1.75.784 1.75 1.75h1.5a3.25 3.25 0 0 0-3.25-3.25zm4.235-8.718v-.438h-1.5v.438z"
    }, null, -1)
  ]));
}
const ge = { render: B7 }, P7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R7(a, l) {
  return r(), n("svg", P7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M9 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11 2.5a1 1 0 0 1 1-1c5.799 0 10.5 4.701 10.5 10.5 0 2.97-1.234 5.653-3.215 7.561a1 1 0 0 1-1.387-1.44A8.5 8.5 0 0 0 12 3.5a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const pe = { render: R7 }, U7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O7(a, l) {
  return r(), n("svg", U7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.98 2.996a.75.75 0 0 1 .75.75v13.232c0 .69.559 1.25 1.25 1.25h13.274a.75.75 0 0 1 0 1.5H6.979a2.75 2.75 0 0 1-2.75-2.75V3.746a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.768 5.588a.75.75 0 0 1-1.06-.014l-1.705-1.75-1.708 1.75a.75.75 0 0 1-1.073-1.047l2.244-2.301a.75.75 0 0 1 1.075 0l2.241 2.302a.75.75 0 0 1-.014 1.06M18.415 21.769a.75.75 0 0 1 .014-1.061l1.75-1.705-1.75-1.707a.75.75 0 1 1 1.047-1.074l2.302 2.245a.75.75 0 0 1 0 1.074l-2.302 2.241a.75.75 0 0 1-1.06-.014M16.779 11.112a.75.75 0 0 1-.74-.76l.032-2.443-2.445.03a.75.75 0 0 1-.019-1.5l3.215-.04a.75.75 0 0 1 .76.76l-.043 3.213a.75.75 0 0 1-.76.74",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.751 7.236a.75.75 0 0 1 0 1.06L6.525 18.505a.75.75 0 1 1-1.06-1.062L15.691 7.235a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Me = { render: O7 }, G7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N7(a, l) {
  return r(), n("svg", G7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M5.986 4.493a1.493 1.493 0 1 1-2.986 0 1.493 1.493 0 0 1 2.986 0M6.986 6.977a.75.75 0 0 1 1.06 0L19.508 18.44v-3.43a.75.75 0 0 1 1.5 0v5.245a.75.75 0 0 1-.75.75h-5.243a.75.75 0 0 1 0-1.5h3.437L6.986 8.038a.75.75 0 0 1 0-1.06M9.008 3.501a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM3 9.504a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM3 13.004a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM3.5 16.004a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5H4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM3 20.004a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM11.5 20.003a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zM7.5 19.503a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5zM13.008 3.001a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM16.008 3.501a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM20.008 3.001a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM20 11.501a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5zM19.5 7.501a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H20a.5.5 0 0 0-.5.5z"
    }, null, -1)
  ]));
}
const xe = { render: N7 }, Q7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z7(a, l) {
  return r(), n("svg", Q7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M20.662 12.649a.75.75 0 0 0-1.06-1.061l-6.852 6.851V3.766a.75.75 0 0 0-1.5 0v14.673l-6.851-6.851a.75.75 0 1 0-1.061 1.06l8.132 8.132a.75.75 0 0 0 1.06 0z"
    }, null, -1)
  ]));
}
const _e = { render: Z7 }, W7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j7(a, l) {
  return r(), n("svg", W7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M20.662 11.351a.75.75 0 0 1-1.06 1.061L12.75 5.561v14.673a.75.75 0 0 1-1.5 0V5.561l-6.851 6.851a.75.75 0 1 1-1.061-1.06L11.47 3.22a.75.75 0 0 1 1.06 0z"
    }, null, -1)
  ]));
}
const $e = { render: j7 }, K7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J7(a, l) {
  return r(), n("svg", K7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.633 3.338a.75.75 0 0 0-1.06 1.06l6.85 6.852H3.75a.75.75 0 0 0 0 1.5h14.674l-6.852 6.851a.75.75 0 0 0 1.061 1.061l8.132-8.132a.75.75 0 0 0 0-1.06z"
    }, null, -1)
  ]));
}
const Ce = { render: J7 }, X7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y7(a, l) {
  return r(), n("svg", X7, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M11.351 20.662a.75.75 0 0 0 1.061-1.06L5.561 12.75h14.673a.75.75 0 0 0 0-1.5H5.561l6.851-6.851a.75.75 0 1 0-1.06-1.061L3.22 11.47a.75.75 0 0 0 0 1.06z"
    }, null, -1)
  ]));
}
const He = { render: Y7 }, l3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e3(a, l) {
  return r(), n("svg", l3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.313 7.547h-6.74V17.98a.5.5 0 0 0 .5.5h13.854a.5.5 0 0 0 .5-.5V8.052a.5.5 0 0 0-.5-.5h-7.486q-.064 0-.129-.005m.128-1.495-1.038-1.581a1 1 0 0 0-.836-.451H5.072a2 2 0 0 0-2 2v11.96a2 2 0 0 0 2 2h13.856a2 2 0 0 0 2-2V8.052a2 2 0 0 0-2-2zm.957 3.196a.75.75 0 0 1 1.06.006l3.214 3.25a.75.75 0 0 1 0 1.055l-3.214 3.25a.75.75 0 0 1-1.066-1.055l1.95-1.973h-6.56a.75.75 0 1 1 0-1.5h6.56l-1.95-1.972a.75.75 0 0 1 .006-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ve = { render: e3 }, n3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r3(a, l) {
  return r(), n("svg", n3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.75 3.719a.75.75 0 0 0-1.5 0v6.344a.75.75 0 0 0 1.5 0zM9.437 5.854a.75.75 0 0 0-.548-1.396A8.52 8.52 0 0 0 12 20.906 8.517 8.517 0 0 0 15.117 4.46a.75.75 0 1 0-.55 1.396A7.02 7.02 0 0 1 12 19.406 7.017 7.017 0 0 1 9.437 5.854",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ie = { render: r3 }, a3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function t3(a, l) {
  return r(), n("svg", a3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.469 5.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM4.719 10a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qe = { render: t3 }, o3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function c3(a, l) {
  return r(), n("svg", o3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.469 5.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM7.719 10a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Le = { render: c3 }, i3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function d3(a, l) {
  return r(), n("svg", i3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.469 5.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 8a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm5.25-3.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 7.25a.75.75 0 1 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ae = { render: d3 }, h3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s3(a, l) {
  return r(), n("svg", h3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.529 2.898a.75.75 0 0 1 .75.75v1.454h7.501V3.648a.75.75 0 0 1 1.5 0v1.454H19a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h1.779V3.648a.75.75 0 0 1 .75-.75m8.251 3.704v.546a.75.75 0 0 0 1.5 0v-.546H19a.5.5 0 0 1 .5.5v2.375h-15V7.102a.5.5 0 0 1 .5-.5h1.779v.546a.75.75 0 1 0 1.5 0v-.546zM4.5 10.977h15v8.125a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5zm2.023 1.43a.5.5 0 0 0-.5.5v2.958a.5.5 0 0 0 .5.5h2.959a.5.5 0 0 0 .5-.5v-2.959a.5.5 0 0 0-.5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ye = { render: s3 }, v3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u3(a, l) {
  return r(), n("svg", v3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.297 18.984H16.74a.5.5 0 0 0 .51.501h2.536a.5.5 0 0 0 .511-.5m0-1.5H16.74v-3.582a.5.5 0 0 1 .51-.51h2.536a.5.5 0 0 1 .511.51zm-16.51-2.798c.096.096.224.15.36.15h11.078v-.934c0-1.11.916-2.025 2.025-2.025h.089V5.025a.5.5 0 0 0-.51-.51H4.147a.5.5 0 0 0-.512.51v9.3a.5.5 0 0 0 .15.36zm15.066-2.81h.933c1.11 0 2.026.917 2.026 2.026v5.073c0 1.11-.916 2.025-2.026 2.025H17.25a2.037 2.037 0 0 1-2.025-2.025V16.35h-3.98v1.445h1.99a.76.76 0 0 1 .758.757.76.76 0 0 1-.758.757H7.74a.76.76 0 0 1-.757-.757.76.76 0 0 1 .757-.757h1.99V16.35H4.149a2.03 2.03 0 0 1-1.432-.593h-.001a2.02 2.02 0 0 1-.593-1.432v-9.3C2.122 3.915 3.038 3 4.148 3h12.68c1.11 0 2.025.916 2.025 2.025z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ke = { render: u3 }, m3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w3(a, l) {
  return r(), n("svg", m3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.08 3.39a.75.75 0 0 0-1.502 0V7.24a.75.75 0 0 0 1.501 0zM11.38 14.674a2.68 2.68 0 0 0 2.577-1.95h7.302a.75.75 0 1 0 0-1.5h-7.317a2.678 2.678 0 0 0-5.24.776 2.675 2.675 0 0 0 2.678 2.674M11.329 16.011a.75.75 0 0 1 .75.75v3.849a.75.75 0 0 1-1.501 0V16.76a.75.75 0 0 1 .75-.75M6.613 12.776a.75.75 0 1 0 0-1.5H2.76a.75.75 0 1 0 0 1.5zM17.244 6.272a.75.75 0 0 1-.093 1.056l-1.583 1.328a.751.751 0 0 1-.966-1.15l1.584-1.327a.75.75 0 0 1 1.058.093M7.034 8.52a.751.751 0 0 0 1.061-1.061L6.633 5.998a.751.751 0 0 0-1.061 1.06zM17.387 17.802a.75.75 0 0 1-1.061 0l-1.462-1.46a.75.75 0 1 1 1.061-1.061l1.462 1.46a.75.75 0 0 1 0 1.061M7.754 16.496a.75.75 0 1 0-.965-1.149l-1.584 1.328a.75.75 0 1 0 .966 1.149z"
    }, null, -1)
  ]));
}
const Se = { render: w3 }, f3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z3(a, l) {
  return r(), n("svg", f3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.633 3.21a1.534 1.534 0 0 0-2.09.325l-7.155 9.898c-.817.321-1.986.935-2.431 1.925-.287.639-.365 1.198-.442 1.75-.102.728-.202 1.444-.776 2.317l-.011.017a6 6 0 0 1-.453.596c-.273.32-.105.84.314.88q.399.037.786.058l.068.004c2.487.124 4.57-.303 5.753-1.79.743-.93 1.003-2.85 1.079-3.61l5.812-10.372.003-.003a1.535 1.535 0 0 0-.445-1.987zm-6.939 12.907-1.828-1.26a6 6 0 0 0-.346.154c-.658.317-1.064.672-1.194.961-.194.431-.237.734-.304 1.213-.027.194-.059.416-.106.687a6.1 6.1 0 0 1-.5 1.627c1.826-.027 2.987-.465 3.607-1.243l.001-.002c.218-.272.446-.923.603-1.75q.039-.202.067-.387m6.06-11.68q.009-.002.018.002.006.007.008.015a.04.04 0 0 1-.003.024l-3.59 6.406-.754-.486 4.304-5.955a.04.04 0 0 1 .017-.007m-5.201 7.178.899.58-1.339 2.389-1.139-.785z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M7.155 5.066c1.164-.543 2.114-.592 2.836-.401a2.78 2.78 0 0 1 1.65 1.215c.75 1.182.607 2.732-.509 3.55l-.004.003c-.92.685-1.98 1.003-3.16 1.358q-.202.06-.409.123c-1.295.394-2.72.886-3.798 2.124l-.01.012a4.457 4.457 0 0 0 1.83 7.014.75.75 0 0 0 .536-1.4 2.957 2.957 0 0 1-1.22-4.648c.77-.88 1.812-1.275 3.1-1.667l.407-.123c1.151-.343 2.471-.736 3.617-1.587 1.887-1.386 1.962-3.868.886-5.563a4.28 4.28 0 0 0-2.532-1.861c-1.12-.297-2.432-.172-3.855.492a.75.75 0 0 0 .635 1.36"
    }, null, -1)
  ]));
}
const De = { render: z3 }, g3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p3(a, l) {
  return r(), n("svg", g3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.5 3.75a.75.75 0 0 1 .75-.75h3A2.75 2.75 0 0 1 21 5.75v3a.75.75 0 0 1-1.5 0v-3c0-.69-.56-1.25-1.25-1.25h-3a.75.75 0 0 1-.75-.75M5.75 4.5c-.69 0-1.25.56-1.25 1.25v3a.75.75 0 0 1-1.5 0v-3A2.75 2.75 0 0 1 5.75 3h3a.75.75 0 0 1 0 1.5zM14.5 20.281c0 .415.336.75.75.75h3a2.75 2.75 0 0 0 2.75-2.75v-3a.75.75 0 1 0-1.5 0v3c0 .69-.56 1.25-1.25 1.25h-3a.75.75 0 0 0-.75.75M5.75 19.531c-.69 0-1.25-.56-1.25-1.25v-3a.75.75 0 0 0-1.5 0v3a2.75 2.75 0 0 0 2.75 2.75h3a.75.75 0 1 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fe = { render: p3 }, M3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x3(a, l) {
  return r(), n("svg", M3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.186 11.895a.5.5 0 0 0 .5-.474l.207-3.984a.75.75 0 0 0-.749-.79h-.278a.75.75 0 0 0-.749.79l.208 3.984a.5.5 0 0 0 .5.474zM11.296 13.05q-.24.23-.241.682 0 .435.247.677.247.236.698.236.44 0 .688-.242.246-.246.247-.671 0-.441-.248-.677-.24-.236-.687-.236-.462 0-.704.23"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.297 2.992a3.25 3.25 0 0 0-3.25 3.25v8.914a3.25 3.25 0 0 0 3.25 3.25h1.86v1.875a.75.75 0 0 0 1.182.613l3.524-2.488h4.897a3.25 3.25 0 0 0 3.25-3.25V6.242a3.25 3.25 0 0 0-3.25-3.25zm-1.75 3.25c0-.967.783-1.75 1.75-1.75h11.462c.967 0 1.75.783 1.75 1.75v8.914a1.75 1.75 0 0 1-1.75 1.75h-4.975c-.258 0-.51.08-.721.229l-2.407 1.699v-1.178a.75.75 0 0 0-.75-.75h-2.61a1.75 1.75 0 0 1-1.75-1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Te = { render: x3 }, _3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $3(a, l) {
  return r(), n("svg", _3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.493 2.999a.5.5 0 0 1 .5.5v17.003a.5.5 0 0 1-1 0V3.499a.5.5 0 0 1 .5-.5M5.987 3.007a1 1 0 0 1 1 1V20.01a1 1 0 1 1-2 0V4.007a1 1 0 0 1 1-1M9.56 3a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-1 0v-17a.5.5 0 0 1 .5-.5M12.059 3.007a1 1 0 0 1 1 1V20.01a1 1 0 1 1-2 0V4.007a1 1 0 0 1 1-1M14.557 3a.5.5 0 0 1 .5.5v17a.5.5 0 1 1-1 0v-17a.5.5 0 0 1 .5-.5M17.057 3.007a1 1 0 0 1 1 1V20.01a1 1 0 1 1-2 0V4.007a1 1 0 0 1 1-1M20.058 3.007a1 1 0 0 1 1 1V20.01a1 1 0 1 1-2 0V4.007a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const be = { render: $3 }, C3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H3(a, l) {
  return r(), n("svg", C3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.43 4.132a1.75 1.75 0 0 1 2.028-1.42l10.833 1.91a1.75 1.75 0 0 1 1.42 2.027l-1.737 9.848a1.75 1.75 0 0 1-.961 1.272v-4.461l1.22-6.92a.25.25 0 0 0-.203-.289L9.197 4.19a.25.25 0 0 0-.29.203l-.382 2.173H7zM4.013 7.815a1.75 1.75 0 0 0-1.75 1.75v10c0 .966.783 1.75 1.75 1.75h12a1.75 1.75 0 0 0 1.75-1.75v-10a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h12a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25h-12a.25.25 0 0 1-.25-.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ee = { render: H3 }, V3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I3(a, l) {
  return r(), n("svg", V3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.29 16.634h5.662v1.5H9.29zM18.123 9.173v4.967h-1.5V9.173zM9.007 5.876h5.798v1.5H9.007zM7.376 9.22v5.245h-1.5V9.219z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.716 4.505a2.217 2.217 0 1 0 0 4.434 2.217 2.217 0 0 0 0-4.434M2.999 6.722a3.717 3.717 0 1 1 7.433 0 3.717 3.717 0 0 1-7.433 0M6.716 15.068a2.217 2.217 0 1 0 0 4.433 2.217 2.217 0 0 0 0-4.433m-3.717 2.216a3.717 3.717 0 1 1 7.433 0 3.717 3.717 0 0 1-7.433 0M17.284 15.068a2.217 2.217 0 1 0 0 4.433 2.217 2.217 0 0 0 0-4.433m-3.717 2.216a3.717 3.717 0 1 1 7.433 0 3.717 3.717 0 0 1-7.433 0M17.284 4.5a2.217 2.217 0 1 0 0 4.433 2.217 2.217 0 0 0 0-4.433m-3.717 2.216a3.717 3.717 0 1 1 7.433 0 3.717 3.717 0 0 1-7.433 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Be = { render: I3 }, q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L3(a, l) {
  return r(), n("svg", q3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.734 21.013h2.56a3.75 3.75 0 0 0 3.75-3.75v-2.781h-1.5v2.78a2.25 2.25 0 0 1-2.25 2.25h-2.56zm6.31-14.326v2.795h-1.5V6.688a2.25 2.25 0 0 0-2.25-2.25h-2.56v-1.5h2.56a3.75 3.75 0 0 1 3.75 3.75m-11.31-2.25H6.72a2.25 2.25 0 0 0-2.25 2.25v2.795h-1.5V6.688a3.75 3.75 0 0 1 3.75-3.75h3.015zM2.97 14.483h1.5v2.78a2.25 2.25 0 0 0 2.25 2.25h3.015v1.5H6.72a3.75 3.75 0 0 1-3.75-3.75zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Pe = { render: L3 }, A3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y3(a, l) {
  return r(), n("svg", A3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M10 2h4v1.5h-4zM19 3.5h-2V2h2a2 2 0 0 1 2 2v1.781h-1.5V4a.5.5 0 0 0-.5-.5M19.5 8.781H21v4.094h-1.5zM4.5 4v1.781H3V4a2 2 0 0 1 2-2h2v1.5H5a.5.5 0 0 0-.5.5M4.5 8.781H3v4.094h1.5zM3 15.875h1.5v2a.5.5 0 0 0 .5.5h.25v1.5H5a2 2 0 0 1-2-2zM19.5 15.875H21v2a2 2 0 0 1-1.5 1.937z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.212 5.031c-.89 0-1.622.698-1.666 1.586l-.377 7.667-1.79-.698A1.778 1.778 0 0 0 5.382 16.4l3.671 4.29a3.75 3.75 0 0 0 2.85 1.312h3.173c1.555 0 3.034-.988 3.333-2.64.258-1.42.424-3.033.522-4.179a2.694 2.694 0 0 0-1.875-2.787l-2.155-.693a2.75 2.75 0 0 0-1.81.044l-.213-5.117a1.67 1.67 0 0 0-1.667-1.598m-.168 1.66a.168.168 0 0 1 .335 0l.263 6.32a.75.75 0 0 0 1.129.615l.656-.384a1.25 1.25 0 0 1 1.015-.112l2.155.693c.544.175.886.686.84 1.232-.097 1.13-.259 2.688-.504 4.039-.148.82-.9 1.407-1.857 1.407h-3.174a2.25 2.25 0 0 1-1.709-.787l-3.671-4.29a.278.278 0 0 1 .313-.44l2.76 1.076a.75.75 0 0 0 1.02-.662z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Re = { render: y3 }, k3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S3(a, l) {
  return r(), n("svg", k3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.461 2.639a.75.75 0 0 1 .629-.151l6.355 1.355a.75.75 0 0 1 .593.76l-.562 16.202a.75.75 0 0 1-1.33.449L8.598 15.7a.75.75 0 1 1 1.16-.95l3.288 4.013.471-13.585-4.832-1.03.008 4.936a.75.75 0 1 1-1.5.002l-.01-5.864a.75.75 0 0 1 .278-.584",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.616 8.625a.75.75 0 0 1 1.004-.342l6.968 3.427a.75.75 0 0 1-.175 1.407l-15.25 3.246a.75.75 0 0 1-.803-.356L2.1 10.432a.75.75 0 0 1 .538-1.12l5.003-.738a.75.75 0 0 1 .22 1.484l-3.906.576 2.425 4.149L18.983 12.1l-5.026-2.472a.75.75 0 0 1-.341-1.004",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.35 8.829a.75.75 0 0 1 1.052-.135l6.02 4.649a.75.75 0 1 1-.917 1.187l-6.02-4.65A.75.75 0 0 1 7.35 8.83",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ue = { render: S3 }, D3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F3(a, l) {
  return r(), n("svg", D3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.959 5.57c-.272.289-.475.791-.475 1.651v6.85c0 .86.203 1.374.477 1.672.265.287.708.494 1.47.494h3.406a.75.75 0 0 1 .602.302l1.514 2.033 1.532-2.036a.75.75 0 0 1 .599-.3h3.452c.776 0 1.225-.208 1.491-.495.276-.297.478-.81.478-1.67V7.22c0-.86-.202-1.362-.474-1.651-.264-.28-.713-.484-1.495-.484H6.454c-.782 0-1.231.204-1.495.484M3.867 4.541c.642-.68 1.552-.955 2.587-.955h11.082c1.034 0 1.945.274 2.587.955.633.673.882 1.613.882 2.68v6.85c0 1.068-.249 2.012-.878 2.69-.64.69-1.55.976-2.591.976h-3.078l-1.91 2.538a.75.75 0 0 1-1.2-.003L9.46 17.737H6.43c-1.032 0-1.937-.288-2.572-.977-.626-.678-.875-1.621-.875-2.69V7.222c0-1.067.25-2.007.883-2.68",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.285 4.794a.75.75 0 0 1 1.057.092l5.212 6.215c.206.247.444.435.696.56.25.124.514.185.775.185s.524-.061.775-.186c.252-.124.49-.312.697-.56l5.151-6.141a.75.75 0 1 1 1.15.964l-5.15 6.139a3.7 3.7 0 0 1-1.181.942 3.24 3.24 0 0 1-1.442.342c-.5 0-.99-.118-1.441-.342a3.7 3.7 0 0 1-1.181-.941L4.193 5.85a.75.75 0 0 1 .092-1.056",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.624 9.945a.75.75 0 0 1 1.054.117l4.13 5.163a.75.75 0 1 1-1.171.937L14.507 11a.75.75 0 0 1 .117-1.055M9.366 9.945A.75.75 0 0 1 9.483 11l-4.13 5.162a.75.75 0 1 1-1.172-.937l4.13-5.162a.75.75 0 0 1 1.055-.118",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Oe = { render: F3 }, T3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b3(a, l) {
  return r(), n("svg", T3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.713 12.486a1.5 1.5 0 0 1 .287.891l-.035 5.949 2-.4L13 13.36a1.5 1.5 0 0 1 .293-.88l5.248-7.12a.5.5 0 0 0-.403-.796H5.93a.5.5 0 0 0-.404.794zm-1.252 7.45L9.5 13.37l-5.188-7.13c-.962-1.321-.018-3.176 1.617-3.176h12.209c1.641 0 2.584 1.866 1.61 3.187L14.5 13.369l-.039 5.968a1 1 0 0 1-.803.98l-3 .6a1 1 0 0 1-1.197-.98",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ge = { render: b3 }, E3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B3(a, l) {
  return r(), n("svg", E3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.476 4.399a.75.75 0 0 0-1.061 1.06L10.956 12l-6.541 6.541a.75.75 0 0 0 1.06 1.061l6.542-6.541 6.54 6.54a.75.75 0 0 0 1.06-1.06L13.078 12l6.54-6.541a.75.75 0 1 0-1.06-1.06l-6.54 6.54z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ne = { render: B3 }, P3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R3(a, l) {
  return r(), n("svg", P3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 6.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.25m3 6a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75m3.75 5.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qe = { render: R3 }, U3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O3(a, l) {
  return r(), n("svg", U3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.707 8.906c.184 0 .333.15.333.333v.786c0 .139.087.262.214.32q.25.117.474.275c.114.08.264.095.385.025l.68-.393a.333.333 0 0 1 .455.121l.707 1.225a.333.333 0 0 1-.121.455l-.681.393a.36.36 0 0 0-.171.345 3 3 0 0 1 0 .549.36.36 0 0 0 .17.345l.682.393c.159.092.213.295.121.455l-.707 1.224a.333.333 0 0 1-.454.122l-.681-.393a.36.36 0 0 0-.385.025 3 3 0 0 1-.474.275.36.36 0 0 0-.214.32v.786a.333.333 0 0 1-.333.332h-1.414a.333.333 0 0 1-.333-.332v-.786a.36.36 0 0 0-.214-.32 3 3 0 0 1-.475-.275.36.36 0 0 0-.384-.025l-.68.393a.333.333 0 0 1-.455-.122l-.707-1.224a.333.333 0 0 1 .121-.455l.681-.393a.36.36 0 0 0 .17-.345 3 3 0 0 1 0-.55.36.36 0 0 0-.17-.344l-.68-.393a.333.333 0 0 1-.122-.455l.707-1.225a.333.333 0 0 1 .454-.121l.681.393c.12.07.27.055.385-.025q.223-.16.474-.275a.36.36 0 0 0 .214-.32v-.786c0-.184.15-.333.333-.333zM12 14.345a1.28 1.28 0 1 0 0-2.56 1.28 1.28 0 0 0 0 2.56",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M17.127 5.721a9.25 9.25 0 0 0-5.04-1.489H5.834l.97-.945a.75.75 0 0 0-1.047-1.074L3.455 4.454a.75.75 0 0 0 0 1.075l2.301 2.244A.75.75 0 0 0 6.803 6.7l-.97-.968h6.255c1.504 0 2.973.435 4.221 1.246a7.42 7.42 0 0 1 2.79 3.307 7.18 7.18 0 0 1 .433 4.247 7.3 7.3 0 0 1-2.065 3.771 7.66 7.66 0 0 1-3.884 2.028 7.8 7.8 0 0 1-4.393-.415 7.55 7.55 0 0 1-3.408-2.712A7.22 7.22 0 0 1 4.5 13.121a.75.75 0 1 0-1.5.003 8.72 8.72 0 0 0 1.547 4.931 9.05 9.05 0 0 0 4.084 3.253 9.3 9.3 0 0 0 5.239.495 9.16 9.16 0 0 0 4.644-2.426 8.8 8.8 0 0 0 2.488-4.546 8.68 8.68 0 0 0-.523-5.133 8.92 8.92 0 0 0-3.352-3.977"
    }, null, -1)
  ]));
}
const Ze = { render: O3 }, G3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N3(a, l) {
  return r(), n("svg", G3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.575 1.647a.76.76 0 0 0 .012 1.067l1.297 1.282a8.031 8.031 0 0 0-8.216 11.232.75.75 0 0 0 1.372-.608 6.531 6.531 0 0 1 7.295-9.038L11.64 7.336a.76.76 0 0 0 .013 1.067.74.74 0 0 0 1.054-.013l2.779-2.877a.76.76 0 0 0-.013-1.067L12.63 1.635a.74.74 0 0 0-1.054.012m.85 20.706a.76.76 0 0 0-.012-1.067l-1.297-1.282a8.031 8.031 0 0 0 8.217-11.232.75.75 0 0 0-1.373.608 6.531 6.531 0 0 1-7.295 9.038l1.694-1.754a.76.76 0 0 0-.013-1.067.74.74 0 0 0-1.054.013l-2.779 2.877a.76.76 0 0 0 .013 1.067l2.845 2.812a.74.74 0 0 0 1.054-.013",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const We = { render: N3 }, Q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z3(a, l) {
  return r(), n("svg", Q3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.017 4.072V2.016h-1.5v2.136c-2.627.43-4.75 2.364-5.493 4.88h-2.99v1.5h8.483v11.433h1.5V10.531h5.977q.009.12.013.242l-.681 1.331a.75.75 0 0 0 .028.733l1.65 2.696h-1.187a.75.75 0 0 0-.75.75v2.667a.05.05 0 0 1-.015.035.05.05 0 0 1-.035.015h-2.258a.75.75 0 0 0-.75.75v2.215h1.5V20.5h1.508c.855 0 1.55-.695 1.55-1.55v-1.917h1.305a1.017 1.017 0 0 0 .944-1.395l-.023-.059-1.94-3.166.574-1.124a.75.75 0 0 0 .082-.341q0-.21-.012-.417H22v-1.5h-2.76a6.85 6.85 0 0 0-1.77-2.975c-1.21-1.198-3.633-1.894-5.453-1.984m-1.5 1.607a5.43 5.43 0 0 0-3.91 3.352h3.91zm1.5-.104c1.45.085 3.467.626 4.397 1.547.556.551.977 1.2 1.247 1.91h-5.645zm8.697 11.01-.62-.42.621.419zm-13.74-.07a1 1 0 0 1 .684.95v3.5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 .684-.95V15.33a2.316 2.316 0 1 1 4.632 0zm-1.263-.05v-1.136a1.053 1.053 0 0 0-2.106 0v1.136z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const je = { render: Z3 }, W3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j3(a, l) {
  return r(), n("svg", W3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.604 4.982a.75.75 0 0 1 .75-.75h7.734c1.792 0 3.546.518 5.039 1.489a8.92 8.92 0 0 1 3.352 3.977 8.68 8.68 0 0 1 .523 5.133 8.8 8.8 0 0 1-2.488 4.546 9.16 9.16 0 0 1-4.644 2.426 9.3 9.3 0 0 1-5.239-.495 9.05 9.05 0 0 1-4.084-3.253A8.72 8.72 0 0 1 3 13.125a.75.75 0 1 1 1.5-.004 7.22 7.22 0 0 0 1.282 4.083 7.55 7.55 0 0 0 3.408 2.712 7.8 7.8 0 0 0 4.393.415 7.66 7.66 0 0 0 3.883-2.028 7.3 7.3 0 0 0 2.066-3.771 7.18 7.18 0 0 0-.433-4.247 7.42 7.42 0 0 0-2.79-3.307 7.75 7.75 0 0 0-4.221-1.246H4.354a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.817 2.227a.75.75 0 0 1-.014 1.06l-1.75 1.705L6.803 6.7a.75.75 0 0 1-1.047 1.073L3.455 5.53a.75.75 0 0 1 0-1.075l2.301-2.241a.75.75 0 0 1 1.06.014",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M11.982 8.2a.75.75 0 0 1 .75.75v3.853l2.253 2.283a.75.75 0 1 1-1.068 1.053l-2.469-2.501a.75.75 0 0 1-.216-.527V8.95a.75.75 0 0 1 .75-.75"
    }, null, -1)
  ]));
}
const Ke = { render: j3 }, K3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J3(a, l) {
  return r(), n("svg", K3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.15 4.502c-3.119 0-5.65 2.536-5.65 5.67 0 1.68.727 3.187 1.883 4.225v1.87A7.17 7.17 0 0 1 3 10.17c0-3.957 3.199-7.169 7.15-7.169a7.14 7.14 0 0 1 6.044 3.337h-1.88a5.63 5.63 0 0 0-4.164-1.837M9.517 7.73a1.75 1.75 0 0 0-1.75 1.75v9.769c0 .966.783 1.75 1.75 1.75h9.733a1.75 1.75 0 0 0 1.75-1.75V9.479a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h9.733a.25.25 0 0 1 .25.25v9.769a.25.25 0 0 1-.25.25H9.517a.25.25 0 0 1-.25-.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Je = { render: J3 }, X3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function Y3(a, l) {
  return r(), n("svg", X3, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.417 4.5h8.604c.898 0 1.648 0 2.242.08.628.084 1.195.27 1.65.725.456.456.641 1.023.726 1.65.08.595.08 1.345.08 2.243v5.604c0 .899 0 1.648-.08 2.242-.085.628-.27 1.195-.726 1.65-.455.456-1.022.642-1.65.726-.594.08-1.344.08-2.242.08H8.417c-.899 0-1.648 0-2.243-.08-.628-.084-1.194-.27-1.65-.726s-.64-1.022-.725-1.65c-.08-.594-.08-1.344-.08-2.242V9.198c0-.898 0-1.648.08-2.242.084-.628.27-1.195.725-1.65.456-.456 1.022-.642 1.65-.726.595-.08 1.344-.08 2.243-.08M6.374 6.067c-.461.062-.659.169-.79.3-.13.13-.237.327-.299.788-.065.483-.066 1.131-.066 2.095v5.5c0 .964.001 1.612.066 2.095.062.461.17.659.3.789s.328.237.79.3c.482.064 1.13.066 2.094.066h1.75V6h-1.75c-.964 0-1.612.002-2.095.067M16.97 18h-5.25V6h5.25c.964 0 1.611.002 2.094.067.462.062.66.169.79.3s.237.327.3.788c.064.483.066 1.131.066 2.095v5.5c0 .964-.002 1.612-.067 2.095-.062.461-.169.659-.3.789s-.327.237-.789.3c-.483.064-1.13.066-2.094.066M6.906 7.875a.75.75 0 0 0 0 1.5h1.5a.75.75 0 1 0 0-1.5zm-.75 3.063a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m.75 1.562a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xe = { render: Y3 }, l4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
};
function e4(a, l) {
  return r(), n("svg", l4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.917 4.5h8.604c.898 0 1.648 0 2.242.08.628.084 1.195.27 1.65.725.456.456.641 1.023.726 1.65.08.595.08 1.345.08 2.243v5.604c0 .899 0 1.648-.08 2.242-.085.628-.27 1.195-.726 1.65-.455.456-1.022.642-1.65.726-.594.08-1.344.08-2.242.08H7.917c-.899 0-1.648 0-2.243-.08-.628-.084-1.194-.27-1.65-.726s-.64-1.022-.725-1.65c-.08-.594-.08-1.344-.08-2.242V9.198c0-.898 0-1.648.08-2.242.084-.628.27-1.195.725-1.65.456-.456 1.022-.642 1.65-.726.595-.08 1.344-.08 2.243-.08M5.874 6.067c-.461.062-.659.169-.79.3-.13.13-.237.327-.299.788-.065.483-.066 1.131-.066 2.095v5.5c0 .964.001 1.612.066 2.095.062.461.17.659.3.789s.328.237.79.3c.482.064 1.13.066 2.094.066h1.75V6h-1.75c-.964 0-1.612.002-2.095.067M16.47 18h-5.25V6h5.25c.964 0 1.611.002 2.094.067.462.062.66.169.79.3s.237.327.3.788c.064.483.066 1.131.066 2.095v5.5c0 .964-.002 1.612-.067 2.095-.062.461-.169.659-.3.789s-.327.237-.789.3c-.483.064-1.13.066-2.094.066",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.085 6.366c.13-.13.328-.237.79-.3C6.356 6.003 7.004 6 7.968 6h1.75v12h-1.75c-.964 0-1.612-.002-2.095-.067-.461-.062-.659-.169-.79-.3-.13-.13-.237-.327-.299-.788-.065-.483-.066-1.131-.066-2.095v-5.5c0-.964.001-1.612.066-2.095.062-.461.17-.659.3-.789m1.321 1.509a.75.75 0 0 0 0 1.5h1.5a.75.75 0 1 0 0-1.5zm-.75 3.063a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m.75 1.562a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ye = { render: e4 }, n4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r4(a, l) {
  return r(), n("svg", n4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.054 8.334a3.5 3.5 0 1 0-4.089.014 3.75 3.75 0 0 0-2.344 1.564l-3.11 4.575a.75.75 0 0 0 .181 1.03l1.28.921a.75.75 0 0 0 .942-.053l1.77-1.607-1.015 6.354a.75.75 0 0 0 .74.868h1.352a.75.75 0 0 0 .675-.423l1.526-3.151 1.35 3.122A.75.75 0 0 0 14 22h1.351a.75.75 0 0 0 .744-.845l-.827-6.452 1.837 1.662a.75.75 0 0 0 .939.054l1.26-.9a.75.75 0 0 0 .187-1.03l-3.09-4.58a3.75 3.75 0 0 0-2.347-1.575M14 5.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-3.314 4.271 1.332-.021 1.284.006a2.25 2.25 0 0 1 1.855.991l2.682 3.975-.175.125-2.895-2.617a.75.75 0 0 0-1.247.652l.977 7.618h-.006l-1.805-4.173a.75.75 0 0 0-1.363-.029L9.29 20.5h-.002l1.213-7.595a.75.75 0 0 0-1.245-.674l-2.902 2.635-.194-.14 2.7-3.97a2.25 2.25 0 0 1 1.825-.985",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ln = { render: r4 }, a4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t4(a, l) {
  return r(), n("svg", a4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.748 3.228a.75.75 0 0 1 1.06 0l3.811 3.81a.75.75 0 0 1 0 1.06l-.997.998.329.329a.75.75 0 0 1 0 1.06l-1.516 1.516a.75.75 0 0 1-1.06 0l-.107-.106-.017.027c-1.05 1.736-1.28 4.546-1.33 5.769a.78.78 0 0 1-.6.735L4.084 20.988a.75.75 0 0 1-.897-.9l2.59-11.221a.785.785 0 0 1 .742-.6c1.227-.042 4.04-.256 5.789-1.331l-.528-.528a.75.75 0 0 1 0-1.061l1.515-1.516a.75.75 0 0 1 1.061 0l.394.394zm.53 1.59-.455.456 2.75 2.75.455-.455zm-2.451.604-.455.455 4.533 4.533.455-.455zM9.942 9.376c1.094-.23 2.398-.624 3.448-1.356l2.778 2.817c-.721 1.045-1.113 2.349-1.343 3.44a20 20 0 0 0-.373 2.808l-8.242 1.88 2.395-2.392a2.073 2.073 0 1 0-1.019-1.103l-2.33 2.328 1.86-8.058c.747-.044 1.77-.143 2.826-.364m-.426 4.76a.573.573 0 1 0 0 1.147.573.573 0 0 0 0-1.146",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const en = { render: t4 }, o4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c4(a, l) {
  return r(), n("svg", o4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.27 6.513h-.05c-1.726 0-3.088 0-4.153.125-1.087.128-1.98.397-2.693 1.022-.728.637-1.055 1.455-1.208 2.451-.146.95-.146 2.158-.146 3.652v.163c0 1.456 0 2.486.151 3.258.173.884.545 1.46 1.203 2.035.714.625 1.606.894 2.693 1.022 1.065.125 2.427.125 4.153.125h.1c1.725 0 3.087 0 4.152-.125 1.088-.128 1.98-.397 2.693-1.022.658-.575 1.03-1.151 1.203-2.035.152-.773.152-1.802.152-3.258v-.163c0-1.494 0-2.701-.146-3.652-.153-.996-.48-1.814-1.209-2.451-.713-.625-1.605-.894-2.693-1.022-1.065-.125-2.427-.125-4.152-.125zM4.362 8.788c.385-.336.926-.548 1.88-.66.968-.114 2.241-.115 4.028-.115s3.06.001 4.027.115c.954.112 1.496.324 1.88.66.37.325.593.76.714 1.551.127.823.129 1.915.129 3.486 0 1.584-.004 2.46-.124 3.07-.101.518-.278.81-.719 1.195-.384.337-.925.549-1.88.66-.967.115-2.24.116-4.027.116s-3.06-.001-4.027-.115c-.955-.112-1.496-.324-1.881-.66-.44-.386-.618-.678-.719-1.195-.12-.611-.123-1.487-.123-3.07 0-1.572.002-2.664.128-3.487.122-.79.344-1.226.714-1.55m5.917 1.093c.382-.463.992-1.044 1.93-1.044.789 0 1.367.613 1.712 1.17.377.609.649 1.409.758 2.26.216 1.691-.193 3.813-2.036 5.12-.94.665-2.03.752-2.998.577-.963-.174-1.868-.615-2.542-1.1-.825-.594-1.21-1.54-1.282-2.44-.072-.895.154-1.856.692-2.572.31-.412.657-.705 1.083-.825.405-.113.768-.032.973.014l.009.002c.238.053.336.074.448.064.086-.008.237-.041.484-.235.049-.039.13-.13.278-.332l.095-.132c.113-.158.25-.35.396-.527m.157 2.17c.233-.183.424-.436.563-.627l.126-.174c.106-.148.202-.282.312-.415.299-.363.525-.498.772-.498q-.006 0 .002.002c.03.012.2.08.435.459.247.398.458.986.545 1.659.173 1.356-.177 2.828-1.415 3.705-.518.367-1.163.453-1.864.326-.707-.128-1.407-.463-1.933-.841-.374-.27-.615-.754-.663-1.342-.047-.592.113-1.175.396-1.551.1-.133.174-.204.222-.242.044-.034.068-.04.068-.04.009-.003.04-.012.249.035l.049.011c.188.043.504.116.863.083.42-.038.838-.208 1.273-.55m2.043.301c0 .389-.238.703-.532.703-.293 0-.531-.314-.531-.703s.238-.703.531-.703.532.315.532.703m-2.994.473a.75.75 0 0 1 .622-.168c.36.066.623.274.793.456.173.185.302.396.394.572a4 4 0 0 1 .263.63c.1.31.028.66-.24.868-.268.21-.62.195-.9.018a3.345 3.345 0 0 1-.51-.403 1.22 1.22 0 0 1-.609.463c-.537.195-1.091.024-1.238-.381-.148-.406.168-.893.705-1.088.167-.06.336-.085.494-.08a1.6 1.6 0 0 1-.036-.298.75.75 0 0 1 .262-.589",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M17.5 16.516s.639.154.952 0c1.244-.612 1.434-1.322 2.195-4.16s1.14-4.257.369-5.408-2.393-1.586-5.636-2.455c-3.243-.87-4.865-1.304-6.108-.692-1.175.577-1.74 3.147-1.74 3.147"
    }, null, -1)
  ]));
}
const nn = { render: c4 }, i4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d4(a, l) {
  return r(), n("svg", i4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M8.508 15.312a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10.758 16.062a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.508 5.438a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10.758 6.188a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.508 10.469a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10.758 11.219a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.25 4.344a2.25 2.25 0 0 1 2.25-2.25h11a2.25 2.25 0 0 1 2.25 2.25v11.875a2.25 2.25 0 0 1-2.25 2.25h-5.594v.75a2.75 2.75 0 0 1-2.75 2.75h-2a.75.75 0 0 1 0-1.5h2c.69 0 1.25-.56 1.25-1.25v-.75H6.5a2.25 2.25 0 0 1-2.25-2.25zM17.5 16.969a.75.75 0 0 0 .75-.75v-2.563H5.75v2.563c0 .414.336.75.75.75zM6.5 3.594a.75.75 0 0 0-.75.75v2.968h12.5V4.345a.75.75 0 0 0-.75-.75zm-.75 8.562V8.812h12.5v3.344z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M13 21.281a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
    }, null, -1)
  ]));
}
const rn = { render: d4 }, h4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s4(a, l) {
  return r(), n("svg", h4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.635 2.362h-.054c-1.24 0-2.247 0-3.04.107-.826.11-1.532.348-2.095.909-.587.585-.822 1.325-.927 2.195l-.006.049.001.05.007.59q-.15.114-.29.245c-.792.744-1.149 1.693-1.318 2.87-.163 1.14-.163 2.592-.163 4.42v.485m1.5.345 1.233-1.078a1.205 1.205 0 0 1 1.645.055l3.647 3.646a2.45 2.45 0 0 0 3.14.272c.873-.613 1.807-.66 2.493-.043l.003.003 2.11 1.876c-.44.32-1.033.524-1.951.64-1.1.138-2.547.14-4.57.14s-3.47-.002-4.57-.14c-1.082-.137-1.714-.395-2.172-.825-.516-.483-.74-.87-.865-1.548-.12-.657-.14-1.551-.142-2.998m15.207 3.556-2.045-1.819-.002-.001c-1.373-1.235-3.12-.937-4.357-.068a.95.95 0 0 1-1.218-.105L8.19 12.543a2.705 2.705 0 0 0-3.694-.123l-.243.213c.006-1.278.033-2.257.146-3.042.142-.993.408-1.566.86-1.99.458-.43 1.09-.687 2.172-.824 1.1-.138 2.547-.14 4.57-.14s3.47.002 4.57.14c1.082.137 1.714.395 2.172.825.452.423.718.996.86 1.989.146 1.02.148 2.364.148 4.265 0 1.913-.003 3.002-.143 3.769a3 3 0 0 1-.15.558M2.75 14.295c0 1.608.01 2.74.168 3.6.187 1.021.585 1.69 1.314 2.373.786.737 1.779 1.063 3.01 1.218 1.205.151 2.746.151 4.704.151h.107c1.959 0 3.5 0 4.704-.151 1.232-.155 2.225-.481 3.011-1.218.73-.684 1.127-1.352 1.314-2.374.168-.918.168-2.15.168-3.94v-.158c0-1.827 0-3.28-.163-4.418-.169-1.178-.526-2.127-1.319-2.87a4 4 0 0 0-.282-.241v-.65l-.005-.044c-.105-.87-.34-1.61-.927-2.195-.563-.56-1.269-.799-2.095-.91-.793-.106-1.8-.106-3.04-.106h-2.784m7.324 3.162c-.092-.564-.245-.866-.464-1.084-.237-.236-.574-.396-1.235-.485-.682-.09-1.587-.093-2.895-.093h-2.73c-1.308 0-2.213.002-2.895.093-.66.089-.998.25-1.235.485-.218.218-.372.52-.464 1.084a8 8 0 0 1 1.202-.235c1.204-.152 2.745-.151 4.704-.151h.106c1.959 0 3.5 0 4.704.151q.644.08 1.202.235m-1.809 5.363a.525.525 0 1 1 1.05 0 .525.525 0 0 1-1.05 0m.525-2.025a2.025 2.025 0 1 0 0 4.05 2.025 2.025 0 0 0 0-4.05",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const an = { render: s4 }, v4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u4(a, l) {
  return r(), n("svg", v4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 6.125a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75m0 6.125a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1-.75-.75m.75 4.875a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tn = { render: u4 }, m4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w4(a, l) {
  return r(), n("svg", m4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.48 12c0-4.141 3.365-7.502 7.52-7.502s7.52 3.36 7.52 7.502-3.365 7.502-7.52 7.502S4.48 16.142 4.48 12M12 2.998c-4.98 0-9.02 4.029-9.02 9.002s4.04 9.002 9.02 9.002 9.02-4.029 9.02-9.002S16.98 2.998 12 2.998m3.55 9.427a.5.5 0 0 0 0-.85L10.524 8.47a.5.5 0 0 0-.763.426v6.207a.5.5 0 0 0 .763.425z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const on = { render: w4 }, f4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z4(a, l) {
  return r(), n("svg", f4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 1.999a.75.75 0 0 1 .75.75v6.084a.75.75 0 0 1-1.5 0V2.749a.75.75 0 0 1 .75-.75M12 14.411a.75.75 0 0 1 .75.75v6.084a.75.75 0 0 1-1.5 0V15.16a.75.75 0 0 1 .75-.75M21.998 11.997a.75.75 0 0 1-.75.75h-6.084a.75.75 0 1 1 0-1.5h6.084a.75.75 0 0 1 .75.75M9.586 11.997a.75.75 0 0 1-.75.75H2.752a.75.75 0 1 1 0-1.5h6.084a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cn = { render: z4 }, g4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p4(a, l) {
  return r(), n("svg", g4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M13 16.969a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12.75 8.734a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.774 4.003c-.765-1.35-2.711-1.352-3.479-.003l-7.97 14.017c-.759 1.333.204 2.989 1.738 2.989h15.912c1.532 0 2.495-1.653 1.74-2.986zM20.41 18.76 12.469 4.743a.5.5 0 0 0-.87-.001L3.63 18.758a.5.5 0 0 0 .434.748h15.912a.5.5 0 0 0 .435-.747",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dn = { render: p4 }, M4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x4(a, l) {
  return r(), n("svg", M4, l[0] || (l[0] = [
    t('<mask id="mask0_5125_17" width="20" height="18" x="2" y="3" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="url(#paint0_linear_5125_17)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path></mask><g mask="url(#mask0_5125_17)"><path fill="url(#paint1_linear_5125_17)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path><circle cx="21.304" cy="10.25" r="4.875" fill="#80EAFF" style="mix-blend-mode:plus-darker;"></circle><circle cx="4.875" cy="4.875" r="4.875" fill="#80EAFF" style="mix-blend-mode:plus-darker;" transform="matrix(1 0 0 -1 7.125 26.625)"></circle><path fill="#fff" d="M13.207 8.09v9.66h-2.128v-6.846q0-.266.014-.518.013-.266.07-.532l-2.296.588-.252-1.386 2.464-.966z"></path><circle cx="8.161" cy="8.161" r="8.161" fill="#8FE4DA" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 25.125 18.5)"></circle><circle cx="19.125" cy="9.125" r="4.875" fill="#79CBC2" style="mix-blend-mode:lighten;"></circle><circle cx="2.696" cy="9.125" r="3.875" stroke="#79CBC2" stroke-width="2" style="mix-blend-mode:lighten;"></circle><circle cx="1" cy="1" r="1" fill="#8FE4DA" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 15.25 5.875)"></circle><circle cx="9.5" cy="17" r="1.438" fill="#79CBC2" fill-opacity=".6" style="mix-blend-mode:lighten;"></circle></g><defs><linearGradient id="paint0_linear_5125_17" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#48CDDB"></stop><stop offset="1" stop-color="#397FDB"></stop></linearGradient><linearGradient id="paint1_linear_5125_17" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#48CDDB"></stop><stop offset="1" stop-color="#397FDB"></stop></linearGradient></defs>', 3)
  ]));
}
const hn = { render: x4 }, _4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $4(a, l) {
  return r(), n("svg", _4, l[0] || (l[0] = [
    t('<mask id="mask0_5125_35" width="20" height="18" x="2" y="3" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="url(#paint0_linear_5125_35)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path></mask><g mask="url(#mask0_5125_35)"><path fill="url(#paint1_linear_5125_35)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path><circle cx="21.304" cy="10.25" r="4.875" fill="#84EE5D" style="mix-blend-mode:plus-darker;"></circle><circle cx="12" cy="21.75" r="4.875" fill="#84EE5D" style="mix-blend-mode:plus-darker;"></circle><path fill="#fff" d="M11.902 7.96q1.008 0 1.736.183.728.168 1.134.658t.406 1.414q0 .546-.14 1.022a3.2 3.2 0 0 1-.476.966q-.336.504-.98 1.19l-2.534 2.618q.35-.055.7-.07.364-.028.728-.028h2.982v1.876H8.542V16.64q0-.252.07-.462.07-.225.224-.406l2.408-2.576q.854-.881 1.302-1.568.462-.686.448-1.19-.014-.308-.168-.448-.14-.14-.434-.182a5 5 0 0 0-.728-.042q-.49 0-.924.014-.42 0-.91.028-.475.029-1.12.084l-.084-1.596q.686-.154 1.232-.224.56-.07 1.05-.084.504-.028.994-.028"></path><circle cx="8.161" cy="8.161" r="8.161" fill="#A1F850" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 25.625 18.5)"></circle><circle cx="19.125" cy="9.125" r="4.875" fill="#89E334" style="mix-blend-mode:lighten;"></circle><circle cx="2.696" cy="9.125" r="3.875" stroke="#89E334" stroke-width="2" style="mix-blend-mode:lighten;"></circle><circle cx="1" cy="1" r="1" fill="#A1F850" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 15.25 5.875)"></circle><circle cx="9.5" cy="17" r="1.438" fill="#89E334" fill-opacity=".6" style="mix-blend-mode:lighten;"></circle></g><defs><linearGradient id="paint0_linear_5125_35" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#48CDDB"></stop><stop offset="1" stop-color="#397FDB"></stop></linearGradient><linearGradient id="paint1_linear_5125_35" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#8CF25D"></stop><stop offset="1" stop-color="#0E9E18"></stop></linearGradient></defs>', 3)
  ]));
}
const sn = { render: $4 }, C4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H4(a, l) {
  return r(), n("svg", C4, l[0] || (l[0] = [
    t('<mask id="mask0_5125_46" width="20" height="18" x="2" y="3" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="url(#paint0_linear_5125_46)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path></mask><g mask="url(#mask0_5125_46)"><path fill="url(#paint1_linear_5125_46)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path><circle cx="12" cy="21.75" r="4.875" fill="#F2E120" style="mix-blend-mode:plus-darker;"></circle><circle cx="21.304" cy="10.25" r="4.875" fill="#F2E120" style="mix-blend-mode:plus-darker;"></circle><circle cx="19.125" cy="9.125" r="4.875" fill="#EADC47" style="mix-blend-mode:lighten;"></circle><path fill="#fff" d="M11.909 7.698q1.147 0 1.834.21.699.196 1.008.686.322.49.322 1.358 0 .672-.126 1.19a1.73 1.73 0 0 1-.448.826q-.322.323-.924.42v.056q.994.155 1.372.756.378.602.392 1.666.013 1.008-.308 1.652-.323.63-1.064.938-.729.294-1.96.294-.84 0-1.694-.084-.855-.07-1.652-.182l.084-1.568q.56.042.994.07l.854.028q.405.015.826.014.685 0 1.078-.112.392-.126.56-.434.168-.322.168-.896 0-.448-.126-.742a.8.8 0 0 0-.434-.462q-.323-.168-.938-.154l-1.834.014v-1.414h1.834q.461 0 .728-.098a.9.9 0 0 0 .392-.28.95.95 0 0 0 .182-.42q.042-.238.042-.518-.015-.462-.154-.7-.126-.238-.462-.322-.322-.084-.91-.084-.729 0-1.414.028l-1.19.028-.098-1.498a15 15 0 0 1 1.54-.196q.77-.07 1.526-.07"></path><circle cx="8.161" cy="8.161" r="8.161" fill="#EADC47" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 25.625 18.5)"></circle><circle cx="2.696" cy="9.125" r="3.875" stroke="#EADC47" stroke-width="2" style="mix-blend-mode:lighten;"></circle><circle cx="1" cy="1" r="1" fill="#FAEE6C" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 15.25 5.875)"></circle><circle cx="9.5" cy="17" r="1.438" fill="#EADC47" fill-opacity=".6" style="mix-blend-mode:lighten;"></circle></g><defs><linearGradient id="paint0_linear_5125_46" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#48CDDB"></stop><stop offset="1" stop-color="#397FDB"></stop></linearGradient><linearGradient id="paint1_linear_5125_46" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#EBE859"></stop><stop offset="1" stop-color="#DC9E0D"></stop></linearGradient></defs>', 3)
  ]));
}
const vn = { render: H4 }, V4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I4(a, l) {
  return r(), n("svg", V4, l[0] || (l[0] = [
    t('<mask id="mask0_5125_57" width="20" height="18" x="2" y="3" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="url(#paint0_linear_5125_57)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path></mask><g mask="url(#mask0_5125_57)"><path fill="url(#paint1_linear_5125_57)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path><circle cx="12" cy="21.75" r="4.875" fill="#F2E120" style="mix-blend-mode:plus-darker;"></circle><circle cx="21.304" cy="10.25" r="4.875" fill="#F2E120" style="mix-blend-mode:plus-darker;"></circle><circle cx="19.125" cy="9.125" r="4.875" fill="#EE9365" style="mix-blend-mode:lighten;"></circle><path fill="#fff" d="m12.152 8.09-2.324 5.558q-.097.224 0 .35.098.112.294.112h5.544v1.274l-1.19.21H8.582q-.391 0-.672-.21a1.1 1.1 0 0 1-.378-.56 1.07 1.07 0 0 1 .07-.7l2.534-6.034zm2.338 1.876v7.784h-1.974v-6.244l.35-1.54z"></path><circle cx="8.161" cy="8.161" r="8.161" fill="#ED915B" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 25.625 18.5)"></circle><circle cx="2.696" cy="9.125" r="3.875" stroke="#ED915B" stroke-width="2" style="mix-blend-mode:lighten;"></circle><circle cx="1" cy="1" r="1" fill="#FFBF9A" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 15.25 5.875)"></circle><circle cx="9.5" cy="17" r="1.438" fill="#ED915B" fill-opacity=".6" style="mix-blend-mode:lighten;"></circle></g><defs><linearGradient id="paint0_linear_5125_57" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#48CDDB"></stop><stop offset="1" stop-color="#397FDB"></stop></linearGradient><linearGradient id="paint1_linear_5125_57" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#F59F65"></stop><stop offset="1" stop-color="#DC4F0D"></stop></linearGradient></defs>', 3)
  ]));
}
const un = { render: I4 }, q4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L4(a, l) {
  return r(), n("svg", q4, l[0] || (l[0] = [
    t('<mask id="mask0_5125_68" width="20" height="18" x="2" y="3" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="url(#paint0_linear_5125_68)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path></mask><g mask="url(#mask0_5125_68)"><path fill="url(#paint1_linear_5125_68)" d="M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298"></path><circle cx="12" cy="21.75" r="4.875" fill="#D8A1FF" style="mix-blend-mode:plus-darker;"></circle><circle cx="21.304" cy="10.25" r="4.875" fill="#D8A1FF" style="mix-blend-mode:plus-darker;"></circle><circle cx="19.125" cy="9.125" r="4.875" fill="#D864F1" style="mix-blend-mode:lighten;"></circle><path fill="#fff" d="m15.017 7.922-.07 1.61h-4.018l-.112 1.82 1.414.154q.882.084 1.47.336.601.252.952.658.35.405.504.938t.154 1.19q0 .63-.154 1.204-.154.56-.532.994-.365.434-1.022.686-.659.238-1.68.238-.672 0-1.526-.084-.84-.07-1.708-.21l.196-1.638q.685.07 1.33.126.658.042 1.162.042.741 0 1.12-.154.378-.154.518-.462.153-.322.182-.798.014-.462-.112-.728a.84.84 0 0 0-.392-.434q-.266-.155-.714-.21-.435-.07-1.078-.112l-1.204-.14a.78.78 0 0 1-.476-.238.7.7 0 0 1-.168-.504l.238-4.284z"></path><circle cx="8.161" cy="8.161" r="8.161" fill="#D864F1" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 25.625 18.5)"></circle><circle cx="2.696" cy="9.125" r="3.875" stroke="#BE70E5" stroke-width="2" style="mix-blend-mode:lighten;"></circle><circle cx="1" cy="1" r="1" fill="#FFBF9A" style="mix-blend-mode:lighten;" transform="matrix(-1 0 0 1 15.25 5.875)"></circle><circle cx="9.5" cy="17" r="1.438" fill="#BE70E5" fill-opacity=".6" style="mix-blend-mode:lighten;"></circle></g><defs><linearGradient id="paint0_linear_5125_68" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#48CDDB"></stop><stop offset="1" stop-color="#397FDB"></stop></linearGradient><linearGradient id="paint1_linear_5125_68" x1="19.125" x2="6.875" y1="8" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#F065F5"></stop><stop offset="1" stop-color="#860DDC"></stop></linearGradient></defs>', 3)
  ]));
}
const mn = { render: L4 }, A4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y4(a, l) {
  return r(), n("svg", A4, l[0] || (l[0] = [
    e("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M10.162 4.103c.846-.535 1.269-.802 1.85-.802.58 0 .996.265 1.83.795a58 58 0 0 1 2.988 2.039 58 58 0 0 1 2.912 2.252c.735.61 1.103.915 1.282 1.466.18.552.061 1.013-.175 1.936-.23.9-.564 2.085-1.034 3.533a58 58 0 0 1-1.23 3.438c-.355.9-.534 1.35-1.003 1.69-.469.342-.957.373-1.933.436-.952.062-2.192.114-3.65.114-1.487 0-2.75-.055-3.709-.118-.943-.062-1.415-.093-1.883-.434-.469-.342-.638-.77-.977-1.628a60 60 0 0 1-1.245-3.498 60 60 0 0 1-1.045-3.543c-.232-.902-.348-1.353-.17-1.905s.547-.86 1.286-1.473a57 57 0 0 1 5.906-4.298Z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M11.836 8.032q1.525 0 2.268.532.742.518.742 1.638 0 .615-.252 1.064-.239.448-.602.826l-.728.756a4.2 4.2 0 0 0-.644.882q-.266.49-.322 1.204h-1.666q-.028-.742.154-1.288.182-.56.476-.98.307-.42.616-.756.308-.35.518-.658.224-.307.252-.63.043-.49-.266-.7-.307-.225-1.036-.224-.7 0-1.162.014-.448 0-.826.028-.364.015-.84.028l-.07-1.386q.392-.084.714-.14.336-.056.686-.098.364-.056.826-.084.476-.028 1.162-.028m-.126 7.84q.405 0 .56.168.154.155.154.56v.672q0 .405-.154.574-.155.154-.56.154h-.504q-.405 0-.56-.154-.154-.168-.154-.574V16.6q0-.405.154-.56.154-.168.56-.168z"
    }, null, -1)
  ]));
}
const wn = { render: y4 }, k4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S4(a, l) {
  return r(), n("svg", k4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.71 3.093a2 2 0 0 0-.765 3.847c.23.095.486.135.765.135.536 0 1.04-.198 1.408-.566a2.03 2.03 0 0 0 .583-1.425 1.99 1.99 0 0 0-1.99-1.991m-1.096-.646a2.86 2.86 0 0 1 3.115.618c.535.535.836 1.262.836 2.019 0 .754-.298 1.498-.836 2.036a2.8 2.8 0 0 1-1.587.787v.735l1.344.01.026.001 3.909.26c-.126-.167-.265-.36-.404-.568a8 8 0 0 1-.652-1.166c-.179-.407-.317-.855-.317-1.285a2.226 2.226 0 1 1 4.452 0c0 .395-.142.826-.318 1.218-.18.402-.417.808-.648 1.165-.18.28-.36.536-.513.743l.41.027a.43.43 0 0 1 .404.431v1.202a.43.43 0 0 1-.348.423l-5.016 1-.287.944c.329 1.476.597 2.91.866 4.347.245 1.308.49 2.618.781 3.962.06.275-.216.415-.394.415H13.55c-.229 0-.317-.069-.431-.406l-1.412-4.593-.073.23c.136.288.212.61.212.949 0 .395-.142.825-.318 1.218a9 9 0 0 1-.648 1.165c-.186.288-.371.55-.526.761l-.082.261c-.087.226-.203.407-.431.407H9.7a.4.4 0 0 1-.158.001l-1.412.007c-.374 0-.412-.159-.374-.415l.255-1.525a7 7 0 0 1-.3-.595c-.18-.408-.318-.855-.318-1.285 0-.886.518-1.65 1.267-2.01l.485-2.906-.224-.938-4.862-.994a.43.43 0 0 1-.345-.423V9.478c0-.17.098-.318.243-.388a6 6 0 0 1-.141-.297c-.18-.408-.317-.855-.317-1.285a2.226 2.226 0 0 1 4.452 0c0 .395-.142.825-.319 1.218l-.048.105 2.309-.144h.015l1.37-.037v-.738a2.6 2.6 0 0 1-.665-.174 2.863 2.863 0 0 1 0-5.291M7.09 9.727l-.103.164a15 15 0 0 1-.565.813l2.944.602c.165.034.295.16.334.323l.306 1.286a.4.4 0 0 1 .007.161c-.102.714-.24 1.66-.388 2.649a2.22 2.22 0 0 1 1.394.493c.1-.264.2-.513.294-.738a.432.432 0 0 1 .798.003c.73 1.772 1.847 5.424 1.847 5.424h.78s-1.097-5.683-1.422-7.827a.4.4 0 0 1 .014-.19l.391-1.287a.43.43 0 0 1 .329-.298l4.922-.98v-.443l-5.504-.366-1.753-.013-1.774.046zm-2.338.635-.172-.242v.207zm12.161-4.468a1.362 1.362 0 0 1 2.724 0c0 .211-.082.508-.242.864a8 8 0 0 1-.586 1.051c-.194.301-.388.574-.545.783-.152-.194-.34-.445-.526-.726a7 7 0 0 1-.581-1.035c-.157-.357-.244-.678-.244-.937M8.258 17.951a1.362 1.362 0 0 1 2.724 0c0 .21-.082.507-.242.864a8 8 0 0 1-.586 1.05c-.194.302-.388.574-.545.784-.152-.194-.34-.445-.526-.726a7 7 0 0 1-.581-1.035c-.157-.357-.244-.678-.244-.937M4.364 7.508a1.362 1.362 0 1 1 2.724 0c0 .211-.082.507-.243.864a8 8 0 0 1-.585 1.05c-.194.302-.389.574-.545.784-.152-.194-.34-.445-.526-.726a7 7 0 0 1-.582-1.035c-.157-.357-.243-.678-.243-.937",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "m10.945 3.245-.115-.277zm-.649.433.212.212zm-.433.649.277.115zm0 1.53.277-.114zm.433.65.212-.213zm.649.433-.115.277zm2.173-.431-.212-.212zm0-2.833-.212.212zm-2.504-1.23.115.278zm3.115.62.212-.213zm0 4.054-.212-.213zm-1.587.787-.043-.296-.257.037v.26zm0 .735h-.3v.298l.298.002zm1.344.01.002-.3zm.026.001.02-.3zm3.909.26-.02.3.654.043-.395-.523zm-.404-.568.25-.166zm-.652-1.166-.274.121zm3.817-.067.274.123zm-.648 1.165.252.163zm-.513.743-.241-.178-.324.441.545.036zm.41.027-.02.3zm.056 2.056.059.295zm-5.016 1-.058-.295-.177.035-.052.172zm-.287.944-.287-.087-.023.075.017.077zm.866 4.347-.295.055zm.781 3.962-.293.064zm-2.712.009-.287.088.003.008zm-1.412-4.593.286-.088-.284-.925-.289.923zm-.073.23-.286-.09-.035.113.05.105zm-.106 2.167-.274-.123zm-.648 1.165-.252-.163zm-.526.761-.242-.178-.03.04-.015.048zm-.082.261.28.107.003-.008.003-.009zm-.431.407v-.3h-.002zm-.14 0v-.3h-.029l-.027.006zm-.072.008.005.3zm-.086-.007.054-.295-.028-.005h-.028zm-1.412.007v.3h.002zm-.374-.415-.296-.049v.005zm.255-1.525.296.05.017-.106-.052-.092zm-.3-.595.274-.121zm.949-3.294.13.27.14-.067.026-.154zm.485-2.907.296.05.01-.06-.014-.06zm-.224-.938.292-.07-.044-.186-.188-.038zm-4.862-.994-.06.294zM3.958 9.09l.131.27.274-.134-.138-.272zm-.141-.297.274-.121zm3.816-.067-.273-.123zm-.048.105-.271-.128-.217.459.507-.032zm2.309-.144-.014-.3h-.005zm.015 0-.007-.3h-.006zm1.37-.037.007.3.292-.007V8.65zm0-.738h.3v-.264l-.262-.034zm-.665-.174.115-.277zm-.928-.621.212-.212zm-.621-.929-.277.115zm0-2.191-.277-.115zm.62-.93.213.213zm-2.7 6.824-.251-.163zm.104-.164-.018-.3-.154.01-.082.132zm-.668.977-.24-.179-.282.378.462.095zm2.944.602.06-.294zm.334.323-.292.07zm.306 1.286-.292.07zm.007.161.297.043zm-.388 2.649-.296-.044-.051.343h.347zm1.394.493-.189.234.322.26.147-.386zm.294-.738.277.116zm.4-.265v-.3zm.398.268-.278.114zm1.847 5.424-.287.088.065.212h.222zm.78 0v.3h.363l-.069-.356zm-1.422-7.827.297-.045zm.014-.19-.287-.088zm.391-1.287-.287-.087zm.329-.298.059.295zm4.922-.98.058.295.242-.048v-.247zm0-.443h.3v-.28l-.28-.02zm-5.504-.366.02-.3h-.018zm-1.753-.013.002-.3h-.01zM9.94 9.55l-.008-.3-.011.001zm-5.361.57.247-.17-.547-.792v.963zm.172.243-.06.294.757.155-.455-.625zm-.172-.035h-.3v.245l.24.05zm14.815-3.569.274.123zm-.586 1.051.252.163zm-.545.783-.235.186.242.308.234-.315zm-.526-.726-.25.167zm-.581-1.035-.275.121zM10.74 18.815l.274.123zm-.586 1.05-.252-.162zm-.545.784-.236.185.243.308.234-.314zm-.526-.726-.25.166zm-.581-1.035.274-.12zM6.845 8.372l.274.123zm-.585 1.05.252.163zm-.545.784-.236.185.242.308.235-.314zM5.19 9.48l.25-.166zm-.582-1.035.275-.12zm6.453-4.923a1.7 1.7 0 0 1 .65-.13v-.6a2.3 2.3 0 0 0-.88.176zm-.552.368a1.7 1.7 0 0 1 .552-.368l-.23-.554a2.3 2.3 0 0 0-.746.498zm-.368.552a1.7 1.7 0 0 1 .368-.552l-.424-.424a2.3 2.3 0 0 0-.498.746zm-.13.65a1.7 1.7 0 0 1 .13-.65l-.554-.23a2.3 2.3 0 0 0-.175.88zm.13.65a1.7 1.7 0 0 1-.13-.65h-.6c0 .302.06.601.176.88zm.368.552a1.7 1.7 0 0 1-.368-.551l-.554.23c.115.278.285.532.498.745zm.552.369a1.7 1.7 0 0 1-.552-.369l-.424.424c.214.214.467.383.746.499zm.65.112a1.7 1.7 0 0 1-.65-.112l-.23.554c.275.114.573.158.88.158zm1.196-.478a1.68 1.68 0 0 1-1.196.478v.6c.61 0 1.192-.226 1.62-.654zm.495-1.213c0 .454-.181.9-.495 1.213l.424.424a2.33 2.33 0 0 0 .671-1.637zm-.495-1.196c.317.317.495.747.495 1.196h.6c0-.608-.241-1.19-.67-1.62zm-1.196-.495c.449 0 .879.178 1.196.495l.424-.424a2.3 2.3 0 0 0-1.62-.671zm0-1.464c-.415 0-.827.082-1.21.24l.23.555c.31-.129.644-.195.98-.195zm2.231.924a3.16 3.16 0 0 0-2.23-.924v.6c.677 0 1.327.27 1.806.748zm.924 2.23c0-.836-.332-1.638-.924-2.23l-.424.424c.479.48.748 1.13.748 1.807zm-.924 2.249a3.2 3.2 0 0 0 .924-2.248h-.6c0 .676-.268 1.344-.748 1.823zm-1.756.872a3.1 3.1 0 0 0 1.756-.872l-.424-.425a2.5 2.5 0 0 1-1.418.704zm.257.438v-.735h-.6v.735zm1.046-.29-1.344-.01-.004.6 1.344.01zm.043.002-.043-.002-.004.6h.008zm3.91.26-3.91-.26-.04.598 3.91.26zm-.673-.103c.142.214.284.412.413.583l.48-.361a12 12 0 0 1-.394-.554zM16.09 7.3c.19.433.439.851.677 1.21l.5-.332a7.6 7.6 0 0 1-.628-1.12zm-.343-1.407c0 .49.156.981.343 1.406l.549-.242c-.172-.39-.292-.793-.292-1.164zm2.526-2.526a2.526 2.526 0 0 0-2.526 2.526h.6c0-1.063.863-1.926 1.926-1.926zM20.8 5.894a2.526 2.526 0 0 0-2.526-2.526v.6c1.064 0 1.926.863 1.926 1.926zm-.344 1.341c.181-.405.344-.882.344-1.34h-.6c0 .33-.121.714-.292 1.094zm-.67 1.205c.235-.365.48-.785.67-1.205l-.548-.246a9 9 0 0 1-.626 1.126zm-.523.758c.155-.211.339-.472.523-.758l-.504-.325a15 15 0 0 1-.502.727zm.188-.45-.41-.027-.04.598.41.028zm.684.73a.73.73 0 0 0-.684-.73l-.04.599c.07.004.124.062.124.131zm0 1.202V9.478h-.6v1.202zm-.59.718a.73.73 0 0 0 .59-.718h-.6a.13.13 0 0 1-.107.13zm-5.015.998 5.016-.998-.117-.589-5.016.999zm-.06.738.288-.945-.574-.174-.287.945zm.875 4.205a129 129 0 0 0-.868-4.357l-.586.13c.328 1.47.595 2.9.864 4.337zm.78 3.954c-.29-1.34-.535-2.646-.78-3.954l-.59.11c.245 1.307.49 2.621.783 3.97zm-.688.778a.77.77 0 0 0 .478-.173.6.6 0 0 0 .21-.605l-.587.127c.003.014 0 .013.002.007.002-.003.002 0-.008.009a.2.2 0 0 1-.049.026.2.2 0 0 1-.046.01zm-1.887 0h1.887v-.6H13.55zm-.715-.61c.057.17.127.339.254.455.148.135.32.155.461.155v-.6a.3.3 0 0 1-.067-.005l.011.007c.002.002-.007-.006-.025-.04a1 1 0 0 1-.066-.165zm-1.415-4.6 1.412 4.592.574-.176-1.413-4.593zm.5.231.073-.23-.573-.18-.072.23zm.226.859c0-.385-.086-.75-.24-1.076l-.543.255c.117.249.183.527.183.82zm-.345 1.34c.182-.404.345-.881.345-1.34h-.6c0 .331-.121.715-.292 1.095zm-.669 1.205c.235-.364.48-.784.67-1.204l-.548-.246c-.172.383-.4.774-.626 1.125zm-.537.777c.158-.214.347-.482.537-.777l-.504-.325c-.182.282-.364.54-.516.746zm-.037.173.082-.261-.573-.18-.081.262zm-.717.617c.206 0 .37-.087.488-.214.108-.116.176-.262.223-.386l-.56-.214a.6.6 0 0 1-.102.19.1.1 0 0 1-.023.02.1.1 0 0 1-.026.004zm-.138 0h.14l-.004-.6H9.7zm-.069.008a1 1 0 0 0 .125-.013l-.114-.59-.022.003zm-.145-.012a1 1 0 0 0 .145.012l-.011-.6q-.014 0-.026-.002zm-1.356.012 1.411-.007-.003-.6-1.411.007zm-.672-.76c-.02.126-.044.344.085.524.14.195.376.236.585.236v-.6a.4.4 0 0 1-.125-.013c-.009-.003.01.002.027.027.016.021.014.036.013.02a.5.5 0 0 1 .008-.104zm.255-1.53-.255 1.526.592.099.255-1.526zm-.28-.424c.094.213.202.422.315.621l.522-.295a6 6 0 0 1-.287-.568zm-.342-1.406c0 .49.156.98.343 1.406l.549-.242c-.172-.39-.292-.793-.292-1.164zm1.437-2.28a2.53 2.53 0 0 0-1.437 2.28h.6c0-.766.447-1.428 1.096-1.739zm.319-2.685-.485 2.906.592.1.485-2.907zm-.22-.82.224.939.584-.14-.224-.937zM4 11.396l4.862.995.12-.588-4.862-.994zm-.585-.716c0 .347.245.647.585.717l.12-.588a.13.13 0 0 1-.105-.13zm0-1.202v1.202h.6V9.478zm.411-.658a.73.73 0 0 0-.411.658h.6c0-.051.03-.097.074-.118zm-.284.094q.07.158.148.311l.535-.27a6 6 0 0 1-.134-.283zM3.2 7.508c0 .49.155.98.342 1.406l.55-.242c-.172-.39-.292-.793-.292-1.164zm2.526-2.526A2.526 2.526 0 0 0 3.2 7.508h.6c0-1.064.862-1.926 1.926-1.926zm2.526 2.526a2.526 2.526 0 0 0-2.526-2.526v.6c1.063 0 1.926.862 1.926 1.926zm-.345 1.34c.182-.404.345-.881.345-1.34h-.6c0 .331-.122.715-.292 1.095zm-.05.111.05-.11-.547-.246-.046.1zm2.018-.572-2.309.145.038.598 2.308-.144zm.021 0H9.88l.027.6.016-.001zm1.375-.036-1.37.035.016.6 1.37-.036zm-.293-.44v.74h.6v-.74zm-.478.104c.245.102.495.162.74.194l.077-.595a2.3 2.3 0 0 1-.588-.153zm-1.027-.686c.294.294.643.527 1.027.686l.23-.554a2.6 2.6 0 0 1-.832-.556zm-.685-1.026c.159.384.392.732.685 1.026l.425-.424a2.6 2.6 0 0 1-.556-.832zm-.241-1.21c0 .415.082.826.24 1.21l.555-.23a2.6 2.6 0 0 1-.195-.98zm.24-1.211c-.158.384-.24.795-.24 1.21h.6c0-.336.066-.67.195-.98zm.686-1.027a3.2 3.2 0 0 0-.685 1.027l.554.23c.129-.312.318-.594.556-.832zM10.5 2.17a3.2 3.2 0 0 0-1.027.685l.425.425c.238-.238.52-.427.831-.556zm-3.262 7.883.106-.167-.51-.317-.1.16zm-.576.83c.165-.223.37-.51.576-.83l-.504-.325c-.197.306-.394.582-.554.797zm2.763.129-2.944-.602-.12.588 2.944.602zm.566.548a.73.73 0 0 0-.566-.548l-.12.588c.05.01.09.049.102.098zm.306 1.286L9.99 11.56l-.584.138.306 1.287zm.012.273a.7.7 0 0 0-.012-.273l-.584.139a.1.1 0 0 1 .002.049zm-.388 2.65c.147-.988.286-1.936.388-2.65l-.594-.085c-.101.713-.24 1.659-.387 2.647zm1.286.216a2.52 2.52 0 0 0-1.582-.56l-.001.6c.457 0 .876.16 1.205.427zm-.172-.621q-.144.344-.297.748l.56.214q.151-.397.29-.73zm.678-.449a.73.73 0 0 0-.678.449l.554.232a.13.13 0 0 1 .122-.08zm.674.454a.73.73 0 0 0-.674-.454l-.002.6c.053 0 .1.033.121.082zm1.57 5.538.287-.087v-.003q-.002-.003-.003-.008l-.047-.15a128 128 0 0 0-.602-1.892c-.37-1.135-.835-2.5-1.205-3.399l-.555.23c.36.874.82 2.22 1.19 3.355a132 132 0 0 1 .636 2.001l.009.03.003.011zm.78-.3h-.78v.6h.78zm-1.718-7.482c.163 1.078.52 3.04.834 4.727a584 584 0 0 0 .541 2.863l.036.185.009.048.002.012v.003l.001.001.295-.057.294-.056v-.005l-.003-.012-.01-.048-.034-.184a511 511 0 0 1-.541-2.86c-.315-1.69-.67-3.641-.831-4.707zm.023-.323a.7.7 0 0 0-.023.323l.593-.09a.13.13 0 0 1 .004-.058zm.391-1.286-.391 1.286.574.175.391-1.286zm.557-.505a.73.73 0 0 0-.557.505l.574.175a.13.13 0 0 1 .1-.091zm4.922-.98-4.922.98.117.589 4.922-.98zm-.241-.149v.443h.6v-.443zm-5.224-.067 5.504.367.04-.6-5.504-.366zm-1.735-.012 1.753.013.004-.6-1.752-.013zm-1.764.046 1.774-.046-.015-.6-1.775.047zm-2.84.178 2.85-.178-.037-.599-2.85.178zm-2.776.263q.09.13.176.249l.485-.353q-.081-.113-.167-.237zm.547.037v-.207h-.6v.207zm-.068-.258-.172-.036-.12.588.172.035zm13.463-5.837c-.918 0-1.662.744-1.662 1.662h.6c0-.586.476-1.062 1.062-1.062zm1.662 1.662c0-.918-.744-1.662-1.662-1.662v.6c.587 0 1.062.476 1.062 1.062zm-.268.987c.165-.369.268-.712.268-.987h-.6c0 .147-.061.397-.216.741zm-.608 1.09c.223-.344.443-.723.608-1.09l-.548-.246c-.147.33-.35.68-.564 1.012zm-.556.8c.159-.213.358-.491.556-.8l-.504-.324c-.19.293-.38.56-.533.766zm-1.017-.738c.192.289.385.546.54.745l.472-.371c-.149-.19-.331-.434-.512-.707zm-.606-1.08c.164.372.384.746.606 1.08l.5-.333a7 7 0 0 1-.556-.99zm-.269-1.059c0 .319.105.684.27 1.058l.548-.241c-.15-.34-.218-.617-.218-.817zM9.62 16.29c-.918 0-1.662.744-1.662 1.662h.6c0-.587.476-1.062 1.062-1.062zm1.662 1.662c0-.918-.744-1.662-1.662-1.662v.6c.587 0 1.062.475 1.062 1.062zm-.268.987c.165-.37.268-.712.268-.987h-.6c0 .147-.061.397-.216.74zm-.608 1.09c.223-.344.443-.724.607-1.09l-.547-.246c-.147.329-.35.68-.564 1.011zm-.556.8c.159-.214.358-.492.556-.8l-.504-.325c-.19.294-.38.56-.533.766zm-1.017-.739c.192.29.384.546.54.745l.472-.37c-.149-.19-.331-.434-.512-.707zm-.606-1.08c.164.373.384.746.606 1.08l.5-.332a7 7 0 0 1-.557-.99zm-.269-1.058c0 .318.104.683.27 1.058l.548-.242c-.15-.34-.218-.617-.218-.816zM5.726 5.846c-.918 0-1.662.744-1.662 1.662h.6c0-.587.475-1.062 1.062-1.062zm1.662 1.662c0-.918-.744-1.662-1.662-1.662v.6c.586 0 1.062.475 1.062 1.062zm-.269.987c.166-.37.269-.712.269-.987h-.6c0 .147-.062.397-.216.741zm-.607 1.09a8.5 8.5 0 0 0 .607-1.09l-.547-.246a8 8 0 0 1-.564 1.011zm-.556.8c.159-.213.357-.492.556-.8l-.504-.325c-.19.294-.38.56-.534.766zm-1.017-.739c.192.29.384.547.54.745l.472-.37c-.149-.19-.331-.434-.513-.707zm-.606-1.08c.164.373.384.746.606 1.08l.5-.332a7 7 0 0 1-.557-.99zm-.27-1.058c0 .318.105.683.27 1.058l.55-.242c-.15-.34-.22-.617-.22-.816z"
    }, null, -1)
  ]));
}
const fn = { render: S4 }, D4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F4(a, l) {
  return r(), n("svg", D4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.955 4.709a.75.75 0 0 1 .75-.75h12.59a.75.75 0 0 1 .75.75v15.693a.75.75 0 0 1-.75.75H5.705a.75.75 0 0 1-.75-.75zm1.5.75v14.193h11.09V5.46z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.338 5.412a.75.75 0 0 1-.481.945l-1.34.435 1.901 5.88a.75.75 0 0 1-1.427.462L2.86 6.54a.75.75 0 0 1 .482-.944l2.051-.667a.75.75 0 0 1 .945.482M7.9 19.73a.75.75 0 0 1 .945.48l.032.097 2.839-.58a.75.75 0 0 1 .451 1.43l-3.547.804a.75.75 0 0 1-.939-.483l-.262-.803a.75.75 0 0 1 .48-.946M18.065 10.366a.75.75 0 0 1 .944.483l2.131 6.605a.75.75 0 0 1-.476.941l-2.131.713a.75.75 0 1 1-.476-1.423l1.428-.477-1.904-5.898a.75.75 0 0 1 .484-.944M15.374 2.035a.75.75 0 0 1 .945.482l.599 1.84a.75.75 0 1 1-1.427.464l-.367-1.128L8.798 5.42a.75.75 0 0 1-.463-1.426zM8.122 7.577a.75.75 0 0 1 .75-.75h6.303a.75.75 0 0 1 0 1.5H8.872a.75.75 0 0 1-.75-.75M8.122 10.089a.75.75 0 0 1 .75-.75h6.303a.75.75 0 0 1 0 1.5H8.872a.75.75 0 0 1-.75-.75M8.122 12.563a.75.75 0 0 1 .75-.75h6.303a.75.75 0 0 1 0 1.5H8.872a.75.75 0 0 1-.75-.75M8.122 15.069a.75.75 0 0 1 .75-.75h6.303a.75.75 0 0 1 0 1.5H8.872a.75.75 0 0 1-.75-.75M8.122 17.572a.75.75 0 0 1 .75-.75h6.303a.75.75 0 0 1 0 1.5H8.872a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zn = { render: F4 }, T4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b4(a, l) {
  return r(), n("svg", T4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 6.5c-4.682 0-7.371 3.73-8.358 5.467a.1.1 0 0 0-.01.033c0 .004 0 .015.01.033C4.63 13.771 7.318 17.5 12 17.5c4.685 0 7.356-3.735 8.33-5.468a.1.1 0 0 0 .011-.032c0-.004 0-.014-.01-.032C19.356 10.235 16.685 6.5 12 6.5m-9.662 4.726C3.372 9.406 6.447 5 12 5c5.56 0 8.616 4.416 9.638 6.233a1.55 1.55 0 0 1 0 1.534C20.616 14.584 17.56 19 12 19c-5.553 0-8.628-4.405-9.662-6.226a1.55 1.55 0 0 1 0-1.548",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.787 3.219a.75.75 0 0 1 0 1.06L4.285 20.78a.75.75 0 1 1-1.061-1.06l16.5-16.501a.75.75 0 0 1 1.061 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gn = { render: b4 }, E4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B4(a, l) {
  return r(), n("svg", E4, l[0] || (l[0] = [
    e("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m6.594 17.377 10.96-10.96"
    }, null, -1),
    e("circle", {
      cx: "12",
      cy: "12",
      r: "8.25",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1)
  ]));
}
const pn = { render: B4 }, P4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R4(a, l) {
  return r(), n("svg", P4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.777 8.241a.76.76 0 0 0 .759-.75l.026-2.21 2.983 2.984a5.25 5.25 0 0 1 0 7.424l-2.963 2.962v-2.18a.76.76 0 0 0-.75-.759.74.74 0 0 0-.75.741v3.987a.75.75 0 0 0 .749.772h.002l4 .046a.74.74 0 0 0 .75-.74.76.76 0 0 0-.75-.76l-2.21-.025 2.982-2.983a6.75 6.75 0 0 0 0-9.546L10.643 4.24h2.18a.76.76 0 0 0 .76-.75.74.74 0 0 0-.742-.75h-4a.75.75 0 0 0-.759.75l-.046 4a.74.74 0 0 0 .741.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mn = { render: R4 }, U4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O4(a, l) {
  return r(), n("svg", U4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.281 8.61a.75.75 0 0 0 0-1.5h-2.11a3.25 3.25 0 0 0-6.404 0H3.781a.75.75 0 0 0 0 1.5h8.075a3.251 3.251 0 0 0 6.225 0zM14.97 5.921a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m-5.813 8.656a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m11.125 2.469h-7.954a3.251 3.251 0 0 1-6.341 0H3.781a.75.75 0 1 1 0-1.5h2.22a3.251 3.251 0 0 1 6.31 0h7.97a.75.75 0 0 1 0 1.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const xn = { render: O4 }, G4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N4(a, l) {
  return r(), n("svg", G4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m20.196 6.298-1.501-1.73a1.24 1.24 0 0 0-1.559-.262l-1.138.658a8 8 0 0 0-1.416-.65L14.312 3A1.25 1.25 0 0 0 13.088 2h-2.26a1.25 1.25 0 0 0-1.225 1l-.27 1.314c-.76.263-1.47.637-2.11 1.102l-1.197-.538a1.24 1.24 0 0 0-1.523.419L3.18 7.173a1.26 1.26 0 0 0 .097 1.57l.896.988a8.3 8.3 0 0 0-.337 1.969l-1.169.62c-.52.275-.78.877-.621 1.444l.62 2.226c.159.57.696.95 1.288.908l1.307-.093a8.3 8.3 0 0 0 1.297 1.487l-.254 1.325c-.111.579.196 1.16.74 1.392l2.086.89a1.24 1.24 0 0 0 1.518-.445l.748-1.101a8.2 8.2 0 0 0 1.941-.1l.852 1.018a1.24 1.24 0 0 0 1.555.289l.99-.548.004-.003.994-.55c.517-.286.763-.895.595-1.459l-.385-1.292a8.3 8.3 0 0 0 1.146-1.615l1.309-.041a1.25 1.25 0 0 0 1.19-1.033l.197-1.14.002-.01.196-1.129a1.25 1.25 0 0 0-.764-1.375l-1.222-.495a8.3 8.3 0 0 0-.532-1.924l.794-1.076a1.26 1.26 0 0 0-.062-1.572M11.031 3.5l-.317 1.548a.75.75 0 0 1-.531.571 6.6 6.6 0 0 0-2.381 1.245.75.75 0 0 1-.783.104l-1.412-.634L4.518 7.88l1.06 1.168a.75.75 0 0 1 .15.758 6.8 6.8 0 0 0-.403 2.318v.032a.75.75 0 0 1-.398.664l-1.383.733.511 1.835 1.543-.11a.75.75 0 0 1 .697.362c.41.683.938 1.287 1.552 1.781a.75.75 0 0 1 .267.726l-.3 1.56 1.712.732.878-1.296a.75.75 0 0 1 .716-.323 6.6 6.6 0 0 0 2.335-.12.75.75 0 0 1 .746.25l1.002 1.196.808-.448.005-.002.818-.454-.454-1.523a.75.75 0 0 1 .193-.748 6.8 6.8 0 0 0 1.368-1.932.75.75 0 0 1 .655-.43l1.547-.049.161-.926.002-.01.164-.943-1.446-.586a.75.75 0 0 1-.465-.625 6.8 6.8 0 0 0-.634-2.293.75.75 0 0 1 .073-.769l.938-1.272-1.235-1.423-1.341.775a.75.75 0 0 1-.79-.024 6.5 6.5 0 0 0-1.838-.844.75.75 0 0 1-.53-.571L12.883 3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.958 7.624c-2.464 0-4.442 2.026-4.442 4.5 0 2.473 1.978 4.499 4.442 4.499 2.463 0 4.44-2.026 4.44-4.5 0-2.473-1.977-4.499-4.44-4.499m0 1.5c-1.614 0-2.942 1.332-2.942 3s1.328 2.999 2.941 2.999c1.614 0 2.942-1.332 2.942-3s-1.328-2.999-2.941-2.999",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _n = { render: N4 }, Q4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z4(a, l) {
  return r(), n("svg", Q4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.46 7.749a1.75 1.75 0 0 0-.43-2.438l-4.312-3.02a1.75 1.75 0 0 0-2.437.43L3.81 16.246a1.75 1.75 0 0 0 .429 2.438l4.313 3.02a1.75 1.75 0 0 0 2.437-.43zM19.17 6.54a.25.25 0 0 1 .062.348l-9.47 13.525a.25.25 0 0 1-.349.062L5.1 17.455a.25.25 0 0 1-.061-.348l9.47-13.525a.25.25 0 0 1 .348-.062z",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.346 6.27a.5.5 0 0 0-.123-.697L13.445 4.33a.5.5 0 1 0-.573.819l1.778 1.245a.5.5 0 0 0 .696-.123M12.896 8.424a.5.5 0 0 0-.123-.697l-1.397-.978a.5.5 0 0 0-.574.82l1.397.977a.5.5 0 0 0 .697-.122M11.679 11.508a.5.5 0 0 0-.123-.697L9.778 9.566a.5.5 0 0 0-.574.82l1.778 1.244a.5.5 0 0 0 .697-.122M9.228 13.661a.5.5 0 0 0-.123-.696l-1.397-.978a.5.5 0 0 0-.573.819l1.397.978a.5.5 0 0 0 .696-.123M8.05 16.69a.5.5 0 0 0-.123-.696L6.149 14.75a.5.5 0 0 0-.574.82l1.778 1.244a.5.5 0 0 0 .696-.122M18.503 4.242 7.025 20.634l1.229.86L19.732 5.102z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $n = { render: Z4 }, W4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j4(a, l) {
  return r(), n("svg", W4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 5.669a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.982 1.922a7.2 7.2 0 0 0-3.049.671 7.2 7.2 0 0 0-2.476 1.892 7.06 7.06 0 0 0-1.676 4.61v.207a8.2 8.2 0 0 0 .72 3.136c.611 1.365 1.566 2.543 2.439 3.62q.295.361.57.71l.013.016.014.016a9.9 9.9 0 0 1 2.084 3.782q.027.093.05.183c.073.277.139.525.368.752.256.255.477.399.956.399.255 0 .685-.086.978-.399.235-.25.334-.605.369-.727l.01-.034c.022-.067.054-.174.054-.174.321-1.623 1.365-2.906 2.378-4.152l.245-.302.223-.27c.093-.113.189-.227.275-.336 1.328-1.666 2.634-3.543 2.692-6.224v-.204a7.1 7.1 0 0 0-.814-3.314 7.2 7.2 0 0 0-1.771-2.183 7.2 7.2 0 0 0-2.477-1.337 7.4 7.4 0 0 0-2.172-.338zM4.781 9.096v-.003.005zm4.783-5.142a5.74 5.74 0 0 1 4.146-.262h.004a5.7 5.7 0 0 1 1.963 1.06 5.7 5.7 0 0 1 1.4 1.726c.424.807.644 1.704.642 2.614v.181c-.048 2.144-1.107 3.706-2.41 5.341q-.224.28-.457.565c-1.111 1.37-2.331 2.872-2.857 4.763a11.4 11.4 0 0 0-2.32-4.119 77 77 0 0 0-.618-.772c-.864-1.068-1.664-2.058-2.187-3.227v-.002a6.7 6.7 0 0 1-.59-2.551v-.183a5.56 5.56 0 0 1 1.323-3.635l.001-.002a5.7 5.7 0 0 1 1.96-1.497",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cn = { render: j4 }, K4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J4(a, l) {
  return r(), n("svg", K4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M9.476 1.969a.75.75 0 0 1 .75.75v1.5h6.016a.75.75 0 0 1 0 1.5h-1.767l-.011.033-.113.319c-.544 1.546-1.404 3.987-3.803 6.505.48.485.892.91 1.247 1.275l.282.293c.336.347.608.63.836.857a.75.75 0 0 1-1.06 1.06 76 76 0 0 1-.86-.88l-.276-.287c-.35-.361-.755-.778-1.226-1.254l-4.61 4.609a.75.75 0 1 1-1.06-1.06l4.62-4.62c-1.118-1.196-1.933-2.33-2.51-3.484a.75.75 0 0 1 1.341-.67c.493.984 1.204 1.989 2.226 3.088 2.072-2.188 2.857-4.286 3.387-5.784H2.742a.75.75 0 1 1 0-1.5h5.984v-1.5a.75.75 0 0 1 .75-.75"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.815 10.382a.75.75 0 0 0-1.397.003l-2.563 6.62-1.576 4.001a.75.75 0 0 0 1.395.55l1.391-3.53H19.2l1.359 3.525a.75.75 0 0 0 1.4-.54l-1.545-4.006zm.799 6.143h-2.965l1.473-3.803z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hn = { render: J4 }, X4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y4(a, l) {
  return r(), n("svg", X4, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M2.219 3.031a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-2.75v2.75a.75.75 0 0 1-1.5 0zM2.219 21c0 .414.336.75.75.75h3.5a.75.75 0 0 0 0-1.5h-2.75V17.5a.75.75 0 0 0-1.5 0zM21 2.281a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-2.75H17.5a.75.75 0 0 1 0-1.5zM21.75 21a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5h2.75V17.5a.75.75 0 0 1 1.5 0zM13.25 13a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25zM14.5 14.75a.25.25 0 0 1 .25-.25h1a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25zM16.25 13a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25zM17.5 14.75a.25.25 0 0 1 .25-.25h1a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25zM16.25 16a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25zM14.5 17.75a.25.25 0 0 1 .25-.25h1a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25zM13.25 16a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M17.5 17.75a.25.25 0 0 1 .25-.25h1a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm1.5 4v-3h3v3zM13.5 5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm1 1.5v3h3v-3zM5 13.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm1.5 4v-3h3v3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Vn = { render: Y4 }, l6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e6(a, l) {
  return r(), n("svg", l6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.101 13.062a.75.75 0 0 1 1.058-.08l5.588 4.803a.75.75 0 1 1-.977 1.137L15.18 14.12a.75.75 0 0 1-.08-1.058M8.618 2.039a.75.75 0 0 1 .927.516l1.55 5.44a.75.75 0 1 1-1.443.41l-1.55-5.44a.75.75 0 0 1 .516-.926M1.983 16.736a.75.75 0 0 1 .593-.88l6.102-1.19a.75.75 0 0 1 .287 1.473l-6.102 1.19a.75.75 0 0 1-.88-.593",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.94 18.469h12a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-12a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5m12 1.5h-12a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M10.36 9.682a1.58 1.58 0 1 0 .001-3.158 1.58 1.58 0 0 0 0 3.158M15.671 15.127a1.58 1.58 0 1 0 .001-3.159 1.58 1.58 0 0 0 0 3.159M8.825 16.917a1.58 1.58 0 1 0 0-3.158 1.58 1.58 0 0 0 0 3.158"
    }, null, -1)
  ]));
}
const In = { render: e6 }, n6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r6(a, l) {
  return r(), n("svg", n6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.25 4.5h-14a.5.5 0 0 0-.5.5v6.219h15V5a.5.5 0 0 0-.5-.5M4.75 19v-6.281h6.75V19.5H5.25a.5.5 0 0 1-.5-.5m8.25.5h6.25a.5.5 0 0 0 .5-.5v-6.281H13zM5.25 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qn = { render: r6 }, a6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t6(a, l) {
  return r(), n("svg", a6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.046 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.955a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-.5 2a.5.5 0 0 1 .5-.5h.955a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-.955a.5.5 0 0 1-.5-.5zM9.523 8.063a2 2 0 0 1 2-2h.954a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2h-.954a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5V18a.5.5 0 0 0 .5.5h.954a.5.5 0 0 0 .5-.5V8.064a.5.5 0 0 0-.5-.5zm-8.524 4.175a2 2 0 0 1 2-2h.955a2 2 0 0 1 2 2v6.262a2 2 0 0 1-2 2h-.955a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v6.262a.5.5 0 0 0 .5.5h.955a.5.5 0 0 0 .5-.5v-6.262a.5.5 0 0 0-.5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ln = { render: t6 }, o6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c6(a, l) {
  return r(), n("svg", o6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 1.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const An = { render: c6 }, i6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d6(a, l) {
  return r(), n("svg", i6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M7.801 16.544q1.491 1.092 4.137 1.092t3.927-1.197q1.281-1.218 1.281-3.318V5.868q0-.924.378-1.155.399-.252.924-.252h.672V3.432h-5.418v1.029h.651q.546 0 .924.231.399.231.399 1.092v7.295q0 1.533-.84 2.352-.84.798-2.394.798-1.47 0-2.373-.714t-.903-2.499V5.868q0-.924.378-1.155.399-.252.945-.252h.651V3.432H4.336v1.029h.651q.525 0 .924.231t.399 1.092v7.085q0 2.562 1.491 3.675M4.688 19.051a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
    }, null, -1)
  ]));
}
const yn = { render: d6 }, h6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s6(a, l) {
  return r(), n("svg", h6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.25 5.734c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zm.25 3v-1.5H6v1.5zm-.25 5.032c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zm.25 3v-1.5H6v1.5zM10 6.484a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zM10 14.516a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kn = { render: s6 }, v6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u6(a, l) {
  return r(), n("svg", v6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.334 12 3.882 18.886 5.22 14.59a.25.25 0 0 1 .178-.168l6.745-1.693.047-.013a.75.75 0 0 0-.054-1.449L5.263 9.543 3.882 5.115zm2.134-.691L3.482 3.294c-.786-.35-1.618.39-1.362 1.211l1.769 5.672c.12.382.43.675.818.773L8.89 12l-3.858.968a1.75 1.75 0 0 0-1.244 1.177l-1.669 5.35c-.256.82.576 1.56 1.362 1.21l18-8.02a.75.75 0 0 0-.014-1.376",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sn = { render: u6 }, m6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w6(a, l) {
  return r(), n("svg", m6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.75 19.5h-14a.5.5 0 0 1-.5-.5v-6.219h15V19a.5.5 0 0 1-.5.5M4.25 5v6.281H11V4.5H4.75a.5.5 0 0 0-.5.5m8.25-.5h6.25a.5.5 0 0 1 .5.5v6.281H12.5zM4.75 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dn = { render: w6 }, f6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z6(a, l) {
  return r(), n("svg", f6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 19.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fn = { render: z6 }, g6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p6(a, l) {
  return r(), n("svg", g6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12 9.516a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12.484 16.484a.5.5 0 0 0 .5-.5v-4.97a.5.5 0 0 0-.5-.5h-1.437a.75.75 0 0 0 0 1.5h.44v3.97a.5.5 0 0 0 .5.5z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tn = { render: p6 }, M6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function x6(a, l) {
  return r(), n("svg", M6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M12.727 6.734a.75.75 0 0 0-1.5 0v8.737l-2.712-2.712a.75.75 0 1 0-1.061 1.06l3.992 3.993a.75.75 0 0 0 1.06 0l3.993-3.993a.75.75 0 0 0-1.06-1.06l-2.712 2.712z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const bn = { render: x6 }, _6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function $6(a, l) {
  return r(), n("svg", _6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 3.75h-.052c-.898 0-1.648 0-2.242.08-.628.084-1.195.27-1.65.725-.456.456-.642 1.023-.726 1.65-.08.595-.08 1.345-.08 2.243v7.104c0 .899 0 1.648.08 2.242.084.628.27 1.195.725 1.65.456.456 1.023.642 1.65.726.595.08 1.345.08 2.243.08h9.104c.899 0 1.648 0 2.242-.08.628-.084 1.195-.27 1.65-.726.456-.455.642-1.022.726-1.65.08-.594.08-1.343.08-2.242V8.448c0-.898 0-1.648-.08-2.242-.084-.628-.27-1.195-.726-1.65-.455-.456-1.022-.642-1.65-.726-.594-.08-1.343-.08-2.242-.08H7.5M4.25 15.219v.281c0 .964.002 1.612.067 2.095.062.461.169.659.3.789s.327.237.788.3c.483.064 1.131.066 2.095.066h3.75v-3.531zm8.5 3.531h3.75c.964 0 1.612-.002 2.095-.067.461-.062.659-.169.789-.3s.237-.327.3-.788c.064-.483.066-1.131.066-2.095v-.281h-7zm7-5.031v-3.313h-7v3.313zm0-4.813V8.5c0-.964-.002-1.612-.067-2.095-.062-.461-.169-.659-.3-.789s-.327-.237-.788-.3c-.483-.064-1.131-.066-2.095-.066h-9c-.964 0-1.612.002-2.095.067-.461.062-.659.169-.789.3s-.237.327-.3.788c-.064.483-.066 1.131-.066 2.095v.406zm-15.5 1.5v3.313h7v-3.313z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const En = { render: $6 }, C6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function H6(a, l) {
  return r(), n("svg", C6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0m1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-4.017-2a.75.75 0 0 0-1.06-1.062l-4.532 4.533-2.314-2.314a.75.75 0 0 0-1.06 1.06l2.843 2.845a.75.75 0 0 0 1.061 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bn = { render: H6 }, V6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function I6(a, l) {
  return r(), n("svg", V6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "m8.535 14.267.632.405.326-.508-.427-.427zm1.196 1.192.53-.53-.427-.427-.508.326zm9.188-4.39.487.57.022-.019.02-.02zm-5.978-5.96-.53-.531-.018.019-.018.02zm-6.544 12.49-.63-.405a.75.75 0 0 0 1.036 1.036zm5.06-3.993a.75.75 0 0 0-1.06-1.061zm-.937-5.86a.75.75 0 0 0 .812-1.262zm-.142-.984-.406.63zM8.14 5.614l.11-.742a1 1 0 0 0-.094-.007zm-4.996 4.544.687.3zm-.177.775-.749.041a.75.75 0 0 0 1.162.585zm14.567 1.736a.75.75 0 1 0-1.26.815zm-.276.953-.63.408zm1.151 2.23.747-.067-.005-.043zm-4.632 4.939.27.7zm-.743.209-.607-.44a.75.75 0 0 0 .699 1.184zm5.397-10.502-4.747 4.05.974 1.14 4.747-4.049zm-9.005-.2 4.08-4.697-1.132-.984-4.08 4.698zm-2.5 7.832 4.53-4.524-1.06-1.061-4.53 4.524zm4.405-11.646-.548-.352-.812 1.26.548.353zm-.548-.352c-.54-.348-.98-.632-1.36-.837-.39-.21-.76-.362-1.173-.423l-.22 1.484c.176.026.374.094.681.26.317.17.7.417 1.26.777zM2.458 9.857a3 3 0 0 0-.217.749 2.3 2.3 0 0 0-.022.36v.007l.75-.04.748-.04v.016l.001-.008q0-.021.008-.082c.012-.082.04-.208.106-.36zm13.818 3.627.353.546 1.26-.815-.354-.546zm.353.546c.361.558.608.94.78 1.256.165.306.233.503.26.677l1.483-.22c-.061-.414-.214-.784-.425-1.172-.205-.38-.49-.818-.839-1.356zm-.254-5.062a.944.944 0 0 1-1.332 0l-1.06 1.063c.954.95 2.498.95 3.45 0zm-1.332 0a.93.93 0 0 1 0-1.321l-1.06-1.063a2.43 2.43 0 0 0 0 3.447zm0-1.321a.944.944 0 0 1 1.332 0l1.059-1.063a2.444 2.444 0 0 0-3.45 0zm1.332 0a.93.93 0 0 1 0 1.321l1.059 1.063a2.43 2.43 0 0 0 0-3.447zM2.968 10.933l.413.627v-.001l.007-.004a4 4 0 0 1 .158-.1c.11-.067.273-.164.474-.276.404-.225.952-.504 1.542-.732.598-.231 1.196-.393 1.71-.415.513-.023.847.094 1.058.305l1.061-1.06c-.619-.62-1.437-.777-2.184-.744-.746.033-1.517.256-2.186.515-.675.26-1.289.574-1.73.82a15 15 0 0 0-.678.402l-.04.026-.012.007-.003.002-.001.001zM13.035 21l.608.44.001-.002.003-.004.008-.011.029-.041q.038-.053.102-.15c.086-.127.205-.309.34-.532.27-.444.615-1.061.898-1.742.28-.671.52-1.454.54-2.215.019-.777-.197-1.601-.91-2.2l-.964 1.15c.258.216.386.534.374 1.013-.012.495-.177 1.08-.425 1.676a11.6 11.6 0 0 1-.793 1.538 13 13 0 0 1-.391.602l-.022.03-.005.007v.002zm.472-.909a3.4 3.4 0 0 1-.549.162l-.02.003h.005l.092.744.092.744h.005l.008-.001a1 1 0 0 0 .079-.013q.072-.012.193-.04c.159-.038.378-.1.636-.2zm-4.181-5.263-3.334 2.14.81 1.262 3.334-2.14zm-2.297 3.176 2.138-3.332-1.263-.81-2.138 3.332zm2.037-4.267c-.811-.81-.9-1.214-.857-1.508.027-.183.118-.418.328-.75.21-.333.509-.715.904-1.196L8.28 9.33c-.396.482-.747.927-1.011 1.345-.265.419-.476.86-.545 1.337-.15 1.03.389 1.893 1.28 2.785zM9.2 15.99c.917.917 1.82 1.317 2.837 1.122.462-.089.893-.292 1.3-.53.405-.239.83-.54 1.269-.853l-.87-1.222c-.45.32-.82.582-1.16.781-.337.199-.6.308-.821.35-.351.068-.78.007-1.495-.709zm4.847 5.5c.938-.363 2.218-1.22 3.24-2.201.517-.496.996-1.05 1.34-1.62.336-.56.59-1.215.529-1.884l-1.494.136c.02.215-.06.54-.32.974-.254.422-.636.873-1.093 1.311-.923.887-2.04 1.613-2.743 1.885zM3.832 10.46c.412-.942 1.175-2.007 2.034-2.826.428-.408.861-.738 1.266-.96.413-.225.747-.314.993-.309l.032-1.5c-.604-.012-1.204.197-1.745.494-.548.3-1.086.717-1.58 1.19-.986.938-1.872 2.163-2.374 3.31zM13.47 5.64c.26-.26.747-.57 1.407-.872a12.5 12.5 0 0 1 2.153-.74c.756-.185 1.476-.285 2.054-.278.625.009.901.141.979.219l1.06-1.063c-.517-.515-1.318-.646-2.018-.655-.747-.01-1.6.116-2.432.32-.837.206-1.682.497-2.419.833-.722.33-1.397.728-1.843 1.174zm5.978 5.96c.446-.445.846-1.118 1.176-1.838.337-.734.628-1.578.834-2.412.205-.83.333-1.683.323-2.428-.01-.7-.142-1.5-.659-2.016L20.064 3.97c.077.076.21.35.218.973.007.577-.093 1.295-.28 2.048a12.4 12.4 0 0 1-.74 2.147c-.302.658-.613 1.142-.872 1.4z"
    }, null, -1)
  ]));
}
const Pn = { render: I6 }, q6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function L6(a, l) {
  return r(), n("svg", q6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.787 3.219a.75.75 0 0 1 0 1.06L4.285 20.78a.75.75 0 1 1-1.061-1.06l16.5-16.501a.75.75 0 0 1 1.061 0",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.94 18.469h12a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-12a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5m12 1.5h-12a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M10.36 9.682a1.58 1.58 0 1 0 .001-3.158 1.58 1.58 0 0 0 0 3.158M15.671 15.127a1.58 1.58 0 1 0 .001-3.159 1.58 1.58 0 0 0 0 3.159M8.825 16.917a1.58 1.58 0 1 0 0-3.158 1.58 1.58 0 0 0 0 3.158"
    }, null, -1)
  ]));
}
const Rn = { render: L6 }, A6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function y6(a, l) {
  return r(), n("svg", A6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.25 7.288a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M12 3.038a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5m-5.542 14.29c0-.587.43-1.27 1.46-1.85 1.008-.566 2.449-.94 4.082-.94s3.074.374 4.081.94c1.03.58 1.46 1.263 1.46 1.85 0 1.042-.04 1.538-.51 1.92-.263.215-.722.439-1.542.605-.817.165-1.942.263-3.489.263s-2.672-.098-3.489-.263c-.82-.166-1.279-.39-1.543-.605-.47-.383-.51-.878-.51-1.92M12 13.037c-1.842 0-3.546.418-4.817 1.133-1.246.701-2.225 1.788-2.225 3.156v.093c-.001.904-.003 2.123 1.063 2.991.523.426 1.243.72 2.193.912.953.193 2.187.293 3.786.293s2.833-.1 3.786-.293c.95-.192 1.67-.486 2.193-.912 1.066-.868 1.064-2.087 1.063-2.99v-.094c0-1.368-.979-2.455-2.225-3.156-1.27-.715-2.975-1.133-4.817-1.133",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Un = { render: y6 }, k6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function S6(a, l) {
  return r(), n("svg", k6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.83 14.455a.75.75 0 0 1-1.06-1.06l3.67-3.67H8.25a4.75 4.75 0 1 0 0 9.5h8.628a.75.75 0 0 1 0 1.5H8.25a6.25 6.25 0 1 1 0-12.5h11.19l-3.67-3.67a.75.75 0 1 1 1.06-1.06l4.948 4.947a.76.76 0 0 1 .222.533.75.75 0 0 1-.223.534z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const On = { render: S6 }, D6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function F6(a, l) {
  return r(), n("svg", D6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.235 8.448a.75.75 0 0 0 0 1.403l.649.245a1 1 0 0 0-.009.116v3.513a1.5 1.5 0 0 0 0 2.599v.513a.75.75 0 0 0 1.5 0v-.513a1.5 1.5 0 0 0 0-2.599v-2.891l.307-.058 5.44 2.054a4.75 4.75 0 0 0 3.286.027l8.346-3.001a.75.75 0 0 0 0-1.412l-8.346-3.001a4.75 4.75 0 0 0-3.286.026zm7.154 1.439-1.877.354 3.14 1.186a3.25 3.25 0 0 0 2.248.018l6.384-2.295L12.9 6.854a3.25 3.25 0 0 0-2.248.018L4.622 9.15l.196.074 4.293-.811a.75.75 0 0 1 .278 1.474M5.75 16.828v-3.93l1.5.577v2.946c.166.09.413.21.75.331.786.283 2.075.585 4 .585s3.214-.302 4-.585c.337-.121.584-.24.75-.331v-3.154l1.5-.549v4.11c0 .22-.1.433-.267.574a2 2 0 0 1-.121.092 4 4 0 0 1-.28.179c-.24.14-.594.317-1.074.49-.961.347-2.423.674-4.508.674s-3.547-.327-4.508-.674a6.5 6.5 0 0 1-1.075-.49 4 4 0 0 1-.385-.258.76.76 0 0 1-.282-.587",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gn = { render: F6 }, T6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function b6(a, l) {
  return r(), n("svg", T6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.01 6.25h5.229c.899 0 1.648 0 2.243.08.628.084 1.195.27 1.65.725.455.456.641 1.023.726 1.65.08.595.08 1.345.08 2.243v2.104c0 .899 0 1.648-.08 2.242-.085.628-.27 1.195-.726 1.65-.455.456-1.022.642-1.65.726-.595.08-1.344.08-2.242.08h-5.23c-.898 0-1.647 0-2.242-.08-.628-.084-1.195-.27-1.65-.726-.456-.455-.641-1.022-.726-1.65-.08-.594-.08-1.344-.08-2.242v-.239h-2.55A1.499 1.499 0 0 1 2 12a1.5 1.5 0 0 1 2.834-.687h2.479v-.365c0-.899 0-1.648.08-2.242.084-.628.27-1.195.725-1.65.455-.456 1.022-.642 1.65-.726.595-.08 1.344-.08 2.242-.08M9.969 7.817c-.462.062-.66.169-.79.3s-.237.327-.299.788c-.065.483-.066 1.131-.066 2.095v2c0 .964.001 1.612.066 2.095.062.461.17.659.3.789s.327.237.789.3c.483.064 1.13.066 2.095.066h5.124c.964 0 1.612-.002 2.095-.067.462-.062.66-.169.79-.3s.237-.327.299-.788c.065-.483.067-1.131.067-2.095v-2c0-.964-.002-1.612-.067-2.095-.062-.461-.17-.659-.3-.789s-.327-.237-.789-.3c-.483-.064-1.13-.066-2.094-.066h-5.125c-.965 0-1.612.002-2.095.067m1.282 2.105a.75.75 0 0 0 0 1.5H18a.75.75 0 0 0 0-1.5zm-.719 3.406a.75.75 0 0 1 .75-.75h4.428a.75.75 0 0 1 0 1.5H11.28a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nn = { render: b6 }, E6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function B6(a, l) {
  return r(), n("svg", E6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M7.551 4.493a9.028 9.028 0 1 1-1.789 13.522.75.75 0 0 1 1.123-.995 7.527 7.527 0 1 0-1.209-8.124l1.75-.454a.75.75 0 0 1 .377 1.452l-3.469.9a.75.75 0 0 1-.91-.526l-.945-3.406a.75.75 0 1 1 1.446-.4l.459 1.657a9.03 9.03 0 0 1 3.167-3.626"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M12.545 7.575a.75.75 0 0 1 .75.75v3.853l2.252 2.283a.75.75 0 0 1-1.067 1.053l-2.47-2.501a.75.75 0 0 1-.215-.527V8.325a.75.75 0 0 1 .75-.75"
    }, null, -1)
  ]));
}
const Qn = { render: B6 }, P6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function R6(a, l) {
  return r(), n("svg", P6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M20.75 20.009a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25zM20.5 12.997a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5zM21 7.485a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5zM20.75 16.978a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25z"
    }, null, -1)
  ]));
}
const Zn = { render: R6 }, U6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function O6(a, l) {
  return r(), n("svg", U6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.832 2.82a.75.75 0 0 0-1.5 0v7.628L8.199 9.316a.75.75 0 1 0-1.06 1.06L9.55 12.79a.75.75 0 0 0 1.061 0l2.413-2.413a.75.75 0 0 0-1.06-1.06l-1.133 1.132zM7.099 6.17h.119a.75.75 0 1 1 0 1.5h-.07c-.728 0-1.2.001-1.546.048-.326.044-.428.114-.485.171s-.127.16-.171.485c-.047.346-.048.817-.048 1.546v4.678c0 .728.001 1.2.048 1.546.044.326.114.428.171.485s.16.127.485.171c.346.047.817.048 1.546.048h5.928c.728 0 1.199-.001 1.546-.048.325-.044.427-.114.484-.172.057-.056.128-.159.172-.484.046-.347.048-.817.048-1.546V9.801c0-.67-.002-1.101-.041-1.422-.038-.303-.1-.402-.147-.456a1 1 0 0 0-.066-.066c-.054-.047-.152-.109-.455-.146-.321-.04-.754-.041-1.422-.041a.75.75 0 0 1 0-1.5h.045c.61 0 1.137 0 1.562.052.453.056.891.183 1.263.51q.105.094.198.198c.328.372.454.81.51 1.264.053.424.053.95.053 1.562v4.892c0 .665 0 1.237-.062 1.696-.066.492-.215.963-.597 1.345-.382.383-.854.532-1.345.598-.46.061-1.032.061-1.697.061H7.098c-.665 0-1.238 0-1.696-.061-.492-.066-.963-.215-1.345-.598-.383-.382-.532-.853-.598-1.345-.062-.459-.061-1.032-.061-1.696V9.87c0-.665 0-1.238.061-1.696.066-.492.215-.963.598-1.345.382-.383.853-.532 1.345-.598.459-.062 1.032-.061 1.697-.061m11.32 3.58c1.206 0 2.183.978 2.183 2.183v6.296c0 .665 0 1.238-.061 1.696-.066.492-.215.963-.598 1.345-.382.383-.853.532-1.345.598-.458.062-1.031.062-1.696.062H9.129a1.955 1.955 0 0 1-1.955-1.955h1.5c0 .25.204.454.455.454h7.723c.729 0 1.2-.001 1.546-.048.326-.044.428-.114.485-.171s.128-.16.171-.485c.047-.347.048-.817.048-1.546v-6.246a.68.68 0 0 0-.682-.682z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wn = { render: O6 }, G6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function N6(a, l) {
  return r(), n("svg", G6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.313 3.031h-.053c-1.723 0-3.087 0-4.154.132-1.094.136-1.99.421-2.703 1.078-.722.665-1.044 1.514-1.195 2.55-.146.994-.146 2.26-.146 3.837v.157c0 1.54 0 2.617.15 3.423.17.911.534 1.51 1.19 2.114.714.657 1.61.942 2.704 1.077q.402.049.863.077c.004 1.573.051 2.404.586 2.938.585.586 1.528.586 3.414.586h5c1.885 0 2.828 0 3.414-.586s.586-1.528.586-3.414v-1c0-1.886 0-2.828-.586-3.414-.217-.217-.482-.353-.826-.44.006-.409.006-.86.006-1.361v-.158c0-1.576 0-2.842-.146-3.837-.15-1.035-.473-1.884-1.195-2.55-.713-.656-1.609-.941-2.703-1.077-1.067-.132-2.43-.132-4.154-.132zm6.745 8.975c.004-.381.005-.816.005-1.319 0-1.65-.002-2.807-.13-3.68-.123-.845-.35-1.316-.727-1.663-.385-.354-.922-.575-1.87-.692-.965-.12-2.236-.12-4.024-.12s-3.058 0-4.022.12c-.949.117-1.486.338-1.871.692-.376.347-.604.818-.727 1.663-.109.744-.126 1.693-.129 2.978l.298-.26a2.54 2.54 0 0 1 3.469.116l2.175 2.175C10.918 12 11.401 12 11.97 12h5q.605-.002 1.09.006m-9.285.4L7.27 10.9a1.04 1.04 0 0 0-1.42-.047l-1.283 1.122c.009.897.035 1.497.121 1.957.105.563.29.878.732 1.285.385.355.922.575 1.87.693q.317.039.68.062V16c0-1.886 0-2.828.586-3.414q.1-.102.218-.18m5.82-4.347a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M10.97 14.28a.75.75 0 1 0 0 1.5h7a.75.75 0 1 0 0-1.5zm5 2.938h-5a.75.75 0 1 0 0 1.5h5a.75.75 0 0 0 0-1.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const jn = { render: N6 }, Q6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Z6(a, l) {
  return r(), n("svg", Q6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M3.5 3.75A.75.75 0 0 1 4.25 3h15.563a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V4.5h-6.25v15h1.937a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h2.063v-15H5v1.75a.75.75 0 0 1-1.5 0z"
    }, null, -1)
  ]));
}
const Kn = { render: Z6 }, W6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function j6(a, l) {
  return r(), n("svg", W6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.103 4.07a.75.75 0 0 1 .81-.535l.41.05c.7.084 1.399.169 2.092.287.152-.061.292-.154.43-.245l.072-.047.133-.088c.368-.244.758-.502 1.2-.557.85-.113 1.531.22 2.112.504.735.36 1.313.988 1.496 1.806.12.531.052.972-.049 1.347-.035.133-.079.27-.117.391q-.025.077-.059.162c-.072.183-.151.387-.086.56a.5.5 0 0 0 .147.183c.22.193.623.395 1.266.633.232.085.688.172 1.323.247.614.073 1.33.128 2.038.17.432.027.865.042 1.298.057.631.022 1.262.044 1.89.1.42.037.848.207 1.232.513.495-.35.725-.812.761-1.274.047-.592-.217-1.303-.9-1.898a.75.75 0 0 1 .984-1.131c.985.856 1.502 2.01 1.412 3.148-.074.922-.54 1.759-1.348 2.348.278.6.45 1.358.45 2.278 0 .758.007 1.787.014 2.833v.001c.004.547.008 1.098.01 1.618.005.755.007 1.443.004 1.948a26 26 0 0 1-.01.618c-.008.259-.032.521-.217.721a.75.75 0 0 1-.499.24q-.753.053-1.505.002c-.44-.003-.89-.168-1.171-.517-.461-.573-.292-1.428.076-2.004l-.967-3.475a7.9 7.9 0 0 0-2.116.166c-.73.16-1.549.377-2.19.555-.238.066-.45.127-.623.177l-.557 4.468a.75.75 0 0 1-.744.657H9.303a1.36 1.36 0 0 1-.98-.404 1.33 1.33 0 0 1-.384-1.035c.043-.483.208-.945.476-1.345l-.268-3.097-.353-.972c-.48-1.314-.97-2.624-1.521-3.91a25 25 0 0 0-.665-1.441c-.228-.448-.41-.74-.523-.865-.03-.034-.13-.113-.363-.24-.16-.087-.333-.172-.528-.267l-.238-.117-.066-.033c-.59-.29-1.276-.63-1.589-1.236a2.79 2.79 0 0 1-.198-2.055m6.932 3.454q-.02.363.109.712c.121.32.328.576.562.781.447.391 1.082.67 1.735.911.416.154 1.033.255 1.666.33a38 38 0 0 0 2.124.178c.427.026.856.04 1.285.055.62.022 1.242.043 1.86.098.238.021 1.224.424 1.224 2.49 0 .763.007 1.802.014 2.852v.004c.004.544.008 1.091.01 1.604.005.815.007 1.547.003 2.046q-.327 0-.654-.024c-.025-.001.164-.31.188-.334a.75.75 0 0 0 .187-.726l-1.207-4.338a.75.75 0 0 0-.633-.544c-1.851-.223-3.613.229-5.381.721-.491.137-.875.25-1.037.298-.312.094-.57.31-.612.65l-.536 4.3h-.478c.05-.212.15-.41.293-.577a.75.75 0 0 0 .177-.551l-.3-3.482a1.4 1.4 0 0 0-.113-.391l-.044-.114-.274-.753c-.49-1.34-.99-2.675-1.551-3.987a26 26 0 0 0-.707-1.532c-.229-.448-.486-.9-.744-1.185-.214-.24-.514-.42-.76-.555a16 16 0 0 0-.617-.312l-.202-.099a7 7 0 0 1-.703-.387c-.25-.166-.336-.26-.398-.54l.25.031c.566.073 1.18.157 1.459.208.308.057.618-.032.895-.165.228-.11.439-.25.65-.388.152-.1.304-.2.462-.29a.9.9 0 0 1 .203-.082l-.126 2.514a.75.75 0 0 0 .892.774h.002l.006-.002.02-.004a8 8 0 0 0 .308-.067c.136-.033.308-.076.493-.128m-.117-2.612c.231.16.4.378.48.673q.02.1.023.203l-.007.003c-.135.072-.33.148-.551.219z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jn = { render: j6 }, K6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function J6(a, l) {
  return r(), n("svg", K6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 5a3 3 0 0 1-2.25 2.905v3.16a.25.25 0 0 0 .25.248h5.072a3.001 3.001 0 1 1 .048 1.5H8.5q-.127 0-.25-.018v5.19c0 .137.112.25.25.25h5.103a3.001 3.001 0 0 1 5.897.78 3 3 0 0 1-5.913.72H8.5a1.75 1.75 0 0 1-1.75-1.75V7.904A3.001 3.001 0 0 1 7.5 2a3 3 0 0 1 3 3m-3 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m9 14.016a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5-8.547a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xn = { render: J6 }, X6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function Y6(a, l) {
  return r(), n("svg", X6, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.279 3.648a.75.75 0 1 0-1.5 0v1.454H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-1.72V3.648a.75.75 0 0 0-1.5 0v1.454H8.279zm7.501 3.5v-.546H8.279v.546a.75.75 0 0 1-1.5 0v-.546H5a.5.5 0 0 0-.5.5v2.375h15V7.102a.5.5 0 0 0-.5-.5h-1.72v.546a.75.75 0 0 1-1.5 0m3.72 3.829h-15v8.125a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yn = { render: Y6 }, l8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function e8(a, l) {
  return r(), n("svg", l8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M4.203 7.64h.98V4.07h-.87l-1.225.999.5.615.405-.334q.135-.12.225-.23-.015.285-.015.63zM8.758 5.105a.75.75 0 1 0 0 1.5h11.5a.75.75 0 0 0 0-1.5zM3.031 13.76h2.59v-.796h-1.35v-.024q.594-.533.775-.723.183-.19.293-.361a1.36 1.36 0 0 0 .214-.74.9.9 0 0 0-.15-.505.96.96 0 0 0-.423-.35 1.5 1.5 0 0 0-.618-.121q-.276 0-.498.056a1.6 1.6 0 0 0-.408.163 2.8 2.8 0 0 0-.464.352l.53.62a2.4 2.4 0 0 1 .388-.283.7.7 0 0 1 .342-.098q.165 0 .254.08a.28.28 0 0 1 .09.22.5.5 0 0 1-.046.215q-.044.103-.159.247-.114.142-.488.532l-.872.882zM8.758 11.2a.75.75 0 1 0 0 1.5h11.5a.75.75 0 0 0 0-1.5zM5.502 17.085a.86.86 0 0 1-.202.572q-.203.236-.586.344v.015q.893.112.893.844a.91.91 0 0 1-.395.784q-.393.285-1.094.286-.288 0-.535-.042a3 3 0 0 1-.53-.151v-.801q.235.12.477.178.243.057.449.056.317 0 .461-.088.147-.09.147-.28 0-.147-.076-.225a.5.5 0 0 0-.244-.12 2 2 0 0 0-.44-.041h-.22v-.725h.225q.735 0 .735-.376a.23.23 0 0 0-.11-.21.54.54 0 0 0-.29-.068q-.342 0-.708.23l-.4-.645q.282-.195.578-.279a2.5 2.5 0 0 1 .681-.083q.555 0 .87.22t.314.605M8.008 18.095a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1-.75-.75"
    }, null, -1)
  ]));
}
const lr = { render: e8 }, n8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function r8(a, l) {
  return r(), n("svg", n8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M8.246 5.25v1.5H17a.25.25 0 0 1 .25.25v8.75h1.5V7A1.75 1.75 0 0 0 17 5.25z"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M21 17.25a.75.75 0 0 1 0 1.5h-2.25V21a.75.75 0 0 1-1.5 0v-2.25H7A1.75 1.75 0 0 1 5.25 17V6.75H3a.75.75 0 0 1 0-1.5h2.25V3a.75.75 0 0 1 1.496-.077v6.186h.004V17c0 .138.112.25.25.25z"
    }, null, -1)
  ]));
}
const er = { render: r8 }, a8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function t8(a, l) {
  return r(), n("svg", a8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m1.969-1.761A7.5 7.5 0 0 1 12 19.5a7.5 7.5 0 0 1-3.173-.702.9.9 0 0 1 .14-.36c.107-.157.321-.348.798-.558.895-.395 1.235-1.26 1.063-2.039-.167-.757-.806-1.409-1.73-1.51-.407-.044-.808-.011-1.1.013q-.127.011-.225.016c-.31.017-.544-.003-.823-.14a.7.7 0 0 1-.266-.202.3.3 0 0 1-.056-.136.2.2 0 0 1 .015-.105l.01-.022c.32-.223.473-.253.718-.301.143-.028.318-.062.575-.145.407-.13.677-.427.836-.718s.234-.622.24-.934c.013-.552-.22-1.456-1.131-1.673a3.7 3.7 0 0 0-.982-.086 13 13 0 0 0-.355.018l-.054.003c-.13.008-.249.014-.368.015a2.7 2.7 0 0 1-1.262-.267 7.5 7.5 0 0 1 1.835-2.979q.096.114.209.221c.335.323.823.644 1.475.674.595.027 1.03-.186 1.306-.321l.033-.017c.28-.137.376-.167.516-.15a.9.9 0 0 1 .283.097l.112.055c.117.06.285.145.424.203.509.214 1.126.327 2.026.113.98-.233 1.709-.917 2.167-1.528.15-.2.278-.401.384-.594a7.5 7.5 0 0 1 2.087 1.716 3.7 3.7 0 0 0-.916.18c-.617.21-1.02.56-1.313.9a2.7 2.7 0 0 0-.502.923c-.046.14-.083.278-.114.395l-.01.035c-.028.107-.05.195-.077.279-.057.184-.106.273-.155.329-.037.042-.113.109-.315.16-.181.045-.38.08-.615.121l-.212.038a7 7 0 0 0-.994.24c-.325.113-.7.295-.98.621-.304.355-.433.804-.381 1.306.039.38.196.707.458.957.246.234.543.36.807.436.424.122.944.156 1.37.184l.21.014c.53.038.889.092 1.115.204a.36.36 0 0 1 .155.125c.022.035.059.114.059.287 0 .278-.072.37-.11.413-.068.074-.183.143-.436.252l-.092.039c-.211.088-.527.22-.787.415-.353.265-.629.653-.704 1.214-.065.48.008.91.194 1.282.154.31.37.548.587.733m1.692-.692q-.054-.03-.103-.057l-.042-.023a4 4 0 0 1-.518-.324.9.9 0 0 1-.273-.305c-.043-.087-.078-.211-.05-.415.016-.123.053-.165.117-.213.1-.074.22-.125.44-.22l.132-.056c.258-.111.643-.284.947-.616.333-.362.506-.836.506-1.427 0-.397-.089-.765-.287-1.082a1.85 1.85 0 0 0-.756-.671c-.53-.265-1.183-.323-1.677-.359l-.255-.018h-.003c-.436-.03-.762-.052-1.017-.125a.6.6 0 0 1-.183-.078l-.004-.027c-.013-.13.016-.163.026-.174l.001-.002c.032-.037.121-.107.335-.181.209-.073.464-.126.768-.181l.171-.03.003-.001c.242-.042.512-.09.75-.15q.675-.169 1.075-.621c.256-.29.383-.616.464-.878.036-.116.067-.236.095-.338l.01-.036c.03-.117.057-.215.088-.309.06-.182.125-.31.213-.413.171-.198.363-.359.66-.46.29-.098.735-.159 1.436-.071.493 1 .77 2.124.77 3.314a7.5 7.5 0 0 1-3.84 6.547M14.253 4.845a4 4 0 0 1-.197.29c-.349.466-.808.85-1.313.97-.586.139-.878.056-1.098-.036-.098-.041-.162-.074-.243-.116-.06-.031-.13-.067-.228-.114a2.4 2.4 0 0 0-.748-.232c-.608-.074-1.054.144-1.337.282l-.018.009c-.287.14-.418.196-.614.187-.166-.007-.327-.086-.503-.255a2 2 0 0 1-.086-.09A7.47 7.47 0 0 1 12 4.5c.785 0 1.542.12 2.253.344m-9.706 6.314a7.489 7.489 0 0 0 2.957 6.846 2.3 2.3 0 0 1 .224-.413c.325-.475.816-.813 1.432-1.084.122-.054.167-.116.187-.157a.28.28 0 0 0 .017-.186c-.033-.147-.164-.313-.429-.342-.252-.027-.448-.011-.702.01-.112.008-.236.019-.381.026-.448.024-.967 0-1.561-.29-1.458-.714-1.452-2.368-.511-3.032.598-.422 1.191-.544 1.516-.61q.096-.02.159-.036l.01-.016a.6.6 0 0 0 .058-.252.5.5 0 0 0-.028-.19 2.3 2.3 0 0 0-.54-.034c-.098.003-.197.009-.31.015l-.058.004q-.2.012-.437.017a4.2 4.2 0 0 1-1.603-.276",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const nr = { render: t8 }, o8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function c8(a, l) {
  return r(), n("svg", o8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.365 19.617c-.097-.487.08-1.013.354-1.292l-.116-.44c-.246-.922-.803-2.98-.902-3.057-.127-.1-.93-.133-2.514.23l-.163.038c-1.231.282-1.896.434-2.163.535.134.294.21.62.21.964 0 .411-.149.86-.332 1.269-.117.26-.257.521-.403.771a42 42 0 0 1-.16 1.353c-.095.6-.407.597-1.337.584h-.032a.4.4 0 0 1-.123-.002h-.046c-1.087-.012-1.372-.566-1.407-1.015a1.9 1.9 0 0 1 .062-.637 8 8 0 0 1-.531-.985c-.187-.424-.33-.89-.33-1.338 0-.738.344-1.395.88-1.82l-.923-2.504c-.029-.069-.082-.203-.154-.383-.41-1.032-1.42-3.566-1.817-3.87-.14-.107-.39-.222-.686-.359-.687-.317-1.617-.745-1.954-1.44-.481-.994-.271-1.841.079-2.084.23-.16 1.038-.023 1.736.096.363.061.696.118.904.125.308.011.554-.172.828-.376.265-.197.556-.414.956-.494.813-.164 1.273.017 2.026.37q.108.07.21.133c.337.205.64.39 1.007 1.019.44.755.163 1.689-.037 2.331s-.081.944 1.248 1.434c.25.092.597.166 1.004.226-.174-.409-.305-.853-.305-1.281a2.32 2.32 0 0 1 4.639 0c0 .412-.148.86-.332 1.269a7 7 0 0 1-.14.294c.734.035 1.352.068 1.69.12.448.07.903.303 1.287.713.653-.392.972-.962 1.02-1.55.053-.678-.251-1.452-.972-2.08a.45.45 0 1 1 .59-.679c.902.785 1.358 1.824 1.278 2.83-.07.885-.552 1.69-1.407 2.222.287.576.468 1.327.468 2.265v.82c0 2.381.001 5.633-.03 6.12-.033.514-.49.513-1.443.511h-.186c-1.08 0-1.434-.469-1.53-.956m-1.271-9.459-.028.043a16 16 0 0 1-.942 1.305l-.017.02-.004.007-.002.002a.45.45 0 0 1-.683.013l-.002-.002-.005-.006-.018-.02a8 8 0 0 1-.283-.34 13 13 0 0 1-.86-1.21l-.19-.022c-.596-.069-1.196-.168-1.637-.33a7 7 0 0 1-.906-.397 2.2 2.2 0 0 1-.686-.551c-.368-.467-.354-.96-.274-1.334q-.12.042-.24.08a10 10 0 0 1-.99.253l-.017.004h-.005l-.002.001a.45.45 0 0 1-.536-.464l.136-2.705a.5.5 0 0 1 .045-.176 1.7 1.7 0 0 0-.49.039c-.18.036-.323.131-.61.345l-.04.03c-.233.175-.71.535-1.343.513a6 6 0 0 1-.733-.09l-.301-.05-.487-.08a7 7 0 0 0-.541-.066l-.002.014c-.018.186.012.481.187.842.1.208.397.456.93.732.196.102.388.19.582.28l.157.072c.208.097.499.233.709.394.2.153.344.373.425.503.102.162.206.355.308.556.204.405.427.902.634 1.389.292.683.605 1.467.772 1.886l.114.284.014.035.637 1.725.25.68a2.32 2.32 0 0 1 2.204.529c.143-.082.293-.13.374-.155q.21-.066.513-.14c.374-.094.904-.215 1.606-.376l.17-.039c.826-.19 1.474-.281 1.95-.31q.357-.021.628.004c.088.009.187.023.284.049.078.02.246.07.408.196a1 1 0 0 1 .236.274l.001.002c.028.048.049.093.062.122.027.061.052.127.073.187.044.122.094.279.146.449.105.344.23.787.35 1.22a138 138 0 0 1 .426 1.575l.039.147a.9.9 0 0 1-.228.858.5.5 0 0 0-.095.192.64.64 0 0 0-.02.295c.018.087.041.106.058.119.03.022.174.113.591.113h.198a18 18 0 0 0 .543-.004c.019-.993.018-3.682.018-5.75v-.797c0-2.094-.978-2.75-1.501-2.831-.223-.035-.638-.063-1.213-.092l-.674-.033zm-6.27-3.95.023-.05.003-.029c.029-.297-.01-.509-.103-.668-.174-.298-.304-.427-.402-.507a2 2 0 0 0-.205-.141l-.073-.045h-.001l-.196-.122-.072-.033-.102 2.045a8 8 0 0 0 .352-.1c.235-.075.454-.158.615-.243a1 1 0 0 0 .158-.103zm4.918 4.321c.163-.218.366-.502.568-.816.227-.352.447-.733.61-1.095.167-.371.253-.68.253-.9a1.42 1.42 0 0 0-2.839 0c0 .27.09.604.254.976.162.367.38.74.606 1.079.194.293.39.554.548.756M9.74 19.406c.162-.219.365-.503.567-.816.227-.352.448-.733.61-1.095.167-.371.253-.68.253-.9a1.42 1.42 0 0 0-2.838 0c0 .27.09.604.254.976.161.367.38.74.605 1.079.195.292.39.553.549.756",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "m17.72 18.325.213.21.12-.122-.044-.164zm-.117-.44.29-.078zm-.902-3.057-.185.236zm-2.514.23.067.293zm-.163.038.067.292zm-2.163.535-.106-.28-.3.114.133.291zm-.122 2.233-.274-.123zm-.403.771-.259-.151-.032.055-.007.064zm-.16 1.353.297.047zm-1.337.584.004-.3zm-.032 0 .004-.3h-.02l-.021.002zm-.047.003.006.3zm-.076-.005.045-.296-.021-.003h-.02zm-.046 0 .003-.3zM8.23 19.555l.299-.024zm.062-.637.29.08.034-.128-.07-.111zm-.531-.985-.275.121zm.55-3.158.187.235.17-.135-.075-.204zm-.923-2.504.282-.104-.005-.012zm-.154-.383.279-.111v-.001zm0 0-.279.11V12zm-1.817-3.87-.182.239zm-.686-.359-.125.273zM2.778 6.22l-.27.13zm.079-2.084.17.247zm1.736.096.05-.296zm.904.125.01-.3zm.828-.376-.18-.24zm.956-.494-.06-.294zm2.026.37.165-.25-.018-.012-.02-.009zm.21.133-.156.256zm1.007 1.019-.259.151zm-.037 2.331L10.2 7.25zm1.248 1.434-.104.282zM12.74 9l-.043.297.53.077-.21-.492zm4.002-.012-.274-.123zm-.14.294-.268-.136-.21.414.463.022zm1.69.12.046-.296zm1.287.713-.22.205.166.177.208-.125zm1.02-1.55-.3-.024zm-.972-2.08-.197.227zm-.045-.634.227.197zm.635-.045-.197.227zm1.278 2.83-.299-.024zm-1.407 2.222-.158-.255-.232.144.122.245zm.468 2.265h-.3zm0 .82h-.3zm-.03 6.12-.3-.019zm-1.443.511v-.3zm-.186 0v-.3zm-2.802-10.415.014-.3-.174-.008-.093.147zm-.028.043.252.162zm-.661.945-.24-.181zm-.219.282-.235-.186zm-.062.078.233.19v-.001zm-.017.02.232.19h.001zm-.004.007.231.19zm-.002.002.231.19zm-.339.164.006.3zm-.344-.15-.224.199zm-.002-.003-.225.199zm-.005-.006-.226.198.001.001zm-.018-.02-.226.198zm-.063-.072-.228.194zm-.22-.268.234-.187zm-.666-.909-.25.166zm-.193-.302.255-.157-.077-.126-.147-.015zm-.19-.02-.035.297zm-1.638-.331-.104.281zm-.906-.397.145-.263zm-.686-.551-.236.186zm-.274-1.334.293.063.113-.526-.506.18zm-.24.08-.09-.287zm-.699.19-.068-.293zm-.226.05.062.294zm-.065.013.06.295zm-.017.004.057.294h.001zm-.005 0 .057.295zm-.002.001.057.295zm0 0 .056.295zm-.381-.102-.197.227zm-.155-.362.3.015zm.136-2.705-.3-.015zm.045-.176.27.132.193-.395-.438-.036zm-.49.039L7.4 4.074zm-.61.345-.179-.241zm-.04.03-.18-.24zm-1.343.513.01-.3zm-.733-.09.049-.295zm-.301-.05.05-.296zm-.487-.08.045-.296zm-.541-.066.022-.3-.29-.021-.03.289zm-.002.014-.298-.032v.002zm.187.842-.27.131zm.93.732.139-.266zm.582.28-.126.272.006.003zm0 0 .134-.268-.007-.004-.007-.003zm0 0-.134.268.009.004zm.157.072.126-.272zm.709.394.182-.238zm.425.503-.254.16zm.308.556-.268.135zm.634 1.389-.276.118zm.772 1.886.279-.11zm0 0-.279.111zm.114.284.277-.116zm.014.035-.281.105zm.637 1.725.282-.103zm.25.68-.281.104.095.26.268-.075zm2.204.529-.203.22.16.149.192-.108zm.374-.155.09.286zm.513-.14-.073-.292zm1.606-.376.067.292h.001zm0 0-.068-.292zm0 0-.067-.293h-.001zm.17-.039.066.293zm1.95-.31-.018-.3zm.628.004.029-.298zm.284.049.076-.29zm.408.196.185-.236zm.236.274-.26.148zm.001.002-.26.15zm.062.122-.274.122zm.073.187.283-.101zm.146.449-.287.088zm.35 1.22-.289.08zm.322 1.186.29-.077zm.104.389.29-.077zm.039.147.29-.077zm0 0 .29-.076zm-.228.858-.214-.21zm-.095.192.288.084zm-.02.295.295-.06zm.058.119-.18.24zm.591.113v-.3zm.198 0v.3zm0 0 .001-.3zm.484-.002.008.3zm.06-.002.01.3.284-.011.005-.284zm.017-5.75h-.3zm0-.797h-.3zm-1.501-2.831-.046.296zm-1.213-.092.015-.3zm-.674-.033-.014.3zM9.847 6.16l.266.138.026-.05.006-.058zm-.022.05.202.221.053-.049.026-.067zm.025-.08.298.031v-.002zm-.103-.668.259-.15zm-.402-.507-.189.233zm-.205-.141-.159.254zm-.073-.045-.157.256zm0 0 .156-.256-.001-.001zm0 0-.157.256h.001zm0 0-.157.256zm-.001 0-.156.255zm0 0 .156-.257-.003-.001zm0 0-.157.255.003.002zm-.196-.122.161-.253-.017-.01-.018-.01zm-.072-.033.127-.273-.404-.187-.022.445zm-.102 2.045-.3-.015-.02.41.397-.105zm.352-.1.09.285zm.615-.243.14.265zm.158-.103.2.223.002-.002zm5.489 3.501.252.163zm-.568.816-.236.185.243.309.234-.315zm1.178-1.91.274.122zm-2.332.075-.274.121zm.606 1.079.25-.166zm-3.887 8.817-.252-.163zm-.567.816-.236.185.242.308.234-.314zm1.178-1.911.273.123zm-2.332.076-.275.12zm.605 1.079.25-.166zm8.314-.535c-.345.352-.55.979-.434 1.561l.588-.118c-.078-.391.072-.816.274-1.023zm-.192-.153.085.32.023.088.006.023.002.006v.001l.29-.075.29-.076v-.002l-.002-.006-.006-.024-.109-.41zm-.797-2.898c-.038-.03-.056-.06-.057-.062q-.007-.01-.004-.005l.023.054q.033.087.085.25c.069.213.154.502.245.82.182.638.382 1.38.505 1.841l.58-.154c-.124-.462-.325-1.209-.508-1.85-.091-.321-.179-.618-.25-.84a6 6 0 0 0-.097-.282 1 1 0 0 0-.073-.156.4.4 0 0 0-.079-.088zm-2.262.287c.78-.18 1.36-.258 1.755-.282.197-.012.342-.009.44 0q.072.008.097.016c.024.006.003.005-.03-.02l.37-.473a.5.5 0 0 0-.188-.088 1 1 0 0 0-.191-.031 3.5 3.5 0 0 0-.534-.003c-.435.026-1.049.112-1.853.296zm-.163.037.163-.037-.134-.585-.163.037zm-2.123.524a7 7 0 0 1 .684-.19c.35-.085.822-.193 1.439-.334l-.134-.585c-.615.141-1.091.25-1.447.337-.35.085-.602.152-.755.21zm-.38-.156c.117.255.182.539.182.839h.6a2.6 2.6 0 0 0-.236-1.088zm.182.839c0 .348-.127.75-.305 1.146l.547.245c.19-.42.358-.916.358-1.391zm-.305 1.146c-.111.247-.245.5-.388.743l.518.303c.15-.257.295-.528.417-.8zm-.427.862c-.068.62-.125 1.136-.157 1.337l.592.095c.035-.22.094-.757.161-1.367zm-.157 1.337a.6.6 0 0 1-.07.225c-.017.024-.038.044-.09.062a1.1 1.1 0 0 1-.308.044c-.15.007-.335.004-.57.001l-.008.6c.23.003.433.006.605-.002a1.7 1.7 0 0 0 .48-.077.76.76 0 0 0 .386-.29c.092-.135.14-.296.167-.468zm-1.038.332H9.81l-.008.6h.032zm-.073.002-.016.001.012.6a1 1 0 0 0 .078-.006zm-.016.001-.025-.001-.09.593q.063.01.127.008zm-.12.595h.046l.007-.6h-.046zm-1.702-1.291c.021.276.122.606.404.868.282.261.706.417 1.299.423l.006-.6c-.494-.005-.756-.133-.897-.263a.7.7 0 0 1-.214-.476zm.072-.74c-.069.25-.091.5-.072.74l.598-.048a1.6 1.6 0 0 1 .053-.534zm.543-.08a7.5 7.5 0 0 1-.51-.946l-.55.241c.158.36.354.709.552 1.024zm-.51-.946c-.18-.407-.305-.83-.305-1.218h-.6c0 .507.16 1.017.355 1.46zm-.305-1.218c0-.642.299-1.214.767-1.585l-.373-.47a2.62 2.62 0 0 0-.994 2.055zm-.624-4.22.923 2.504.563-.208-.923-2.504zm-.151-.376c.07.178.125.316.156.388l.553-.232c-.028-.066-.08-.196-.152-.378zm0 0 .557-.223zM5.236 8.258s.01.008.032.035q.03.037.075.103.089.136.203.351c.152.288.325.658.5 1.055.352.795.705 1.681.91 2.198l.558-.222c-.205-.516-.562-1.412-.918-2.218a18 18 0 0 0-.52-1.093c-.08-.153-.159-.29-.232-.402A1.2 1.2 0 0 0 5.6 7.78zm-.63-.325c.312.143.523.243.63.325L5.6 7.78c-.173-.132-.463-.264-.743-.393zM2.509 6.349c.203.42.573.738.952.983.382.248.806.443 1.147.6l.251-.545c-.347-.16-.732-.338-1.071-.558-.342-.222-.606-.466-.739-.741zm.177-2.46c-.275.191-.437.565-.478.977-.042.426.039.942.301 1.483l.54-.261c-.219-.452-.274-.857-.244-1.163.032-.321.15-.492.224-.543zm1.958.046c-.346-.059-.734-.125-1.066-.155a3 3 0 0 0-.47-.013c-.129.008-.293.032-.422.122l.343.493c-.014.009.01-.01.118-.017q.147-.009.376.012c.304.028.669.09 1.021.15zm.864.121c-.182-.006-.49-.058-.864-.12l-.1.59c.353.06.71.122.943.13zm.639-.316c-.295.219-.454.323-.639.316l-.02.6c.432.015.764-.246 1.017-.435zm1.075-.548c-.474.095-.814.354-1.075.548l.358.48c.27-.2.51-.375.836-.44zm2.214.393c-.375-.176-.706-.324-1.053-.4a2.7 2.7 0 0 0-1.16.007l.118.588c.371-.075.647-.069.912-.01.274.06.55.18.928.358zm.239.148a7 7 0 0 1-.202-.127l-.33.501q.116.075.22.138zm1.11 1.124a3 3 0 0 0-.571-.738c-.188-.173-.372-.284-.539-.386l-.313.512c.17.103.306.187.446.316.138.126.287.305.458.598zm-.01 2.571c.099-.32.228-.74.27-1.183.043-.445.002-.937-.26-1.388l-.519.302c.178.305.218.657.182 1.028-.036.374-.146.74-.247 1.063zm1.065 1.064a6 6 0 0 1-.743-.322c-.178-.098-.272-.178-.323-.243-.073-.093-.094-.197 0-.499L10.2 7.25c-.105.34-.166.708.102 1.049.12.152.292.28.505.396.213.118.486.235.824.36zm.944.21c-.402-.06-.724-.13-.944-.21l-.208.563c.28.103.651.18 1.065.24zm.232.18c-.166-.392-.28-.793-.28-1.164h-.6c0 .485.146.972.328 1.398zm-.28-1.164a2.02 2.02 0 0 1 2.018-2.02v-.6a2.62 2.62 0 0 0-2.619 2.62zm2.018-2.02a2.02 2.02 0 0 1 2.02 2.02h.6a2.62 2.62 0 0 0-2.62-2.62zm2.02 2.02c0 .348-.128.75-.306 1.146l.548.246c.19-.422.358-.917.358-1.392zm-.306 1.146a7 7 0 0 1-.134.281l.535.272q.077-.153.147-.307zm1.87.24c-.357-.055-.996-.088-1.723-.123l-.028.6c.742.035 1.341.067 1.66.117zm1.46.805c-.427-.456-.941-.724-1.46-.804l-.092.593c.377.058.772.256 1.114.62zm.501-1.369c-.039.488-.301.973-.875 1.316l.309.515c.733-.44 1.11-1.095 1.164-1.783zm-.87-1.83c.662.576.915 1.26.87 1.83l.598.048c.063-.788-.292-1.65-1.073-2.33zm-.073-1.057a.75.75 0 0 0 .074 1.058l.394-.453a.15.15 0 0 1-.015-.212zm1.058-.074a.75.75 0 0 0-1.058.074l.453.394a.15.15 0 0 1 .211-.015zm1.38 3.08c.09-1.115-.418-2.243-1.38-3.08l-.394.453c.842.732 1.248 1.683 1.176 2.58zm-1.548 2.453c.932-.58 1.47-1.468 1.548-2.453l-.598-.048c-.062.785-.488 1.507-1.266 1.991zm.61 2.01c0-.976-.188-1.774-.5-2.399l-.537.268c.263.527.437 1.231.437 2.131zm0 .82v-.82h-.6v.82zm-.03 6.14c.031-.5.03-3.77.03-6.14h-.6c0 2.392 0 5.626-.03 6.101zm-1.743.791c.456.001.859.005 1.145-.072a.8.8 0 0 0 .42-.246.78.78 0 0 0 .177-.474l-.599-.038c-.005.084-.025.111-.033.12-.009.011-.037.036-.121.059-.19.05-.491.052-.988.051zm-.186 0h.186v-.6h-.185zm-1.825-1.197c.059.296.202.608.51.841.305.23.735.356 1.316.356v-.6c-.5 0-.787-.108-.954-.235a.76.76 0 0 1-.284-.48zm-1.23-9.68-.027.042.504.325.028-.043zm-.027.042c-.236.367-.472.693-.649.927l.48.361c.182-.242.427-.58.673-.963zm-.649.927q-.134.178-.214.277l.47.373c.055-.069.132-.167.223-.289zm-.214.277-.06.075.466.378.065-.08zm-.06.075-.017.02.466.38.017-.022zm-.016.02-.005.005.465.38.004-.005zm-.004.005-.002.002.464.381.001-.002zm-.002.002a.15.15 0 0 1-.113.055l.012.6a.75.75 0 0 0 .564-.274zm-.113.055a.15.15 0 0 1-.115-.05l-.447.399a.75.75 0 0 0 .574.25zm-.114-.05-.002-.002-.449.398.002.003zm-.002-.002-.005-.005-.449.397.005.006zm-.004-.004-.017-.02-.451.396.017.02zm-.017-.02-.06-.07-.457.389.065.076zm-.06-.07q-.08-.093-.215-.26l-.468.375q.14.175.226.274zm-.215-.26a13 13 0 0 1-.65-.888l-.5.332c.25.375.497.7.682.93zm-.65-.888a11 11 0 0 1-.188-.293l-.51.315q.098.16.198.31zm-.668.141.193.022.063-.597-.187-.02zM11.32 9.9c.478.176 1.108.278 1.707.347l.07-.596c-.595-.069-1.164-.164-1.569-.314zm-.946-.415c.27.149.59.283.947.415l.207-.563a6.5 6.5 0 0 1-.865-.378zm-.778-.628c.225.285.513.482.778.628l.289-.526a1.9 1.9 0 0 1-.596-.474zm-.331-1.583c-.09.42-.114 1.018.331 1.583l.471-.372c-.29-.37-.286-.758-.216-1.085zm.143.429q.123-.038.25-.083l-.2-.566a7 7 0 0 1-.23.076zm-.72.195c.191-.044.452-.11.72-.195l-.18-.573c-.25.08-.495.142-.677.184zm-.233.053q.087-.018.233-.053l-.137-.584q-.138.033-.22.05zm-.067.013.067-.013-.124-.587-.062.012zm-.019.004.018-.003-.118-.589-.017.004zm-.005.001h.004l-.115-.59-.005.002zm-.002 0h.001l-.115-.588h-.001zm-.001 0-.114-.588zM7.725 7.8a.75.75 0 0 0 .634.17l-.114-.59a.15.15 0 0 1-.127-.033zm-.257-.604a.75.75 0 0 0 .257.604l.393-.453a.15.15 0 0 1-.051-.12zm.135-2.705-.135 2.705.599.03.135-2.705zm.076-.293a.75.75 0 0 0-.076.293l.6.03a.2.2 0 0 1 .014-.059zm-.16.465c.182-.037.306-.042.404-.034l.05-.598a2 2 0 0 0-.574.044zm-.491.291c.295-.22.385-.27.49-.291L7.4 4.074c-.257.052-.452.191-.73.398zm-.04.03.04-.03-.36-.48-.04.03zm-1.534.573c.75.026 1.304-.4 1.535-.574l-.361-.479c-.236.178-.636.471-1.152.453zm-.77-.093c.238.039.53.084.77.093l.022-.6a6 6 0 0 1-.695-.085zm-.303-.051.303.05.097-.591-.3-.05zm-.483-.08.483.08.1-.592q-.24-.04-.492-.08zm-.517-.063q.205.016.517.064l.091-.593a8 8 0 0 0-.564-.07zm.319-.254.001-.014-.596-.063-.002.014zm.158.68c-.153-.315-.17-.555-.158-.682l-.597-.059c-.024.247.018.597.215 1.003zm.799.597a3.6 3.6 0 0 1-.579-.36.8.8 0 0 1-.22-.236l-.54.261c.078.161.216.308.386.444q.26.208.676.424zm.569.274c-.195-.09-.38-.176-.57-.274l-.276.533c.203.105.401.196.595.285zm-.006-.003-.24.55zm.014.007-.268.536zm.15.068-.158-.072-.251.544.155.072zm.764.428c-.24-.185-.563-.334-.765-.428l-.253.544c.215.1.474.223.653.36zm.498.582c-.083-.132-.251-.393-.498-.582l-.365.476c.153.118.274.296.354.424zm.32.58a7 7 0 0 0-.32-.58l-.509.318c.095.151.194.335.294.532zm.643 1.406a26 26 0 0 0-.642-1.406l-.536.27c.2.396.42.887.626 1.372zm.775 1.893a89 89 0 0 0-.775-1.893l-.552.236c.29.68.602 1.46.77 1.88zm0 0-.558.222zm.112.28-.112-.28-.558.223.117.289zm.018.046-.018-.047-.553.233.009.023zm.638 1.726-.638-1.726-.562.209.637 1.724zm.25.68-.25-.68-.563.207.25.68zm-.2.392q.262-.075.549-.076v-.6a2.6 2.6 0 0 0-.712.098zm.549-.076c.529 0 1.01.203 1.37.536l.407-.44a2.6 2.6 0 0 0-1.777-.696zm1.857-.125c-.083.026-.259.082-.432.18l.297.522c.113-.065.235-.104.316-.13zm.53-.146c-.203.051-.383.1-.53.146l.18.572q.196-.061.496-.136zm1.612-.377c-.7.16-1.234.283-1.612.377l.146.582c.37-.092.896-.213 1.6-.374zm-.002 0 .137.585zm.001 0 .136.585zm.17-.038-.169.038.134.585.17-.039zm2-.317c-.497.03-1.161.125-2 .317l.134.585c.815-.187 1.446-.276 1.902-.303zm.675.005c-.2-.02-.428-.02-.675-.005l.036.599q.342-.021.58.003zm.331.057a2 2 0 0 0-.331-.057l-.058.597q.119.011.238.04zm.517.25a1.4 1.4 0 0 0-.517-.25l-.151.58a.8.8 0 0 1 .297.142zm.311.36c-.02-.035-.12-.21-.311-.36l-.37.472c.098.077.151.17.16.186zm.002.003-.002-.002-.52.298v.002zm.075.15a2 2 0 0 0-.076-.151l-.52.3c.02.036.037.07.048.094zm.082.207a3 3 0 0 0-.082-.208l-.548.244c.022.05.044.109.064.165zm.15.463a11 11 0 0 0-.15-.463l-.566.202c.042.115.09.267.142.436zm.352 1.227a53 53 0 0 0-.352-1.228l-.574.175c.103.34.228.78.348 1.213zm.323 1.189c-.086-.322-.202-.754-.323-1.19l-.578.16c.12.434.236.864.322 1.185zm.104.389-.104-.39-.58.156.104.387zm.039.147-.04-.147-.58.153.04.147zm0 0-.58.153zm-.303 1.145a1.2 1.2 0 0 0 .303-1.144l-.58.152a.6.6 0 0 1-.152.572zm-.022.066a.3.3 0 0 1 .028-.07l.006-.01-.002.003-.01.011-.43-.42a.8.8 0 0 0-.168.318zm-.013.152a.34.34 0 0 1 .013-.152l-.576-.168a.94.94 0 0 0-.026.438zm-.056-.062c-.001 0 .01.007.02.02a.2.2 0 0 1 .03.037c.012.022.01.03.006.005l-.589.118a.6.6 0 0 0 .064.179.4.4 0 0 0 .107.12zm.41.053c-.376 0-.449-.082-.41-.053l-.362.48c.098.073.313.173.773.173zm.199 0h-.198v.6h.197zm0 0v.6zm.475-.002c-.134.003-.285.003-.475.003l-.001.6c.188 0 .348 0 .492-.003zm.056-.002-.056.002.016.6.062-.003zm-.271-5.45c0 2.07 0 4.755-.018 5.744l.6.011c.019-.996.018-3.69.018-5.756zm0-.797v.797h.6v-.797zm-1.247-2.535c.332.052 1.247.539 1.247 2.535h.6c0-2.192-1.041-3.017-1.756-3.128zm-1.182-.089c.579.03.978.058 1.182.09l.091-.594c-.24-.037-.672-.066-1.243-.095zm-.673-.032.673.032.03-.599-.675-.032zm-.173-.008.173.008.028-.6-.173-.008zM9.58 6.02a1 1 0 0 0-.036.084l.562.21.007-.017zm-.029.079-.003.029.597.061.003-.029zm-.063-.487c.05.086.088.229.063.489l.598.057c.032-.334-.008-.616-.143-.848zm-.332-.425c.066.054.173.154.332.425l.518-.302c-.19-.325-.342-.483-.473-.59zm-.175-.12c.083.052.133.086.175.12l.377-.466a2 2 0 0 0-.235-.163zm-.07-.043.07.043.317-.509q-.032-.02-.075-.046zm-.001 0 .313-.512zm.001 0 .31-.513zm0 0 .311-.513zm-.001 0 .312-.513zm0 0 .312-.513zm.002.001.307-.515zm-.204-.126.201.124.313-.512-.19-.118zm-.036-.014.072.033.252-.544-.071-.034zm.324 1.788.102-2.045-.6-.03-.102 2.045zm-.038-.402q-.174.054-.339.097l.154.58c.115-.03.24-.065.365-.105zm.564-.22a3.5 3.5 0 0 1-.564.22l.18.572c.242-.076.481-.165.666-.263zm.099-.062q0-.001-.006.004l-.02.014-.073.043.282.53q.138-.075.217-.145zm.001-.002-.003.003.404.443.004-.003zm5.436 3.564c-.198.306-.396.584-.556.799l.48.358c.166-.222.373-.512.58-.832zm.588-1.056c-.154.344-.366.71-.588 1.056l.504.325c.231-.36.46-.754.632-1.135zm.227-.777c0 .156-.065.418-.227.777l.548.246c.172-.383.279-.739.279-1.023zm-1.12-1.12c.619 0 1.12.502 1.12 1.12h.6c0-.95-.77-1.72-1.72-1.72zm-1.119 1.12c0-.618.501-1.12 1.12-1.12v-.6c-.95 0-1.72.77-1.72 1.72zm.229.856c-.156-.355-.229-.645-.229-.856h-.6c0 .33.108.708.28 1.097zm.58 1.033a7 7 0 0 1-.58-1.033l-.55.241c.171.388.4.777.63 1.124zm.535.737a12 12 0 0 1-.534-.737l-.5.332c.2.3.4.569.562.775zm-4.923 8.083a15 15 0 0 1-.556.8l.481.358c.166-.222.373-.512.58-.832zm.589-1.055c-.154.343-.366.71-.589 1.055l.505.326a9 9 0 0 0 .631-1.135zm.226-.777c0 .156-.065.418-.226.777l.547.246c.172-.384.28-.74.28-1.023zm-1.119-1.12c.618 0 1.12.502 1.12 1.12h.6c0-.95-.77-1.72-1.72-1.72zm-1.12 1.12c0-.618.502-1.12 1.12-1.12v-.6c-.95 0-1.72.77-1.72 1.72zm.23.855c-.157-.354-.23-.645-.23-.855h-.6c0 .33.109.707.28 1.097zm.58 1.034a7 7 0 0 1-.58-1.034l-.55.242c.17.388.4.776.63 1.124zm.535.736a12 12 0 0 1-.535-.736l-.5.332c.2.3.4.568.563.775z"
    }, null, -1)
  ]));
}
const rr = { render: c8 }, i8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function d8(a, l) {
  return r(), n("svg", i8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.717 20.512a.75.75 0 0 0 1.097 0l3.5-3.75a.75.75 0 1 0-1.097-1.024l-2.201 2.36V4a.75.75 0 0 0-1.5 0v14.097l-2.202-2.359a.75.75 0 1 0-1.097 1.024zM17.283 3.488a.75.75 0 0 0-1.097 0l-3.5 3.75a.75.75 0 1 0 1.097 1.024l2.201-2.36V20a.75.75 0 0 0 1.5 0V5.903l2.202 2.359a.75.75 0 1 0 1.097-1.024z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ar = { render: d8 }, h8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function s8(a, l) {
  return r(), n("svg", h8, l[0] || (l[0] = [
    e("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.934 10.902 10.11 17l9.956-10"
    }, null, -1)
  ]));
}
const tr = { render: s8 }, v8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function u8(a, l) {
  return r(), n("svg", v8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.185 6.864a1.5 1.5 0 0 0 1.252.674H19a.5.5 0 0 1 .5.5V18a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h4.284zm.203-2.415 1.049 1.589H19a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4.554a1 1 0 0 1 .834.45m5.69 7.207a.75.75 0 0 0-1.5 0v1.986h-2a.75.75 0 1 0 0 1.5h2v2.014a.75.75 0 1 0 1.5 0v-2.014h2a.75.75 0 0 0 0-1.5h-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const or = { render: u8 }, m8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function w8(a, l) {
  return r(), n("svg", m8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M2.661 15.938V8.085h2.132v7.852zM13.162 11.845q0 1.965-1.085 3.029-1.08 1.063-3.04 1.063h-2.54V8.086h2.717q1.89 0 2.916.967 1.032.966 1.032 2.793m-2.203.075q0-1.08-.43-1.6-.424-.522-1.294-.522h-.617v4.4h.472q.967 0 1.418-.56.452-.563.452-1.718M18.984 8.085h2.374l-2.573 7.852h-2.497l-2.562-7.852h2.384l1.07 3.98q.332 1.326.364 1.848.039-.376.15-.94.114-.564.2-.887z"
    }, null, -1)
  ]));
}
const cr = { render: w8 }, f8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function z8(a, l) {
  return r(), n("svg", f8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.488 4.5h8a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5m-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2zM6.012 19.25v-13h-1.5v13c0 .966.783 1.75 1.75 1.75h10v-1.5h-10a.25.25 0 0 1-.25-.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ir = { render: z8 }, g8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
function p8(a, l) {
  return r(), n("svg", g8, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.506 4.19a9.355 9.355 0 1 0 1.854 14.012.75.75 0 0 0-1.123-.994 7.855 7.855 0 1 1 1.538-7.79.75.75 0 0 0 1.416-.493 9.36 9.36 0 0 0-3.685-4.735",
      "clip-rule": "evenodd"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.557 5.887a.75.75 0 0 0-.997.362l-1.23 2.637-2.637-1.23a.75.75 0 0 0-.635 1.36l3.317 1.547a.75.75 0 0 0 .997-.363l1.547-3.317a.75.75 0 0 0-.362-.996",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dr = { render: p8 }, M8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor"
};
function x8(a, l) {
  return r(), n("svg", M8, l[0] || (l[0] = [
    e("circle", {
      cx: "12",
      cy: "12",
      r: "8.25",
      "stroke-width": "1.5"
    }, null, -1)
  ]));
}
const hr = { render: x8 }, _8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--com-cell-bg-1)",
  stroke: "currentColor"
};
function $8(a, l) {
  return r(), n("svg", _8, l[0] || (l[0] = [
    e("circle", {
      cx: "12",
      cy: "12",
      r: "8.25",
      "stroke-width": "1.5"
    }, null, -1)
  ]));
}
const sr = { render: $8 }, C8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--com-cell-bg-2)",
  stroke: "currentColor"
};
function H8(a, l) {
  return r(), n("svg", C8, l[0] || (l[0] = [
    e("circle", {
      cx: "12",
      cy: "12",
      r: "8.25",
      "stroke-width": "1.5"
    }, null, -1)
  ]));
}
const vr = { render: H8 }, V8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--com-cell-bg-3)",
  stroke: "currentColor"
};
function I8(a, l) {
  return r(), n("svg", V8, l[0] || (l[0] = [
    e("circle", {
      cx: "12",
      cy: "12",
      r: "8.25",
      "stroke-width": "1.5"
    }, null, -1)
  ]));
}
const ur = { render: I8 };
export {
  el as AddIcon,
  A9 as AdminIcon,
  E9 as AlignCenterIcon,
  b9 as AlignLeftIcon,
  T9 as AlignRightIcon,
  jn as AltTextIcon,
  cl as AnnotateCreateIcon,
  b8 as AnnotateEditIcon,
  Je as AnnotateIcon,
  Be as ApplyTransformationToAllIcon,
  jl as ArchivedIcon,
  c9 as ArrowAnnotationIcon,
  _e as ArrowDownIcon,
  He as ArrowLeftIcon,
  Ce as ArrowRightIcon,
  ae as ArrowSimpleBottomIcon,
  ce as ArrowSimpleLeftIcon,
  oe as ArrowSimpleRightIcon,
  te as ArrowSimpleTopIcon,
  $e as ArrowTopIcon,
  rr as AtlasAnimalIcon,
  fn as AtlasHumanIcon,
  en as AuthorIcon,
  j9 as AxeOrientationIcon,
  I9 as BackLineIcon,
  T8 as BackspaceIcon,
  P9 as BoldIcon,
  P8 as BookmarkIcon,
  Xl as BugIcon,
  re as BuyIcon,
  k9 as CalendarEndIcon,
  Yn as CalendarIcon,
  ye as CalendarStartIcon,
  R8 as CaptionIcon,
  ol as CardsIcon,
  G9 as CasIcon,
  nn as Cases2EmptyIcon,
  Hl as Cases2Icon,
  Ee as CasesIcon,
  zl as Caution2Icon,
  dn as CautionIcon,
  Kl as CertificationIcon,
  Wl as ChangeContrastIcon,
  y9 as CheckCircleIcon,
  tr as CheckIcon,
  wl as CheckboxIcon,
  vr as CircleBlueIcon,
  ur as CircleGreenIcon,
  sr as CircleGreyIcon,
  hr as CircleIcon,
  O9 as CleanIcon,
  Xe as CollapseCloseIcon,
  Ye as CollapseOpenIcon,
  zn as ContractIcon,
  n9 as ContrastZoneIcon,
  Ul as CopyrightIcon,
  Gn as CoursesIcon,
  er as CropIcon,
  Ne as CrossIcon,
  Ue as CrossRef1Icon,
  cn as CrossRefIcon,
  U8 as DarkThemeIcon,
  O8 as DeleteAfterIcon,
  G8 as DeleteBeforeIcon,
  Z8 as DescriptionIcon,
  dl as DiscussIcon,
  qn as DisplayHoriz12Icon,
  Dn as DisplayHoriz21Icon,
  Fn as DisplayMode1Icon,
  N8 as DisplayMode2HorizontalIcon,
  x9 as DisplayMode2VerticalIcon,
  hl as DisplayMode3HorizontalIcon,
  kl as DisplayMode3VerticalIcon,
  q9 as DisplayMode4Icon,
  W8 as DisplayVert12Icon,
  r9 as DisplayVert21Icon,
  Jn as DogIcon,
  bn as DownloadIcon,
  pe as DownloadProgress2Icon,
  ir as DuplicateIcon,
  ie as EasyIcon,
  R9 as EllipseIcon,
  vl as EraserIcon,
  H9 as ExternalLinkIcon,
  Jl as FastIcon,
  yl as FaxIcon,
  Te as FeedbackIcon,
  Al as FileIcon,
  B8 as FilesIcon,
  Ge as Filter1Icon,
  Qe as FilterIcon,
  Ol as FlagIcon,
  or as FolderAddIcon,
  m9 as FolderIcon,
  Ve as FolderMoveIcon,
  Cl as FreeFormIcon,
  il as FullScreenExitIcon,
  Fe as FullScreenIcon,
  ml as GalleryIcon,
  We as GenerateIcon,
  sl as HQIcon,
  de as HelpIcon,
  Rn as HidePointsIcon,
  e9 as HistoryIcon,
  N9 as HomeIcon,
  d9 as HorizontalFlipIcon,
  ln as HumanIcon,
  X8 as HumanVinciIcon,
  cr as IDVIcon,
  X9 as ImageIcon,
  z9 as ImportIcon,
  g9 as IndicatorIcon,
  Tn as InformationIcon,
  rl as InstitutionIcon,
  Pe as IsolateIcon,
  D8 as IsolateMultiIcon,
  be as IssnIcon,
  fl as KeyboardIcon,
  Q8 as LabelV1Icon,
  Nn as Labelv3Icon,
  nr as LanguagesIcon,
  Se as LaserIcon,
  hn as Level1Icon,
  sn as Level2Icon,
  vn as Level3Icon,
  un as Level4Icon,
  mn as Level5Icon,
  Ln as LevelIcon,
  wn as LevelPlaceHolderIcon,
  u9 as LightThemeIcon,
  y8 as LinkIcon,
  lr as ListNumberIcon,
  _9 as ListViewIcon,
  Ie as LogOutIcon,
  he as LoopIcon,
  J9 as MIPIcon,
  Gl as MPRModeIcon,
  o9 as MailCancelIcon,
  Oe as MailIcon,
  pl as MaskIcon,
  D9 as MeasureAngleIcon,
  $n as MeasureIcon,
  Ll as MentionIcon,
  xl as MenuBurgerIcon,
  S9 as MergeIcon,
  ar as MobileDataIcon,
  kn as ModuleTabIcon,
  i9 as MoreiOsIcon,
  pn as NoColorIcon,
  Vl as NonOrthoIcon,
  tl as NotePatientIcon,
  bl as NotificationIcon,
  Rl as OppositeIcon,
  v9 as OrderIcon,
  Me as OrientationIcon,
  je as OrthoIcon,
  Bl as PanIcon,
  F9 as PauseIcon,
  le as PenIcon,
  B9 as PhoneIcon,
  an as PictureAllIcon,
  a9 as PictureEditIcon,
  Z9 as PinIcon,
  Cn as PinLocationIcon,
  gn as PointHideIcon,
  C9 as PointOnMapIcon,
  F8 as PointShowIcon,
  De as PresentationModeIcon,
  Zn as PresentationModeLineIcon,
  w9 as ProductIcon,
  Un as ProfileIcon,
  Vn as QRCodeIcon,
  E8 as QuickAnnotationCircleIcon,
  xe as QuickAnnotationTwoPointsIcon,
  ll as QuickLinksIcon,
  j8 as QuizModeIcon,
  al as RadiobuttonIcon,
  ne as ReceiptIcon,
  On as RedoIcon,
  Yl as RemunerationIcon,
  rn as RequestIcon,
  Ke as ResetAllIcon,
  L8 as ResetIcon,
  Ze as ResetSettingIcon,
  ke as ResponsiveIcon,
  Qn as RestoreIcon,
  Pn as RocketIcon,
  Mn as RotateIcon,
  Zl as RotateLeftIcon,
  Nl as RotatePlanIcon,
  dr as RotateRightIcon,
  ql as SaveCheckIcon,
  ge as SaveIcon,
  Pl as ScreenshotIcon,
  Ml as ScrollIcon,
  ul as SearchIcon,
  Il as Security1Icon,
  Q9 as SecurityIcon,
  Re as Select1Icon,
  An as SelectEmptyIcon,
  El as SelectFalseIcon,
  J8 as SelectIcon,
  Bn as SelectTrueIcon,
  Sn as SendIcon,
  _n as SettingsIcon,
  xn as SettingsV2Icon,
  k8 as SettingsV3Icon,
  A8 as ShareAddIcon,
  p9 as ShareAppleIcon,
  Y8 as ShareIcon,
  Tl as SharePeopleIcon,
  K9 as ShuffleIcon,
  h9 as SquareIcon,
  _l as SquareLockIcon,
  Y9 as StarsIcon,
  $9 as StatisticIcon,
  U9 as SubscriptionIcon,
  ue as TableAddBottomIcon,
  me as TableAddLeftIcon,
  se as TableAddRightIcon,
  ve as TableAddTopIcon,
  En as TableIcon,
  S8 as TargetIcon,
  Le as TextAlignCenterIcon,
  qe as TextAlignLeftIcon,
  Ae as TextAlignRightIcon,
  Kn as TextIcon,
  Sl as TextItalicIcon,
  $l as TextSizeIcon,
  M9 as TextStyleIcon,
  yn as TextUnderlineIcon,
  L9 as TimeIcon,
  t9 as TimerIcon,
  Wn as TransfersAppleIcon,
  Hn as TranslateIcon,
  K8 as TrashIcon,
  Dl as Tree1Icon,
  Fl as Tree2Icon,
  Xn as TreeStructureIcon,
  tn as TxtIcon,
  f9 as TxtNote2Icon,
  nl as UndoIcon,
  V9 as UnlinkIcon,
  Ql as UnlockV2Icon,
  W9 as UploadIcon,
  we as VerticalAlignBottomIcon,
  fe as VerticalAlignCenterIcon,
  ze as VerticalAlignTopIcon,
  l9 as VerticalFlipIcon,
  on as VideoPlayIcon,
  In as ViewZoneIcon,
  gl as WifiIcon,
  ee as WifiNoIcon,
  s9 as ZoomIcon
};
//# sourceMappingURL=stroke24.js.map
